export class TranslationObject {
  public static TRANSLATION_OBJECT = {
    //app-component.html
    SalesEmails: 'Sales-Emails',
    WasGibtsNeues: "Was gibt's neues?",
    NeustartTutorial: 'Neustart-Tutorial',
    HowToVideos: 'How-to Videos',
    Hilfe: 'Hilfe',
    Dokumentation: 'Dokumentation',
    MONASupport: 'MONA-Support',
    MONAAutomations: 'MONA-Automationen',
    Datatransfer: 'Datatransfer',
    Neu: 'Neu',
    //add-node-popover.html
    Dashboard: 'Dashboard',
    Löschen: 'Löschen',
    Abbrechen: 'Abbrechen',
    Ok: 'Ok',
    Confirm: 'Confirm',
    Bedingung: 'Bedingung',
    Ja: 'Ja',
    Nein: 'Nein',
    gleich: 'gleich',
    ungleich: 'ungleich',
    größergleich: 'größer gleich',
    kleinergleich: 'kleiner gleich',
    keineBedingung: 'keine Bedingung',
    Antwort: 'Antwort',
    keineAntworten: 'keine Antworten',
    Aktion: 'Aktion',
    keineAktion: 'keine Action',
    Verbindenmit: 'Verbinden mit',
    VerbindenMitMussGefülltsein: 'Verbinden mit muss gefüllt sein.',

    //assessment-test-information.html
    FrageFürDieBewertungHinzufügen: 'Frage für die Bewertung hinzufügen',
    GebenSieEinenTitelFürDieFeststellungsprüfungAn:
      'Geben Sie einen Titel für den Einstellungstest an',
    GebenSieEineBewertungsfrageEin: 'Geben Sie eine Bewertungsfrage ein',
    Frage: 'Frage',
    RichtigeAntwort: 'Richtige Antwort',
    FalscheAntwort: 'Falsche Antwort',
    WerkzeugeBearbeiten: 'Werkzeuge bearbeiten',
    TestGenerieren: 'Test generieren',
    UpdateTest: 'Test aktualisieren',

    //assessment-test.html
    AssessmentTestErstellen: 'Einstellungstest erstellen',
    AssessmentTitle: 'Titel',

    //new-assessment-test.html
    DerTitelExistiertBereitsErstellenSieEinenEinzigartigenTitel:
      'Der Titel existiert bereits. Erstellen Sie einen einzigartigen Titel.',

    //create-workflow.html
    BasicWorkflows: 'Grundlegende Workflows',
    UseWorkflow: 'Workflow verwenden',
    AdvancedWorkflows: 'Erweiterte Workflows',

    // Agent Dashboard Filtering
    Filters: 'Filter',
    DateRange: 'Datumsbereich',
    StartDate: 'Startdatum',
    EndDate: 'Enddatum',
    AgentFilters: 'Agent-Filter',
    Status: 'Status',
    SelectStatus: 'Status auswählen',
    All: 'Alle',
    Active: 'Aktiv',
    Inactive: 'Inaktiv',
    Type: 'Typ',
    SelectType: 'Typ auswählen',
    Chat: 'Chat',
    Email: 'E-Mail',
    Workflow: 'Workflow',
    Search: 'Suche',
    SearchAgents: 'Agenten suchen...',
    WorkflowFilters: 'Workflow-Filter',
    Paused: 'Pausiert',
    Error: 'Fehler',
    Communication: 'Kommunikation',
    Automation: 'Automatisierung',
    LogFilters: 'Log-Filter',
    SelectSeverity: 'Schweregrad auswählen',
    Success: 'Erfolg',
    Info: 'Info',
    Severity: 'Schweregrad',
    SearchLogs: 'Logs suchen...',
    ClearFilters: 'Filter löschen',
    FilteredData: 'Gefilterte Daten',
    FilteredAgents: 'Gefilterte Agenten',
    FilteredWorkflows: 'Gefilterte Workflows',
    FilteredLogs: 'Gefilterte Logs',
    FilteredAPIRequests: 'Gefilterte API-Anfragen',
    NoAgentsFound: 'Keine Agenten mit aktuellen Filtern gefunden',
    NoWorkflowsFound: 'Keine Workflows mit aktuellen Filtern gefunden',
    RecruitingWorkflows: 'Recruiting-Workflows',
    AgentWorkflows: 'Agent-Workflows',
    NoRecruitingWorkflowsFound: 'Keine Recruiting-Workflows gefunden',
    NoAgentWorkflowsFound: 'Keine Agent-Workflows gefunden',
    OnboardAgent: 'Onboarden',
    AgentOnboarded: 'Aktiv',
    NoLogsFound: 'Keine Logs mit aktuellen Filtern gefunden',
    NoAPIRequestsFound: 'Keine API-Anfragen mit aktuellen Filtern gefunden',
    ShowingFirst10: 'Zeige erste 10 Einträge',
    LastRun: 'Letzter Lauf',
    NeuenWorkflowErstellen: 'Neuen Workflow erstellen',
    EmailSendenBeiBewerbungseingang: 'Email senden bei Bewerbungseingang',
    sendeEineEmailWennBineBewerbungEingegangenIst:
      'sende eine Email, wenn eine Bewerbung eingegangen ist',
    EmailSendenWennBewerberImOnboardingIst:
      'Email senden wenn Bewerber im Onboarding ist',
    sendeEineEmailWennSichDerBewerbendeImOnboardingBefindet:
      'sende eine Email, wenn sich der Bewerbende im Onboarding befindet',
    ProfilAnKundeVerschicken: 'Profil an Kunde verschicken',
    sendeEineEmailMitDemBewerberprofilAnDenKunden:
      'sende eine Email mit dem Bewerberprofil an den Kunden',
    ProfilAnDisponentVerschicken: 'Profil an Disponent verschicken',
    sendeEineEmailMitDemBewerberprofilAnDenDisponenten:
      'sende eine Email mit dem Bewerberprofil an den Disponenten',
    MatcheBewerberAufKriteriumSendeNotizAnDisponenten:
      'Matche Bewerber auf Kriterium, sende Notiz an Disponenten',
    SchickeInformationenNachErfolgreichemInterview:
      'Schicke Informationen nach erfolgreichem Interview',
    schickeSpezifischeInformationenZumBewerberDamitManWeißWieEsWeitergeht:
      'schicke spezifische Informationen zum Bewerber, damit man weiß, wie es weitergeht.',
    SchickeDatenAnSchnittstellen: 'Schicke Daten an Schnittstellen',
    updateInformationenInATSSystem: 'update Informationen in ATS-System',
    fahreEchtzeitUpdatesInDeinemATSSystem:
      'fahre Echtzeit-Updates in deinem ATS-System',
    updateInformationenInERPSystem: 'update Informationen in ERP-System',
    fahreEchtzeitUpdatesInDeinemERPSystem:
      'fahre Echtzeit-Updates in deinem ERP-System',
    leiteWeiterZurWebseite: 'leite weiter zur Webseite:',
    leiteDiePersonWeiterZuEinerWebseite:
      'leite die Person weiter zu einer Webseite',
    ProfilErstellenNachBewerbungseingangOhneInterview:
      'Profil erstellen nach Bewerbungseingang ohne Interview',
    erstelleEinProfilOhneInterview: 'erstelle ein Profil ohne Interview',
    ProfilMatchenUndVersendenAKunden: 'Profil matchen und versenden an Kunden',
    ProfilMatchenUndVersendenAnDisponent:
      'Profil matchen und versenden an Disponent',
    matcheUndVersendeDasProfilAnDenKunden:
      'matche und versende das Profil an den Kunden',
    AnrufSendenWennBewerberInsichBeworbenHat:
      'Anruf senden wenn Bewerber/-in sich beworben hat',
    sendeEinenAnrufWennDerBewerbendeDasOnboardingBeendetHat:
      'sende einen Anruf, wenn der Bewerbende das Onboarding beendet hat',
    SMSSendenWennBewerberInSichBeworbenHat:
      'SMS senden wenn Bewerber/-in sich beworben hat',
    sendeEineSMSWennDerBewerbendeDasOnboardingErfolgreichBeendetHat:
      'sende eine SMS, wenn der Bewerbende das Onboarding erfolgreich beendet hat',
    SendeDankesmailAnBewerber: 'Sende Dankesmail an Bewerber',
    sendetDankesmailAnBewerberNachDemBewerbungsprozess:
      'sendet Dankesmail an Bewerber nach dem Bewerbungsprozess',
    SendeVertragskopieAnBewerber: 'Sende Vertragskopie an Bewerber',
    sendetEineKopieDesVertragsAnDenBewerber:
      'sendet eine Kopie des Vertrags an den Bewerber',
    TerminÜberCalendlyBuchen: 'Termin buchen (z.B. Calendly oder Bookings)',
    DerBewerberKannEinenTerminÜberCalendlyBeiIhnenBuchen:
      'Der Bewerber kann einen Termin über Calendly bei Ihnen buchen.',
    TerminÜberURLBuchen: 'Termin buchen über URL',
    TerminÜberURLBuchenBeschreibung:
      'Der Bewerber kann einen Termin über URL bei Ihnen buchen.',
    InValidURL: 'Bitte geben Sie eine gültige URL ein.',

    zumZeitpunkt: 'zum Zeitpunkt',
    vierhDanach: '4h danach',
    vierundzwanzighDanach: '24h danach',
    achtundvierzighDanach: '48h danach',
    benutzerdefinierteZeit: 'benutzerdefinierte Zeit',
    BenutzerdefinierteZeit: 'Benutzerdefinierte Zeit',
    nichtWiederholen: 'nicht wiederholen',
    wiederholen: 'Wiederholen',
    every: 'jede',
    after: 'nach',
    PleaseEnteraNumberFrom1to30: 'Bitte geben Sie eine Zahl von 1 bis 30 ein.',
    täglich: 'täglich',
    wöchentlich: 'wöchentlich',
    monatlich: 'monatlich',
    mon: 'Mon',
    di: 'Di',
    mi: 'Mi',
    do: 'Do',
    fr: 'Fr',
    sa: 'Sa',
    so: 'So',
    Bewerberprofil: 'Bewerberprofil',
    BewerberprofilFürKunden: 'Bewerberprofil für Kunden',
    BewerberprofilFürDisponentUndMatching: 'Bewerberprofil für Disponent und Matching',
    Vertragsdokumente: 'Vertragsdokumente',
    attachments: 'Anhänge',
    dynamicAttachments: 'Dynamische Anhänge',
    API: 'API',
    Flowchartknotenpunkt: 'Flowchart-Knotenpunkt',
    PromptWorkflow: 'Prompt-Workflow',
    agentWorkflow: 'Agent-Workflow',
    OnboardingBeendet: 'Onboarding beendet',
    WiederkehrenderWorkflow: 'Wiederkehrender Workflow',
    InterviewBeendet: 'Interview beendet',
    VertragUnterschrieben: 'Vertrag unterschrieben',
    mandantenMatchingEinzeln: 'Mandanten-Matching einzeln',
    geoMappingEinzeln: 'Geo-Mapping einzeln',
    geoMappingMehrfach: 'Geo-Mapping mehrfach',
    alleAusführen: 'alle ausführen',
    KriteriumErfüllt: 'Kriterium erfüllt',
    mehrereKriterienErfüllt: 'mehrere Kriterien erfüllt',
    Disponent: 'Disponent',
    Kunde: 'Kunde',

    //dashbaord.html (workflow dashboard)
    Rang: 'Rang',
    Workflows: 'Workflows',
    WorkflowTutorial: "Workflow Tutorial",
    RestartTutorial: "Restart Tutorial",
    TutorialWelcome: "Welcome to Workflow Builder",
    TutorialAddTrigger: "Add a Trigger Block",
    TutorialConfigureTrigger: "Configure Your Trigger",
    TutorialAddAction: "Add an Action Block",
    RecruitingMetrics: "Recruiting Metrics",
    CandidatesProcessed: "Candidates Processed",
    JobsPosted: "Jobs Posted",
    InterviewsScheduled: "Interviews Scheduled",
    PlacementsCompleted: "Placements Completed",
    ClientInteractions: "Client Interactions",
    ActiveJobOpenings: "Active Job Openings",
    ResponseRate: "Response Rate",
    QuickActions: "Quick Actions",
    AgentBuilder: "Agent Builder",
    WorkflowBuilder: "Workflow Builder",
    AgentChat: "Agent Chat",
    TutorialConfigureAction: "Configure Your Action",
    TutorialSaveWorkflow: "Save Your Workflow",
    SkipTutorial: "Skip Tutorial",
    NextStep: "Next",
    PreviousStep: "Previous",
    FinishTutorial: "Finish",
    // Agent workflow translations
    AgentWorkflowDesign: "Agent Workflow Design",
    ConnectAgents: "Connect Agents",
    SelectAgents: "Select Your Agents",
    AddAgent: "Add Agent",
    TestRun: "Test Run",
    PrePromptingConfiguration: "Pre-prompting Configuration",
    ReflectionMode: "Reflection Mode",
    ReasoningMode: "Reasoning Mode",
    SafetyMode: "Safety Mode",
    HumanInTheLoop: "Human in the Loop",
    RequireHumanConfirmation: "Require human confirmation for critical decisions",
    MonariAgent: "Monari Agent",
    CustomAgent: "Custom Agent",
    ConversationalAI: "Conversational AI Agent",
    TaskSpecificAgent: "Task-specific Agent",
    AgentConnections: "Agent Connections",
    PrePromptMessage: "Pre-prompt Message",
    TestAgent: "Test Agent",
    CriticalDecisionConfirmation: "Critical Decision Confirmation",
    Name: 'Name',
    Inhalt: 'Inhalt',
    Medium: 'Medium',
    Zyklus: 'Zyklus',
    zumEreigniszeitpunkt: 'zum Ereigniszeitpunkt',
    nach4Stunden: 'nach 4 Stunden zw. 09:00-17:00 lokale Zeit',
    nach24Stunden: 'nach 24 Stunden zw. 09:00-17:00 lokale Zeit',
    nach48Stunden: 'nach 48 Stunden zw. 09:00-17:00 lokale Zeit',
    jederzeit: 'jederzeit',
    bewerberContingent: 'Bewerber-Contingent im Jahr',
    ZeitProBewerber: 'Zeit pro Bewerber',
    inMin: 'in min',
    StundenlohnDisponentEuro: 'Stundenlohn Disponent (€)',
    NoDocumentAvailable: 'Kein Dokument verfügbar',
    FileWithNoWorkflows: 'Datei enthält keine Workflows',

    //workflow-contact-modal.html
    AktionAuswählen: 'Aktion auswählen',
    BewerberAusgewählt: 'Bewerber ausgewählt',
    WorkflowAnwenden: 'Workflow anwenden',
    BestehendeWorkflowDatenWerdenÜberschrieben: 'Bestehende Workflow-Daten werden überschrieben',
    NeuKontaktieren: 'Neu kontaktieren',
    BewerberDuplizierenUndNeuZuordnen: 'Bewerber duplizieren und neu zuordnen',
    WorkflowAuswählen: 'Workflow auswählen',
    StellenausschreibungAuswählen: 'Stellenausschreibung auswählen',
    InterviewAuswählen: 'Interview auswählen',
    Ausführen: 'Ausführen',
    AktionAusführen: 'Aktion ausführen',
    DerAusgewählteWorkflowWirdAufAlleBewerberAngewendet: 'Der ausgewählte Workflow wird auf alle {{count}} Bewerber angewendet. Bestehende Workflow-Daten werden überschrieben.',
    FürJedenDerBewerberWirdEineKopieErstellt: 'Für jeden der {{count}} Bewerber wird eine Kopie erstellt und dem ausgewählten Interview zugeordnet. Die Kommunikationshistorie wird zurückgesetzt.',
    BitteWählenSieAlleErforderlichenOptionenAus: 'Bitte wählen Sie alle erforderlichen Optionen aus.',
    EinzellkontaktierungInfo: 'Hier können einzelne Bewerber kontaktiert werden. Bewerber können nur kontaktiert werden, wenn Vorname, Nachname, Handynummer, E-Mail und das Interview gefüllt sind.',

    //edit-workflow.html
    WorkflowEdit: 'Workflow bearbeiten',
    UntergeordneteWorkflows: 'Untergeordnete Workflows',
    UntergeordneteMatchingOptionen: 'Untergeordnete Matching-Optionen',
    WorkflowName: 'Workflow Name',
    EventTypes: 'Welche Ereignistypen gelten für diesen Workflow?',
    bitteAuswählen: 'Bitte auswählen',
    BeschreibeDenProzess: 'Beschreibe den Prozess...',
    DateAndTime: 'Datum und Uhrzeit:',
    Repeat: 'Wiederholen:',
    Every: 'Jede:',
    days: 'Tage',
    weeks: 'Wochen',
    months: 'Monate',
    checkLogsForTranslation: 'Übersetze Antworten',
    End: 'Ende:',
    repeatations: 'Wiederholungen',
    WennDasPassiert: 'Wenn das passiert',
    StatusDesWorkflow: 'Status des Workflows',
    ChosenWorkflows: 'Gewählte Workflows',
    dannSchickeDiesesMedium: 'dann schicke dieses Medium',
    Informationen: 'Informationen',
    InformationenAnpassen: 'Informationen anpassen',
    EMailTextAnpassen: 'E-Mail-Text anpassen',
    Betreff: 'Betreff',
    Nachricht: 'Nachricht',
    Anhänge: 'Anhänge',
    BetreffFallsLleerDannWirdDerBetreffPassendDynamischGesetzt:
      'Betreff (falls leer, dann wird der Betreff passend dynamisch gesetzt)',
    DateiWählen: 'Datei wählen',
    dynamischeAnhänge: 'Dynamische Anhänge',
    NachrichtOptional: 'Nachricht (optional)',
    dynamischenAnhangAuswählen: 'Dynamischen Anhang auswählen',
    VorlageWählenOptional: 'Vorlage wählen (optional)',
    DokumentHochladenNurDOCX: 'Dokument hochladen (nur .docx)',
    dynamischeAPIDaten: 'Dynamische API-Daten',
    anDieseEmpfänger: 'An diese Empfänger',
    EMailAdresseDesEmpfängersUndAufPLUSklicken:
      'E-Mail Adresse des Empfängers und auf PLUS klicken',
    Landesvorwahl: 'Landesvorwahl',
    Telefonnummer: 'Telefonnummer',
    DieEMailExistiertBereits: 'Die E-Mail existiert bereits!',
    DieTelefonnummerExistiertBereits: 'Die Telefonnummer existiert bereits!',
    KalenderLink: 'Kalender Link',
    KalenderLinkEinfügen: 'Kalender Link einfügen',
    Speichern: 'Speichern',
    CustomizeReminderEmail: 'E-Mail Text',
    CustomizeReminderSMS: 'SMS Text',
    Prompt: 'Prompt',
    Agent: 'Agent',
    BewerberprofilFürDirektvertrieb: 'Bewerberprofil für Direktvertrieb',
    duplicateWorkflowText: 'Workflow-Name existiert bereits.',
    SchwellenwertOderLevel: 'Schwellenwert oder Level',

    //contacting-text.html
    EMailBetreff: 'E-Mail Betreff',
    HierKannDerStandardtextDesEMailBetreffsEingegebenWerden:
      'Hier kann der Standardtext des E-Mail Betreffs eingegeben werden.',
    EMailText: 'E-Mail Text',
    Vorname: 'Vorname',
    Nachname: 'Nachname',
    Firmenname: 'Firmenname',
    BrandingEinrichten: 'Branding einrichten',
    RichtenSieIhrUnternehmensbrandingEin: 'Richten Sie Ihr Unternehmensbranding ein',
    GebenSieDenNamenIhresUnternehmensEin: 'Geben Sie den Namen Ihres Unternehmens ein',
    Unternehmensname: 'Unternehmensname',
    Firmenlogo: 'Firmenlogo',
    LadenSieIhrUnternehmenslogoHoch: 'Laden Sie Ihr Unternehmenslogo hoch',
    LogoÄndern: 'Logo ändern',
    LogoHochladen: 'Logo hochladen',
    BrandingGespeichert: 'Branding gespeichert',
    FehlerBeimSpeichern: 'Fehler beim Speichern',
    // Applicant Inbox Modal
    YourApplicantInboxAddress: 'Ihre Bewerber-Postfach-Adresse',
    GenerateYourDedicatedApplicantInbox: 'Generieren Sie Ihr dediziertes Bewerber-Postfach',
    WelcomeToMONAAI: 'Willkommen bei MONA AI!',
    GenerateYourDedicatedApplicantInboxAddress: 'Generieren Sie Ihre dedizierte Bewerber-Postfach-Adresse. Verwenden Sie sie, um Lebensläufe und Bewerbungen von Kandidaten an diese Adresse weiterzuleiten.',
    GenerateApplicantInboxEmail: 'Bewerber-Postfach-E-Mail generieren',
    GenerationStarted: 'Generierung gestartet',
    TheEmailAddressWillBeSaved: 'Die E-Mail-Adresse wird automatisch in Ihren Branding-Einstellungen gespeichert.',
    YourApplicantInbox: 'Ihr Bewerber-Postfach',
    UseThisAddressToReceiveApplications: 'Verwenden Sie diese Adresse, um Bewerbungen weiterzuleiten',
    Copy: 'Kopieren',
    GeneratingInboxEmail: 'Postfach-E-Mail wird generiert...',
    ApplicantInboxEmailGeneratedSuccessfully: 'Bewerber-Postfach-E-Mail erfolgreich generiert.',
    TimedOutWaitingForInboxEmail: 'Zeitüberschreitung beim Warten auf die Postfach-E-Mail. Bitte versuchen Sie es in einem Moment erneut.',
    FailedToStartGeneration: 'Fehler beim Starten der Generierung. Bitte versuchen Sie es erneut.',
    EmailCopiedToClipboard: 'E-Mail in die Zwischenablage kopiert',
    // Onboarding Missions Modal
    BrandingFirmennameLogo: 'Branding: Firmenname & Logo',
    FirmennameEintragenUndLogoHochladen: 'Firmenname eintragen und Logo hochladen. Der Firmenname wird später als Absender für E-Mails und SMS genutzt.',
    StellenanzeigeAusTemplateErstellen: 'Stellenanzeige aus Template erstellen',
    WaehleEinTemplateUndErstelleEineStellenanzeige: 'Wähle ein Template und erstelle eine Stellenanzeige.',
    BewerberInboxEinrichten: 'Bewerber Inbox einrichten',
    ErzeugeDeineBewerberPostfachAdresse: 'Erzeuge deine Bewerber-Postfach-Adresse.',
    Link: 'Link',
    HierKannDerStandardtextZurEMailKontaktierungEingegebenWerden:
      'Hier kann der Standardtext zur E-Mail-Kontaktierung eingegeben werden.',
    SMSText: 'SMS Text',
    HierKannDerStandardtextZurSMSKontaktierungEingegebenWerden:
      'Hier kann der Standardtext zur SMS-Kontaktierung eingegeben werden.',
    anrufMP3: 'Anruf MP3',
    DiesesMP3WirdAlsAnrufVerwendet: 'Dieses MP3 wird als Anruf verwendet',
    MP3WirdHochgeladen: 'MP3 wird hochgeladen...',
    EigeneMP3BereitZumAnhoeren: '🎵 Eigene MP3 bereit zum Anhören',
    StandardAudioWirdVerwendet: '🔊 Standard-Audio wird verwendet',
    MP3Hochladen: 'MP3 hochladen',

    //conditional-flowchart.html
    conditionalFlowchart: 'Flowchart',
    //dashbaord.html (workflow dashboard)
    //contract-information.html
    Lesen: 'Lesen',
    Messages: 'Fragen',
    Variables: 'Variablen',
    NeueNachrichtHinzufügen: 'Neue Nachricht hinzufügen',
    neueNachricht: 'neue Nachricht',
    VariabelMatching: 'Variabel Matching',
    VariableAusVertrag: 'Variable aus Vertrag',
    Konfigurieren: 'Konfigurieren',

    //contracts.html
    VertragHinzufügen: 'Vertrag hinzufügen',
    Vetragsname: 'Vertragsname',
    ErstelltAm: 'Erstellt am',

    //new-contract.html
    WähleEineDatei: 'Wähle eine Datei',
    aufCVAnalyseSchalten: 'auf CV Analyse schalten',
    aufVertragsAnalyseSchalten: 'auf Vertrags Analyse schalten',
    DragAndDropDateiHier: 'Drag and drop Datei hier',
    Erklärungen: 'Erklärungen',

    //dashboard.html
    MONADashboard: 'MONA-Dashboard',
    logout: 'Logout',
    liveHilfeBeantragen: 'Live Hilfe beantragen',
    liveHilfeNachricht: 'Brauchen Sie Hilfe beim Einrichten Ihrer Agents? Buchen Sie einen Call oder schreiben Sie uns eine E-Mail.',
    callBuchen: 'Call buchen',
    emailSenden: 'E-Mail senden',
    abbrechen: 'Abbrechen',
    aktuellerMonat: 'aktueller Monat',
    BewerberGesamt: 'Bewerber gesamt:',
    ZeitDisponent: 'Prozesszeit jetzt übernommen durch MONA:',
    Minuten: 'Minuten',
    ZeitMONA: 'Zeit MONA:',
    ZeitGespart: 'Zeit gespart:',
    GeldDisponent: 'Prozesskosten pro Stunde vor MONA:',
    GeldGespart: 'Geld gespart:',
    loadingText: 'Wird geladen...',
    Bewerber: 'Bewerber',
    übergeordnet: 'übergeordnet',
    untergeordnet: 'untergeordnet',
    MaxLimit: 'Max Limit',
    BewerberDoppelpunkt: 'Bewerber:',
    ÜbrigeBewerber: 'Übrige Bewerber',
    ÜbrigeBewerberDoppelpunkt: 'Übrige Bewerber:',
    RemainingContigentsPerMonth: 'Restkontingente pro Monat',
    NoDataAvailable: 'Keine Daten verfügbar',
    FinalRemainingContigents: 'Letzte verbleibende Kontingente',
    Month: 'Monat',
    RemainingNumberOfApplicants: 'Verbleibende Anzahl der Bewerber',
    ÜbersichtDerBewerber: 'Übersicht der Bewerber',
    Tage: 'Tage',
    Gesamt: 'Gesamt',
    SiebenTage: '7 Tage',
    VierzehnTage: '14 Tage',
    DreißigTage: '30 Tage',
    EmailSMSAnrufe: 'Email/SMS/Anrufe',
    bisherVerschickt: 'bisher verschickt',
    maximalVerfügbar: 'maximal verfügbar',
    WorkflowsInNutzung: 'Workflows in Nutzung',
    möglicheWorkflows: 'mögliche Workflows',

    //edit-message-modal.html
    NachrichtBearbeiten: 'Nachricht bearbeiten',
    CreateNewNode: 'Neuen Knoten erstellen',
    Antwortmöglichkeiten: 'Antwortmöglichkeiten',
    Texteingabe: 'Texteingabe',
    InfoNachricht: 'Info Nachricht',
    JaNeinFrage: 'Ja/Nein Frage',
    MultiAntwort: 'Multi Antwort',
    SingleAntwort: 'Single Antwort',
    nurSpracheingabe: 'nur Spracheingabe',
    DateiHochladen: 'Datei hochladen',
    KalenderEingabe: 'Kalendereingabe',
    SingleDate: 'Einzelnes datum',
    RangeDate: 'Reichweite',
    SingleChoice: 'Single Choice',
    DieAntwortExistiertBereits: 'Die Antwort existiert bereits.',
    TerminWorkflow: 'Termin-Workflow',
    SelectATerminWorkflow: 'Wählen Sie einen Termin-Workflow',
    HelpSetTerminWorkflow: 'Bitte wählen Sie einen Termin-Workflow aus.',
    BeingTranslated: 'Wird übersetzt...',

    //help.html
    SendenSieUnsIhreFragenKommentareUndIdeen:
      'Senden Sie uns ihre Fragen, Kommentare und Ideen',
    damitWirStetigDieMONAEngineVerbessernKönnen:
      ' damit wir stetig die MONA Engine verbessern können.',
    SupportGesprächVereinbaren: 'Support gespräch vereinbaren',
    SupportTeam: 'Support-Team',
    TelefonSupport: 'Telefon-Support:',
    EMailSupport: 'E-Mail-Support:',
    IhrName: 'Ihr Name',
    IhreEMailAdresse: 'Ihre E-Mail-Adresse',
    IhreNachricht: 'Ihre Nachricht',
    KategorieOptional: 'Kategorie (optional)',
    Stellenanzeigen: 'Stellenanzeigen',
    Kandidaten: 'Kandidaten',
    Einstellungen: 'Einstellungen',
    TypOptional: 'Typ (optional)',
    FehlerMelden: 'Fehler melden',
    FunktionVorschlagen: 'Funktion vorschlagen',
    Sonstiges: 'Sonstiges',
    IhreTelefonnummerOptional: 'Ihre Telefonnummer (optional)',
    OffeneTickets: 'Offene Tickets',
    User: 'User',
    EMail: 'E-Mail:',
    NachrichtDoppelpunkt: 'Nachricht:',

    //create-custom-video.html
    Generieren: 'Generieren',
    Text: 'Text',
    TextDeutsch: 'Text Deutsch',
    Avatar: 'Avatar',
    Sprache: 'Sprache',

    //create-howto.html
    Titel: 'Titel',
    GehörtZu: 'Gehört zu',
    Beschreibung: 'Beschreibung',
    Erklärung: 'Erklärung',
    HierErklärenWirDirWieDuEineStellenanzeigeErstellenKannst:
      'Hier erklären wir dir, wie du eine Stellenanzeige erstellen kannst.',
    UmEineStellenanzeigeZuErstellenBefolgeBitteDieFolgenenSchritteSchritt1:
      'Um eine Stellenanzeige zu erstellen, befolge bitte die folgenden Schritte. Schritt 1:...',

    //howto.html
    WillkommenBeiDenHowTos: "Willkommen bei den How-To's",
    HierFindestDuAllerleiNützlicheInformationenÜberDieMONAPlattform:
      'Hier findest du allerlei nützliche Informationen über die MONA Plattform.',
    HerzlichWillkommen: 'Herzlich Willkommen',
    NutzeGerneDieSuchfunktionObenOderKlickeDichDurchDasMenüLinksWirFreuenUnsDirHelfenZuKönnen:
      'Nutze gerne die Suchfunktion oben oder klicke dich durch das Menü links. Wir freuen uns dir helfen zu können.',
    HowToHinzufügen: 'How-To hinzufügen',
    VideoGenerieren: 'Video generieren',
    Suche: 'Suche',
    Kommunikation: 'Kommunikation',
    Teamverwaltung: 'Teamverwaltung',

    //analytics.html
    analytics: 'Analytics',

    //flowchart-graph-modal-module.html
    Fertig: 'Fertig',

    //conversations.html
    conversations: 'Conversations',

    //insights.html
    Insights: 'Insights',

    //interviews.html
    interviews: 'Interviews',

    //performance.html
    performance: 'Performance',

    //insights -> reporting.html
    Reporting: 'Reporting',
    Rahmenbedingungen: 'Rahmenbedingungen',
    Intervall: 'Intervall',
    ZeitraumWählen: 'Zeitraum wählen',
    Täglich: 'Täglich',
    Zeitraum: 'Zeitraum',
    Monatlich: 'Monatlich',
    Quartalsweise: 'Quartalsweise',
    Jährlich: 'Jährlich',
    required: '*required',
    von: 'von',
    bis: 'bis',
    Start: 'Start',
    Ende: 'Ende',
    Heute: 'Heute',
    StelleAuswählen: 'Interview auswählen',
    Kriteriumauswaehlen: 'Kriterium auswählen',
    Reset: 'Reset',
    Suchen: 'Suchen',
    KommunikationsmediumWählen: 'Kommunikationsmedium wählen',
    PhaseDesGesprächs: 'Phase des Gesprächs',
    Weiterverarbeitung: 'Weiterverarbeitung',
    Anrufe: 'Anrufe',
    EMails: 'E-Mails',
    SMS: 'SMS',
    WhatsApp: 'WhatsApp',
    Interviews: 'Interviews',
    Einstufungstests: 'Einstufungstests',
    Lebensläufe: 'Lebensläufe',
    Profile: 'Profile',
    Analysen: 'Analysen',
    NullErgebnisse: '0 Ergebnisse',
    Ergebnisse: 'Ergebnisse',
    ExportExcel: 'Export Excel',
    UnternehmenGefunden: 'Unternehmen gefunden',
    durchgeführteMatches: 'durchgeführte Matches',
    positiveMatches: 'positive Matches',
    Matches50: 'Matches >= 50%',
    negativeMatches: 'negative Matches',
    Dubletten: 'Dubletten',
    IndexUnternehmensanalyse: 'Index Unternehmensanalyse',
    Unternehmenswebsite: 'Unternehmenswebsite',
    GoogleMaps: 'Google Maps',
    KeineUnternehmenGefunden: 'Keine Unternehmen gefunden',
    SucheNachUnternehmen: 'Suche nach Unternehmen',
    POWERBI: 'POWER BI',
    ReportingTabelle: 'Reporting Tabelle',
    ExportBewerberInterviews: 'Export Bewerber & Interviews',
    Stellenanzeige: 'Stellenanzeige',
    Datum: 'Datum',
    Uhrzeit: 'Uhrzeit',
    Dauer: 'Dauer',
    Antworten: 'Antworten',
    Lebenslauf: 'Lebenslauf',
    Terminlink: 'Terminlink',
    Browser: 'Browser',
    ReportingGraph: 'Reporting Graph',
    AuswertungDerBewerberdaten: 'Auswertung der Bewerberdaten',
    ExportToPDF: 'Export to PDF',
    InterviewStreetDataAnalysis: 'Interview Street Data Analysis',
    ConversionGraph: 'Conversion Graph',
    AuswertungDerConversionRate: 'Auswertung der Conversion-Rate',
    AnzahlDatensätze: '1) Anzahl Datensätze',
    BewerberValide: '2) Bewerber valide',
    BewerberMitDokumenten: '3) Bewerber mit Dokumenten',
    BewerberMitInterview: '4) Bewerber mit Interview',
    BewerberMitTerminoption: '5) Bewerber mit Terminoption',
    BewerberMitProfilErstellt: '6) Bewerber mit Profil erstellt',
    BewerberMitProfilVersandt: '7) Bewerber mit Profil versandt',
    BewerberMitProfilMatches: '7) Suchergebnisse zu Bewerbern',
    BewerberMitProfilInteresse: '8) Bewerber mit Profil Interesse',
    BewerberMitMatches: '9) Positive Matchings',
    BewerberMitNeutralMatchings: '8) neutrale Matchings',
    geschätztesPotentialProfilvertrieb:
      '10) geschätztes Potential Profilvertrieb',
    geschätzteErfolgsquoteVermittlung:
      '11) geschätzte Erfolgsquote Vermittlung',
    geschätzteErfolgsquoteAUEV: '12) geschätzte Erfolgsquote AUEV',
    Bewerberanzahl: 'Bewerberanzahl',
    Valide: 'Valide',
    InterviewGestartet: 'Interview gestartet',
    BewerberMitProfil: 'Bewerber mit Profil',
    JobtitelUnbekannt: 'Jobtitel unbekannt',
    StandortAuswählen: 'Standort auswählen',
    OhneStandort: 'Ohne Standort',

    WorkflowEmailDirekt: 'Email Direkt',
    WorkflowEmailNach4h: 'Email nach 4h',
    WorkflowEmailNach24h: 'Email nach 24h',
    WorkflowEmailNach48h: 'Email nach 48h',
    WorkflowSMSDirekt: 'SMS Direkt',
    WorkflowSMSNach4h: 'SMS nach 4h',
    WorkflowSMSNach24h: 'SMS nach 24h',
    WorkflowSMSNach48h: 'SMS nach 48h',
    WorkflowAnrufDirekt: 'Anruf Direkt',
    WorkflowAnruf4h: 'Anruf 4h',
    WorkflowAnruf24h: 'Anruf 24h',
    WorkflowAnruf48h: 'Anruf 48h',
    WorkflowTerminbuchungMitSMSUndEmail: 'Terminbuchung mit SMS und Email',
    WorkflowTerminbuchungDirektImInterview: 'Terminbuchung direkt im Interview',
    WorkflowEmailAnDisponentNachInterviewEnde: 'Email an Disponent nach Interview Ende',
    WorkflowEmailAnBewerberNachInterviewEnde: 'Email an Bewerber nach Interview Ende',
    WorkflowProfilerstellung: 'Profilerstellung',
    WorkflowPrematchingGegenIndex: 'Prematching gegen Index',
    WorkflowBewerberprofilDirektvertrieb: 'Bewerberprofil Direktvertrieb',
    WorkflowCustom: 'Benutzerdefinierter Workflow',

    WorkflowEmailDirektDescription: 'Sende eine Einladungs EMail an den Bewerber',
    WorkflowEmailReminderDescription: 'Sende eine Reminder EMail nach {time} an den Bewerber',
    WorkflowSMSDirektDescription: 'Sende eine Einladungs SMS an den Bewerber',
    WorkflowSMSReminderDescription: 'Sende eine Reminder SMS nach {time} an den Bewerber',
    WorkflowAnrufDirektDescription: 'Rufe den Bewerber direkt an',
    WorkflowAnrufReminderDescription: 'Sende einen Reminder Anruf nach {time} an den Bewerber',
    WorkflowTerminbuchungMitSMSUndEmailDescription: 'Der Bewerber bekommt eine Mail und SMS um sich einen Termin zu buchen',
    WorkflowTerminbuchungDirektImInterviewDescription: 'Der Bewerber kann sich direkt im Interview einen Termin buchen',
    WorkflowEmailAnDisponentNachInterviewEndeDescription: 'Schicke nach dem Interview die Logs an den Disponenten',
    WorkflowEmailAnBewerberNachInterviewEndeDescription: 'Sende eine Dankes-Email an den Bewerber',
    WorkflowProfilerstellungDescription: 'Erstelle ein Profil des Bewerbers',
    WorkflowPrematchingGegenIndexDescription: 'Lasse den Bewerber gegen offene Stellen in Index matchen',
    WorkflowBewerberprofilDirektvertriebDescription: 'Sende das Bewerberprofil automatisch an den Kunden',
    WorkflowCustomDescription: 'Erstelle einen benutzerdefinierten Workflow',
    DokumentNameFestelegen: 'Dokumentname',

    WorkflowEmailSubjectNachBewerbungseingang: 'nach Eingang der Bewerbung versenden',
    WorkflowTerminbuchungBetreff: 'Buche jetzt deinen Kennenlern-Termin',
    WorkflowTerminbuchungEmailText: 'Hallo $firstname,\n\ndu hast dich erfolgreich für den Job bei $companyname beworben.\n\nAnbei bekommst du einen Link um dir einen Kennenlern-Termin zu buchen.',
    WorkflowTerminbuchungSMSText: 'Hallo $firstname,\n\ndu hast dich erfolgreich für den Job bei $companyname beworben.\n\nAnbei bekommst du einen Link um dir einen Kennenlern-Termin zu buchen.',
    WorkflowInterviewFinishedEmailSubject: 'Neues Interview abgeschlossen',
    WorkflowThanksToApplicantEmailSubject: 'Vielen Dank für das Interview',
    WorkflowBewerberprofilEmailSubject: 'Bewerberprofil',
    WorkflowBewerberMitMatchesEmailSubject: 'Bewerber mit Matches',

    WorkflowDocumentNameBewerberprofil: 'Bewerberprofil',
    WorkflowDocumentNamePrematching: 'Prematching_Profil',
    Erstkontakt: 'Erstkontakt',
    Zweitkontakt: 'Zweitkontakt',
    Drittkontakt: 'Drittkontakt',
    Terminbuchung: 'Terminbuchung',

    //integrations.html
    IndeedEMailIntegration: 'Indeed E-Mail Integration',
    DieEMailIntegrationErmöglichtEsIhnenDieBewerberVonIndeedMitCVParsingFunktionInMONAEinlesenZuLassen:
      'Die E-Mail Integration ermöglicht es Ihnen die Bewerber von Indeed mit CV-Parsing Funktion in MONA einlesen zu lassen.',
    FürEineIntegrationKontaktierenSiesupportmonaaideUndWirMeldenUnsInKürze:
      'Für eine Integration, kontaktieren Sie support@mona-ai.de und wir melden uns in Kürze.',
    Indeed: 'Indeed',
    Talent360EMailIntegration: 'Talent360 E-Mail Integration',
    Talent360: 'Talent360',
    ZvooveRecruit: 'Zvoove Recruit',
    Aktivieren: 'Aktivieren',
    ZvooveBewerberAPIKey: 'Zvoove Bewerber API Key',
    ZvooveBewerberAPILink: 'Zvoove Bewerber API Link',
    ZvooveStellenAPIKey: 'Zvoove Stellen API Key',
    ZvooveStellenAPILink: 'Zvoove Stellen API Link',
    MONALoginUsername: 'MONA-Login Username',
    MONALoginPasswort: 'MONA-Login Passwort',
    KIMatching: 'KI-Matching',
    exklusiv: 'exklusiv',
    inklusiv: 'inklusiv',
    inklusivMitFallback: 'inklusiv mit Fallback',
    Zvoove: 'Zvoove',
    Aktiviert: 'Aktiviert',
    nichtAktiv: 'nicht aktiv',
    Talention: 'Talention',
    TalentionClientID: 'Talention Client-ID',
    TalentionClientSecret: 'Talention Client-Secret',
    TalentionAccountID: 'Talention Account-ID',
    TalentionIntegrationsweg: 'Talention Integrationsweg',
    talentionCreateApplicantJobId: 'Job ID um neue Bewerber anzulegen',
    softgardenClientId: 'Geben Sie Ihre Softgarden Client ID ein.',
    softgardenClientSecret: 'Geben Sie Ihr Softgarden Client Secret ein.',
    softgardenMonaStatusEingang: 'Geben Sie den Status für Eingang in MONA ein.',
    softgardenMonaStatusImInterview: 'Geben Sie den Status für Interview läuft in MONA ein.',
    softgardenMonaStatusInterviewAbgeschlossen: 'Geben Sie den Status für Interview abgeschlossen in MONA ein.',
    softgardenMonaStatusAbgelehnt: 'Geben Sie den Status für Abgelehnt in MONA ein.',
    softgardenDuplicateStatus: 'Geben Sie den Status für Duplikat in MONA ein.',
    talentMonaStatusAbgelehnt: 'Geben Sie den Status für Abgelehnt in MONA ein.',
    covetoMonaStatusAbgelehnt: 'Geben Sie den Status für Abgelehnt in MONA ein.',
    hr4youMonaStatusAbgelehnt: 'Geben Sie den Status für Abgelehnt in MONA ein.',
    compleetMonaStatusAbgelehnt: 'Geben Sie den Status für Abgelehnt in MONA ein.',
    compleetRecruitingMonaStatusAbgelehnt: 'Geben Sie den Status für Abgelehnt in MONA ein.',
    mysolutionMonaStatusAbgelehnt: 'Geben Sie den Status für Abgelehnt in MONA ein.',
    Alle: 'Alle',
    GebieteNL: 'Gebiete/NL',
    Jobs: 'Jobs',
    TalentionGebieteNiederlassungen: 'Talention Gebiete & Niederlassungen',
    BeispielBerlinHamburgMünchen: 'Beispiel: Berlin,Hamburg,München',
    KeywordsMitKommaTrennen: 'Keywords mit Komma trennen*',
    CompleetAPIPersoprofilerCompana: 'Compleet API (Persoprofiler + Compana)',
    GEPEXAPI: 'GEPEX API',
    CompleetAPIKeys: 'Compleet API Keys',
    StandortAbteilung: 'Standort/Abteilung:',
    Compleet: 'Compleet',
    initiativRow: 'Fallback',
    IndexAnzeigendaten: 'Index Anzeigendaten',
    IndexLogin: 'Index Login',
    Passwort: 'Passwort',
    AlleIntegrationen: 'Alle Integrationen',
    SaaS: 'SaaS',
    OnPremise: 'On Premise',
    Ordner: 'Ordner',
    ExklusivePartnervonMONAAI: 'Exklusive Partner von ',
    AllApps: 'Alle Apps',
    Bewerberdaten: 'Bewerberdaten',
    Verlassen: 'Verlassen',
    ready: 'Bereit',
    inDevelopment: 'In Entwicklung',
    inTesting: 'In Test',
    generateApiKey: 'API Key generieren',
    DuBistEingeloggtMit: 'Du bist eingeloggt mit',
    RecruitingApi: 'Recruiting API',
    AgentApi: 'Agent API',
    Kalendar: 'Kalendar',
    Mitarbeiterdaten: 'Mitarbeiterdaten',
    Aufträge: 'Aufträge',
    allData: 'Alle Daten',
    SearchForApps: 'Suche nach Apps',
    Erfolgreichgespeichert: 'Erfolgreich gespeichert',
    ErfolgreichgespeichertText:
      'Deine Einstellungen wurden erfolgreich gespeichert.',
    FehlertextfürdieEinstellung:
      'Deine Einstellungen konnten nicht gespeichert werden. Bitte versuche es erneut.',
    GenerateApiKey: 'API Key generieren',

    //job-offer-info.html
    KIZiele: 'KI-Ziele',
    BitteWarten: 'Bitte warten...',
    SubscriptionExpiredTitle: 'Subscription abgelaufen',
    SubscriptionExpiredMessage:
      'Dein Abo ist ausgelaufen oder nicht mehr aktiv. Bitte erneuere deine Subscription, um die Plattform weiter zu nutzen.',
    GoToPricing: 'Zu Pricing',
    zurück: 'zurück',
    Kopieren: 'Kopieren',
    StellenangebotBearbeiten: 'Interview bearbeiten',
    Stellentitel: 'Stellentitel',
    IndexStellentitel: 'Index-Stellentitel',
    Produktionshelfer: 'z.B. Produktionshelfer (m/w/d)',
    Einleitung: 'Einleitung',
    BeschreibenSieKurzUndKnappIhrUnternehmen:
      'Beschreiben Sie kurz und knapp Ihr Unternehmen.',
    Aufgaben: 'Aufgaben',
    BeschreibenSieDieGenauenAufgabenUndVerantwortungsbereicheDerStelleDamitDerBewerberVerstehtWasDiesePositionAttraktivMacht:
      'Beschreiben Sie die genauen Aufgaben und Verantwortungsbereiche der Stelle, damit der Bewerber versteht, was diese Position attraktiv macht.',
    Qualifikation: 'Qualifikation',
    BeschreibenSieIhreAnforderungenAnDenKandidaten:
      'Beschreiben Sie Ihre Anforderungen an den Kandidaten.',
    Benefits: 'Benefits',
    NennenSieBenefitsWelcheIhrUnternehmenEinzigartigUndAttraktivMachen:
      'Nennen Sie Benefits, welche Ihr Unternehmen einzigartig und attraktiv machen.',
    Schlussworte: 'Schlussworte',
    WirFreuenUnsÜberDeineBewertung: 'z.B. Wir freuen uns über deine Bewertung!',
    GehaltBrutto: 'Gehalt (Brutto)',
    Land: 'Land',
    Stadt: 'Stadt',
    Deutschland: 'Deutschland',
    Frankreich: 'Frankreich',
    VereinigtesKönigreich: 'Vereinigtes Königreich',
    Schweiz: 'Schweiz',
    Österreich: 'Österreich',
    Belgien: 'Belgien',
    Niederlande: 'Niederlande',
    Luxemburg: 'Luxemburg',
    Spanien: 'Spanien',
    Italien: 'Italien',
    Polen: 'Polen',
    Dänemark: 'Dänemark',
    Schweden: 'Schweden',
    Norwegen: 'Norwegen',
    Finnland: 'Finnland',
    Estland: 'Estland',
    Lettland: 'Lettland',
    Litauen: 'Litauen',
    Tschechien: 'Tschechien',
    Slowakei: 'Slowakei',
    Ungarn: 'Ungarn',
    Slowenien: 'Slowenien',
    Kroatien: 'Kroatien',
    Serbien: 'Serbien',
    Ukraine: 'Ukraine',
    Russland: 'Russland',
    StadtSuchen: 'Stadt suchen',
    Vertrag: 'Vertrag',
    UploadLogo: 'Logo hochladen',
    KlickenZumÄndern: 'Klicken zum ändern',
    FarbauswahlKopfzeile: 'Farbauswahl-Kopfzeile',
    FarbauswahlKörper: 'Farbauswahl-Körper',
    FarbauswahlFürDenFirmentitel: 'Farbauswahl für den Firmentitel',
    AvatarKonfigurieren: 'Avatar konfigurieren',
    AvatarName: 'Avatar Name',
    MONA: 'z.B. MONA',
    AvatarAuswählen: 'Avatar auswählen',
    Automatisierung: 'Automatisierung',
    FragenAnDenBewerber: 'Fragen an den Bewerber',
    Parameter: 'Parameter',
    Feld: 'Feld',
    Fragetyp: 'Fragetyp',
    abfragen: 'abfragen',
    übersetztIn: 'übersetzt in',
    ParameternameExistiertBereits: 'Parametername existiert bereits.',
    NachrichtExistiertBereits: 'Nachricht existiert bereits.',
    HelpNoMessageAnswersPresent: 'Es gibt keine Nachrichtenantworten.',
    HelpNoCommunicationWorkflowsPresent:
      'Es wurden keine Kommunikations-Workflows erstellt. Bitte zuerst einen Workflow unter Einstellungen → Workflows anlegen',
    SetCommunicationWorkflowHasBeenDeleted: 'wurde gelöscht.',
    HelpCommunicationWorkflowHasBeenDeletedExclamationOtherWorkflowExists:
      'Bitte wählen Sie einen anderen Termin-Workflow oder ändern Sie den Fragentyp.',
    HelpChooseAnotherQuestionTypeAsNoCommunicationWorkflow:
      'Bitte wählen Sie einen anderen Fragetyp, da kein Terminworkflow vorhanden ist.',
    InvalidMessage: 'Ungültige Nachricht',
    InterviewContainsDeletedCommunicationWorkflowMessage:
      'Das Interview enthält gelöschte Termine Workflow ',
    defaultJobOfferLanguage: 'Standardsprache für Stellenangebote',
    CodingChallenge: 'Coding Challenge',
    vorgeschlageneFragen: 'vorgeschlagene Fragen',
    ErweiterteEinstellungen: 'Erweiterte Einstellungen',
    automatischeBewerbung: 'automatische Bewerbung',
    VertragOderDokumenteErklären: 'Vertrag oder Dokumente erklären',
    Sprachsteuerung: 'Sprachsteuerung',
    CVParsingZuBeginnDesGesprächs: 'CV-Parsing',
    automatischerEinstellungstest: 'automatischer Einstellungstest',
    BrowserspracheErzwingen: 'Browsersprache erzwingen',
    Feedback: 'Feedback vom Bewerber',
    SprachenAuswählen: 'Sprachen auswählen',
    deutsch: 'deutsch',
    französisch: 'französisch',
    bulgarisch: 'bulgarisch',
    englisch: 'englisch',
    ukrainisch: 'ukrainisch',
    türkisch: 'türkisch',
    rumänisch: 'rumänisch',
    polnisch: 'polnisch',
    slowakisch: 'slowakisch',
    arabisch: 'arabisch',
    ungarisch: 'ungarisch',
    tschechisch: 'tschechisch',
    portugiesisch: 'portugiesisch',
    italienisch: 'italienisch',
    holländisch: 'holländisch',
    spanisch: 'spanisch',
    russisch: 'russisch',
    dänisch: 'dänisch',
    schwedisch: 'schwedisch',
    chinesisch: 'chinesisch',
    kroatisch: 'kroatisch',
    serbisch: 'serbisch',
    albanisch: 'albanisch',
    kasachisch: 'kasachisch',
    indonesisch: 'indonesisch',
    litauisch: 'litauisch',
    estnisch: 'estnisch',
    afrikaans: 'afrikaans',
    hindi: 'hindi',
    malayalam: 'malayalam',
    Flowchart: 'Flowchart',
    ConditionalRoutings: 'Conditional Routings',
    FlowchartZurücksetzen: 'Flowchart zurücksetzen',
    CreateANewNodeButton: 'Erstellen Sie einen neuen Knoten',
    backToJobOffersHeader: 'Zurück zur Stellenübersicht',
    fontStyleLabel: 'Schriftart auswählen',
    backToJobOffersMessage:
      'Möchtest du wirklich zurück zu den Stellenanzeigen?',
    FlowchartZurücksetzenText:
      'Möchtest du den Flowchart wirklich zurücksetzen?',
    IframeKopieren: 'iFrame Kopieren',
    addJobButtonText: 'Interview Erstellen',
    FullscreenFlowchart: 'Vollbildmodus aktivieren',
    ExportToExcel: 'Export als Excel',
    EinstellungstestAnAlleSenden: 'Einstellungstest an alle senden',
    Herkunft: 'Herkunft',
    Bewerbernummer: 'Bewerbernummer',
    Stelle: 'Stelle',
    email: 'Email',
    Telefon: 'Telefon',
    TelefonAndCode: 'Telefonnummer z.B. +49 1234567890',
    Bewerbungseingang: 'Bewerbungseingang',
    QALab: 'Q&A Lab',
    LimitReached: 'Limit erreicht',
    LimitReachedMessage: 'Sie haben das maximale Limit erreicht',
    MessageStillInFlowchart:
      'Diese Nachricht ist noch im Flowchart. Bitte entfernen Sie sie zuerst aus dem Flowchart, bevor Sie sie hier deaktivieren.',
    //new-job-offer.html
    SpeichernAlsTemplate: 'Als Template Speichern',
    StellenangebotErstellen: 'Stellenangebot erstellen',
    HINWEIS: 'Hinweis',
    SAVE_AS_DRAFT: 'Entwurf speichern',
    SAVE_IN_TEST_MODE: 'im Testmodus speichern',
    InfoMessageForMessagePresentInFlowhchart:
      'Bitte löschen Sie zunächst die Nachricht aus dem Flussdiagramm.',
    ToastForStandaloneNodes:
      'Jeder Knoten muss über mindestens einen eingehenden Link und einen ausgehenden Link verfügen, mit Ausnahme des Knotens Start- und Endsitzung.',
    ToastStandaloneNodeAdded:
      'Ein eigenständiger Knoten wurde hinzugefügt. Bitte stellen Sie eine Verbindung mit einem Quell- und einem Zielknoten her, um daraus ein gültiges Flussdiagramm zu erstellen.',
    ToastHeaderForStandaloneNodes:
      'Flussdiagramm enthält eigenständigen Knoten',
    CVUPLOAD_FLOWCHART_NODE_EXISTS_TOAST:
      'CV-Upload-Knoten existiert in einem Flussdiagramm. Bitte entfernen Sie ihn aus dem Flussdiagramm, um ihn zu deaktivieren.',
    INVALID_ANSWER_IN_FLOWCHART_LINK: 'Ungültige Antwort im Flowchart-Link',
    INVALID_ANSWER_IN_FLOWCHART_LINK_MESSAGE:
      'Bitte überprüfen Sie das Flussdiagramm. Es gibt einen Link mit einer ungültigen Antwort. Bitte korrigieren Sie ihn, um das Stellenangebot zu speichern.',
    MESSAGE_MULTIPLE_LINKS_FROM_ONE_NODE_WITH_SAME_CONDITION_IS_NOT_ALLOWED:
      'Mehrere Links mit derselben Bedingung sind nicht erlaubt.',

    //qna-lab.html
    VorgeschlageneFragen: 'Vorgeschlagene Fragen',
    Aktualisieren: 'Aktualisieren',
    StellenanzeigeBearbeiten: 'Stellenanzeige bearbeiten',
    GenerierenSieFragen: 'Generieren Sie Fragen',
    Hinzufügen: 'Hinzufügen',
    AILabTrainingPanel: 'AI Lab Training Panel',
    Keyword: 'Keyword',
    Anzahl: 'Anzahl',
    Keywords: 'Keywords',
    Deutsch: 'deutsch',
    //profile.html
    CoreDataAccess: 'Core Data Access',
    AgentManagement: 'Agent Management',
    ToolManagement: 'Tool Management',
    MatchingAnalytics: 'Matching & Analytics',
    DocumentProcessing: 'Document Processing',
    Administrative: 'Administrative',

    ExecuteAgents: 'Execute Agents',
    ExecuteWorkflow: 'Execute Workflow',
    ReadTools: 'Read Tools',
    ManageTools: 'Manage Tools',
    ReadMatching: 'Read Matching',
    CreateMatching: 'Create Matching',
    ReadAnalytics: 'Read Analytics',
    Parsing: 'Parsing',
    ReadCommunication: 'Read Communication',
    ManageApiKeys: 'Manage API Keys',
    SystemAdmin: 'System Admin',
    AccountEinstellungen: 'Account Einstellungen',
    UnternehmensInformationen: 'Unternehmens Informationen',
    WebseitenLink: 'Webseiten Link',
    Farbauswahl: 'Farbauswahl',
    FarbeAuswählen: 'Farbe auswählen',
    SpracheAuswählen: 'Plattform-Sprache auswählen',
    Kontaktierung: 'Kontaktierung',
    Standorte: 'Standorte',
    Straße: 'Straße',
    Hausnr: 'Hausnr',
    PLZ: 'PLZ',
    Umkreis: 'Umkreis',
    Ort: 'Ort',
    id: 'ID',
    EMinusMail: 'E-Mail',
    calendlyLink: 'Calendly Link',
    Datenschutz: 'Datenschutz',
    GebenSieHierIhrenDatenschutzLinkEin:
      'Geben Sie hier Ihren Datenschutz-Link ein',
    MatchingProfilvertrieb: 'Matching & Profilvertrieb',
    FallbackFürInterviews: 'Fallback für Interviews',
    FallbackFürFinishedInterviewDocument:
      'Fallback für Finished Interview Document',
    MatchingExtern: 'Matching extern',
    MinimumMatchingErgebnis: 'Minimum Matching Ergebnis',
    MatchingKriterium: 'Matching Kriterium',
    MatchingTyp: 'Matching Typ',
    MatchingGewicht: 'Matching Gewicht',
    Optionen: 'Optionen',
    EUWorker:
      'EU-Worker - lebt in EU, soll vermittelt werden nach DE. Lebensstandort des Bewerbers wird nicht für Matching verwendet wenn aktiv. Gilt nicht für Personen, die in Deutschland leben.',
    Hard: 'Hard',
    Soft: 'Soft',
    ausgewähltIstDannMussDasKriteriumErfülltWerdenDamitEinMatchVorliegt:
      'ausgewählt ist, dann muss das Kriterium erfüllt werden, damit ein Match vorliegt.',
    ausgewähltIstDannMussDasKriteriumNichtErfülltWerdenDamitEinMatchVorliegt:
      'ausgewählt ist, dann muss das Kriterium nicht erfüllt werden, damit ein Match vorliegt.',
    EineGewichtungVon1IstDieNiedrigsteGewichtungFürEinMatchingkriterium:
      'Eine Gewichtung von 1 ist die niedrigste Gewichtung für ein Matchingkriterium.',
    EineGewichtungVon200IstDieNiedrigsteGewichtungFürEinMatchingkriterium:
      'Eine Gewichtung von 200 ist die niedrigste Gewichtung für ein Matchingkriterium.',
    insgesamtKönnen20KriterienAngepasstWerdenGematchedWerdenInsgesamt25KriterienUndDieInterviewergebnisse:
      'Insgesamt können 20 Kriterien angepasst werden. Gematched werden insgesamt 25 Kriterien und die Interviewergebnisse',
    BewerberprofilKonfigurieren: 'Bewerberprofil konfigurieren',
    ProfilbildAutomatischErgänzen: 'Profilbild automatisch ergänzen',
    SprachenMüssenEnthaltenSein: 'Sprachen müssen enthalten sein',
    BerufserfahrungMussEnthaltenSein: 'Berufserfahrung muss enthalten sein',
    AtLeastThreeJobs: 'mindestens drei Berufspositionen',
    WennDerMatchingTyp: 'Wenn der Matching-Typ',
    Zertifikate: 'Zertifikate',
    Softskills: 'Softskills',
    ProjektkenntnisseMüssenEnthaltenSein:
      'Projektkenntnisse müssen enthalten sein',
    AufenthaltserlaubnisArbeitserlaubnisMussVorliegenOderAbgefragtSein:
      'Aufenthaltserlaubnis/Arbeitserlaubnis muss vorliegen oder abgefragt sein',
    ExternalAccess: 'Externer Zugang',
    ExternalAccessSettings: 'Externe Zugriffseinstellungen',
    ExternalAccessSettingsMessage:
      'Erlauben Sie externen Integrationen, Daten für Ihre Bewerber, Jobangebote und Agenten zu pushen/zu holen.',
    ReadApplicants: 'Bewerber lesen',
    PushApplicants: 'Bewerber pushen',
    ReadJobOffers: 'Stellenangebote lesen',
    PushJobOffers: 'Stellenangebote pushen',
    ReadAgents: 'Agenten lesen',
    PushAgents: 'Agenten pushen',
    ReadData: 'Daten lesen',
    PushData: 'Daten pushen',
    GenerateAPIKey: 'API-Schlüssel Generieren',
    YourNewAPIKey: 'Ihr neuer API-Schlüssel',
    PleaseCopyThisKeyMessage:
      'Bitte kopieren Sie diesen Schlüssel jetzt. Sie werden ihn später nicht mehr sehen können.',
    EmailAutomation: 'E-Mail-Automatisierung',
    EmailAutomationSettings: 'E-Mail-Automatisierungseinstellungen',
    EmailAutomationSettingsMessage:
      'Generieren Sie eine neue E-Mail-Adresse und verbinden Sie sie mit einem Workflow, der ausgelöst wird, wenn eine E-Mail eingeht.',
    SaveEmailConfigurationManually: 'E-Mail-Konfiguration manuell speichern',
    GenerateNewEmailAddress: 'Neue E-Mail-Adresse Generieren',
    DeleteEmailAccount: 'E-Mail-Konto Löschen',
    IMAPEmailAddress: 'IMAP E-Mail Adresse',
    SMTPEmailAddress: 'SMTP E-Mail Adresse',
    ExternalAccessAndAPI: 'Externer Zugang & API',
    APIAndConnections: 'API & Verbindungen',
    AboAndSubscription: 'Abo & Abonnement',
    UserId: 'Benutzer-ID',
    SelectUser: 'Benutzer Auswählen',
    SelectRole: 'Rolle Auswählen',
    Recruiter: 'Anwerber',
    Admin: 'Verwaltung',
    ManageBillingSettingsHere:
      'Verwalten Sie Ihre Rechnungseinstellungen hier.',
    MatchingTypeForMonaJobs: 'Matching-Typ für MONA Jobs',
    MatchingArtMONA: 'Matching-Art für MONA-Stellen',
    YourNewEmailAddress: 'Ihre neue E-Mail Adresse',
    SelectWorkflow: 'Workflow Auswählen',
    PleaseCopyThisPasswordMessage:
      'Bitte kopieren Sie dieses Passwort jetzt, wenn Sie es für andere APIs benötigen. Sie werden es später nicht mehr sehen können.',
    SavePermissions: 'Berechtigungen Speichern',
    ManageBilling: 'Rechnungen Verwalten',
    AIAssistant: 'KI-Assistent',
    SaveAutomation: 'Automatisierung Speichern',
    Bewerberstatus: 'Bewerberstatus',
    Bewerberquelle: 'Bewerberquelle',
    Job_Bezeichnung: 'Job Bezeichnung',
    Verfügbarkeit: 'Verfügbarkeit',
    Gehalt: 'Gehalt',
    Arbeitszeit: 'Arbeitszeit',
    Arbeitsvertrag: 'Arbeitsvertrag',
    Branchenkenntnisse: 'Branchenkenntnisse',
    projectExperience: 'Projekt Erfahrung',
    Persönlichkeit: 'Persönlichkeit',
    Arbeitsrechtliche_Einschränkungen: 'Arbeitsrechtliche Einschränkungen',
    Management_Level: 'Management Level',
    Mobilität: 'Mobilität',
    DeleteEmailAccountMessage:
      'Sind Sie sicher, dass Sie dieses E-Mail-Konto löschen möchten?',
    password: 'Passwort',
    EmailAccountDeleted: 'E-Mail-Konto erfolgreich gelöscht',
    EmailAccountSaved: 'E-Mail-Konto erfolgreich gespeichert',
    AIAssistantMessage:
      'Funktionalitäten für Ihre Benutzer zulassen oder verbieten',
    ErstkontaktInsights: '11) Erstkontakt',
    ZweitkontaktInsights: '12) Zweitkontakt',
    DrittkontaktInsights: '13) Drittkontakt',
    validatePhoneNumber: 'Telefonnummer validieren',

    // mona-agent-chat.page.html
    sendSMS: 'SMS senden',
    sendMail: 'E-Mail senden',
    sendCall: 'Anruf senden',
    sendWhatsApp: 'WhatsApp senden',
    sendLinkedIn: 'LinkedIn senden',
    sendXing: 'Xing senden',
    sendFacebook: 'Facebook senden',
    sendInstagram: 'Instagram senden',
    sendX: 'X senden',
    confirm: 'Bestätigen',
    FreigegebeneTelefonnummern: 'Freigegebene Telefonnummern',
    Landauswählen: 'Land auswählen',
    VollständigeNummer: 'Vollständige Nummer',
    FreigegebeneEMailAdressen: 'Freigegebene E-Mail-Adressen',
    Sprachpräferenzen: 'Sprachpräferenzen',
    Bestätigen: 'Bestätigen',

    //delete-job-offer.html
    StellenanzeigeLöschen: 'Stellenanzeige löschen',
    SindSieSicherDassSieDieseStellenanzeigeLöschenMöchten:
      'Sind Sie sicher, dass Sie diese Stellenanzeige löschen möchten?',

    //job-offers.html
    NeuLaden: 'Neu Laden',
    Aktiv: 'Aktiv',
    Draft: 'Vorlagen',
    Test: 'Test',
    Gelöscht: 'Gelöscht',
    ImportierenVonStellenanzeigen: 'Importieren von Stellenanzeigen',
    ExportierenVonStellenanzeigen: 'Exportieren von Stellenanzeigen',
    Reaktivieren: 'Reaktivieren',
    Verträge: 'Dokumente',
    Aktualisiert: 'Aktualisiert',
    Stellenangebot: 'Interview',
    Standort: 'Standort',
    URL: 'URL',
    Iframe: 'Iframe',
    StatusDerBereitstellung: 'Status der Bereitstellung',
    Interaktion: 'Interaktion',

    //logo.html
    ChangeCompanyLogoJPGPNG: 'Logo ändern (JPG/PNG)',
    BildHinzufügen: 'Bild hinzufügen',
    BitteGebenSieEinKleineresBildEin:
      'Bitte laden Sie ein kleineres Bild hoch.',
    Entfernen: 'Entfernen',

    //message -> configure-message.html
    AlteNachricht: 'Alte Nachricht',
    NeueNachricht: 'Neue Nachricht',
    neueNachrichtEingeben: 'neue Nachricht eingeben',

    //mona-communication-list.html
    Recruiting: 'Recruiting',
    Onboarding: 'Onboarding',
    Vertrieb: 'Vertrieb',
    VertriebHistorie: 'Vertrieb-Historie',
    WorkflowsAnwenden: 'Workflows anwenden',
    RunAgentTask: 'Run Agent Task',
    SalesmailsLöschen: 'Salesmails löschen',
    SalesmailsFreigeben: 'Salesmails freigeben',
    Ziel: 'Ziel',
    Dokumente: 'Dokumente',
    BewerberId: 'Bewerber ID',
    Kontakt: 'Kontakt',
    EmailPreview: 'Email Vorschau',
    ViewEmail: 'Email anzeigen',
    Company: 'Firma',
    Location: 'Standort',
    Position: 'Position',
    URLLink: 'URL Link',
    CompanyLink: 'Firmenlink',
    CompanyReport: 'Firmenreport',
    CompanyPhone: 'Firmen Telefon',
    ContactPerson: 'Kontaktperson',
    ContactPersonEmail: 'Kontaktperson Email',
    ContactPersonPhone: 'Kontaktperson Telefon',
    Goal: 'Ziel',
    AcquisitionSubject: 'Akquise Betreff',
    MatchingPunktzahl: 'Matching Punktzahl',
    Erklaerung: 'Erklärung',
    Reflexion: 'Reflexion',
    Unternehmensdetails: 'Unternehmensdetails',
    OpenDocument: 'Dokument öffnen',
    EditEmail: 'E-Mail bearbeiten',
    ViewEmailContent: 'E-Mail-Inhalt anzeigen',
    AttachNewAttachment: 'Neuen Anhang hinzufügen',
    ShowLead: 'Lead anzeigen',
    ShowCompanyDetails: 'Unternehmensdetails anzeigen',
    ShowMoreJobs: 'Mehr Jobs anzeigen',
    Cancel: 'Abbrechen',
    Versanddatum: 'Versanddatum',
    SpaltenAnpassen: 'Spalten anpassen',
    Notes: 'Notizen',
    SetValueOfDeal: 'Wert des Profils festlegen',
    //team-management.html
    Team: 'Team',
    TeammitgliederVerwalten: 'Teammitglieder verwalten',
    Einladen: 'Einladen',

    //news.html
    UpdateLOG: 'Update - LOG',
    TageHer: 'Tage her',
    Plattform: 'Plattform',
    Verbesserung: 'Verbesserung',
    BugFix: 'Bug-Fix',

    //preview-file.html
    Herunterladen: 'Herunterladen',
    abgeschlossenesStudium: 'abgeschlossenes Studium',
    mehrAls6MonateBerufserfahrung: 'mehr als 6 Monate Berufserfahrung',
    Deutschkenntnisse: 'Deutschkenntnisse',
    Übernehmen: 'Übernehmen',
    FehlerBeimLadenDerDatei: 'Fehler beim Laden der Datei...',
    AnswerVideo: 'Antwort Video',
    Image: 'Bild',
    MatchingErgebnisseZusenden: 'Sales Mails-Liste zusenden per Mail',

    //applicant-create-short-info.html
    BewerberAnlegen: 'Bewerber anlegen',
    BewerberSchnellerfassung: 'Bewerber-Schnellerfassung',
    Strasse: 'Straße',
    Hausnummer: 'Hausnummer',
    Wohnort: 'Wohnort',
    TelefonMobil: 'Telefon / Mobil',
    Geburtsdatum: 'Geburtsdatum',
    ChoosePDFFile: 'PDF-Datei wählen',
    //constants.ts
    PERSONALIZE_MESSAGE:
      'Diese standardmäßige personalisierte Nachricht würde angezeigt, wenn Sie keine personalisierte Nachricht festlegen. Wir möchten Sie daher bitten, Ihre eigene personalisierte Nachricht festzulegen und auf die Schaltfläche „Speichern“ zu klicken.',
    GENERATEQAQUESTIONS_LOADING_MESSAGE:
      'Bitte warten Sie 15 Sekunden, während wir Fragen generieren.',
    GENERATEQA_PROMPT_MESSAGE:
      'Listen Sie die 10 wichtigsten Fragen auf, die Sie einem Personalvermittler als Bewerber für die Stelle stellen sollten ',
    JOB_TITLE_NOTSET_MESSAGE:
      'Um vorgeschlagene Fragen zu generieren, geben Sie bitte hier den Stellentitel ein.',
    REFRASEQANDAQUESTIONS_TEXTBLOCK:
      'Nachfolgend sende ich dir mit Komma seperierte Fragen. Formuliere jede Fragen in 10 verschiedenen weisen um. Formuliere sie so, als würde sie ein Bewerber an einen Recruiter stellen. Gebe mir das Ergebnis als valides Json format zurück mit den von mir gesendeten Fragen als Key und den von dir umgewandelten Fragen als value. Das json objekt soll wie folgt aufgebaut werden. {"frage1": [""]}. Lösche alles, was verhindert, dass es ein valides JSON objekt wird. Ersetze \'frage\' mit den Fragen, die ich dir gebe und den Array \'[""]\' mit den Ergebnissen von dir. Gib mir keine weiteren Erklärungen: ',
    AIALERT_MESSAGE:
      'Das KI-Modell wird jetzt trainiert. Dies dauert ca. 10 Minuten. Anschließend kann das Gespräch geführt werden.',
    AIFEEDBACKONPREQUISITES_MESSAGE:
      'Nachfolgend ist der Text für eine Stellenanzeige. Welche Fragen würdest du an einen Bewerber stellen, um herauszufinden, ob er die Anforderungen an die Stellenanzeige erfüllt? Formuliere maximal 10 Fragen: ',
    VALIDATE_CANTLINKTOITSELF_MESSAGE:
      'Du kannst keinen Knoten auf sich selbst verlinken',
    VALIDATE_NOCONDITIONSBUTVALUEISSET_MESSAGE:
      'Sie können keinen Knoten mit Wert, aber ohne Bedingung verknüpfen',
    VALIDATE_CONDITIONPRESENTBUTVALUEISNOTSET_MESSAGE:
      'Kann keinen Link ohne Wert hinzufügen und ',
    VALIDATE_NOCONDITIONS_ONSTARTNODE_MESSAGE:
      'Zum Startknoten können keine Bedingungen hinzugefügt werden',
    VALIDATE_NEWUPDATEDLINK_CONTAINSVALUEBUTCONDITIONJAORNEIN_MESSAGE:
      "Link mit dem Wert 'true' oder 'false', aber mit der Bedingung 'Yes' oder 'No' ist ungültig.",
    MAXIMUM_QUESTIONS_REACHED_MESSAGE: 'Maximale Anzahl von Fragen erreicht',
    VALIDATECYCLE_WITHOUTCONDITIONS_MESSAGE:
      'Zyklen oder Mehrfachverknüpfungen ohne Bedingungen sind nicht zulässig',
    ERROR_CLOUDFUNCTION_MESSAGE:
      'Fehler beim Aufrufen der Google Cloud Function: ',
    //   GENERATE_ASSESSMENT_ANSWERS:  "Bitte generieren Sie 4 Multiple-Choice-Optionen für die folgende Frage. Von den Optionen müssen 3 falsch und 1 richtig sein. Bitte geben Sie die Antwort als JSON-Objekt zurück, bestehend aus der Frage als „frage“, 4 Optionen als „optionen“ und der richtigen Antwort als „richtig“. Schreiben Sie Optionen im JSON als [„Option 1“, „Option 2“, „Option 3“, „Option 4“]",
    GENERATE_ASSESSMENT_ANSWERS:
      '„Bitte generieren Sie 4 Multiple-Choice-Optionen für die folgende Frage. Von den Optionen müssen 3 falsch und 1 richtig sein. Bitte geben Sie die Antwort als JSON-Objekt zurück, bestehend aus der Frage als „Frage“, 3 falschen Optionen als „falsch“ und der richtigen Antwort als „richtig“. Schreiben Sie die falschen Optionen in JSON als [„Option 1“, „Option 2“, „Option 3“]“; Hier ist die Frage:',
    //   GENERATE_ASSESSMENT_QUESTIONS_ANSWERS_ONLY_TITLE: "Lesen Sie den Titel und stellen Sie genau 10 nicht ganz einfache Fragen. Für diese 10 Fragen sollte es 4 Optionen geben, von denen 3 falsch und 1 richtig sein sollten. Geben Sie es als einfaches JSON-Objektformat zurück. Befolgen Sie strikt diese Beispielvorlage: {frage: \"example questions\", optionen: [\"option 1\", \"option 2\", \"option 3\", \"option 4\"], richtig: \"option 3\"}. Hier ist der Titel der Rezension:",
    //   GENERATE_ASSESSMENT_QUESTIONS_ANSWERS_ONLY_TITLE: "Lesen Sie den Titel und stellen Sie genau 10 nicht ganz einfache Fragen. Für diese 10 Fragen sollte es 4 Optionen geben, von denen 3 falsch und 1 richtig sein sollten. Geben Sie es als einfaches Array im JSON-Objektformat zurück. Befolgen Sie strikt diese Beispielvorlage: [{„frage“: „Beispielfragen“, „optionen“: [„Option 1“, „Option 2“, „Option 3“, „Option 4“], „richtig“: „Option 3“}, {„frage“: „Beispielfragen“, „optionen“: [„Option 1“, „Option 2“, „Option 3“, „Option 4“], „richtig“: „Option 3“}]. Hier der Titel der Rezension:",
    GENERATE_ASSESSMENT_QUESTIONS_ANSWERS_ONLY_TITLE:
      'Lesen Sie den Titel und stellen Sie genau 10 nicht ganz einfache Fragen. Für diese 10 Fragen sollte es 4 Optionen geben, von denen 3 falsch und 1 richtig sein sollten. Geben Sie es als einfaches Array im JSON-Objektformat zurück. Halten Sie sich strikt an diese Beispielvorlage: [{„frage“: „Beispielfragen“, „falsch“: [„Option 1“, „Option 2“, „Option 3“], „richtig“: „Option 4“ }, {„frage“: „Beispielfragen“, „falsch“: [„Option 1“, „Option 2“, „Option 3“], „richtig“: „Option 4“}]. Hier der Titel der Rezension:',
    PREVIEW_NOT_AVAILABLE_HEADER: 'Vorschau nicht verfügbar',
    PREVIEW_NOT_AVAILABLE_MESSAGE:
      'Ihre Datei wurde hochgeladen, kann jedoch nicht in der Vorschau angezeigt werden.',
    DATA_PROTECTION_URL_INVALID_MESSAGE:
      'Die Datenschutz-URL ist ungültig. Bitte geben Sie eine gültige URL ein und versuchen Sie es erneut.',
    DATA_PROTECTION_URL_NOTE_MESSAGE: 'Bitte geben Sie eine gültige URL ein.',
    JOB_OFFER_RESTORED: 'Stellenangebot wurde reaktiviert',
    NO_JOB_OFFER_RECORDS_TEXT: 'Keine Stellenangebote gefunden',
    NO_APPLICANT_RECORDS_TEXT: 'Keine Bewerber gefunden',
    APPLICANT_DELETED_SUCCESSFULLY: 'Bewerber erfolgreich gelöscht',
    LOADING_TEXT_DASHBOARD: 'Wird geladen...',
    STELLENANZEIGE_ERSTELLEN: 'Interview erstellen',
    NeuesInterview: 'Neues Interview',
    IFRAME_KOPIEREN: 'IFrame kopieren',
    EMAIL_TEXT:
      'Hey $firstname $lastname,\n\ndu hast dich erfolgreich bei der Firma $companyname beworben.\n\nKlicke auf den untenstehenden Link, um dein Interview mit unserer digitalen Mitarbeiterin zu starten.\n\n$interactionURL',
    SMS_TEXT:
      'Hey $firstname,\n\ndu hast dich erfolgreich bei der Firma $companyname beworben.\n\nKlicke auf den untenstehenden Link, um dein Interview mit unserer digitalen Mitarbeiterin zu starten.\n\n$interactionURL',
    BETREFF_TEXT: 'Starte jetzt dein Interview',
    CALENDLY_BETREFF_TEXT: 'Buche dir jetzt deinen Kennenlern-Termin',
    CALENDLY_TEXT:
      'du hast dich erfolgreich für den Job bei $companyname beworben.\n\nAnbei erhälst du einen Link um dir einen Kennenlern-Termin zu buchen.\n\n',

    STATUS_INPRÜFUNG: 'in Prüfung',
    STATUS_INTERVIEW_ABGESCHLOSSEN: 'Interview abgeschlossen',
    STATUS_BEGINNT_BEWERBUNGSPROZESS: 'beginnt Bewerbungsprozess',
    STATUS_EINGESTELLT: 'Eingestellt',
    STATUS_VERMITTELT: 'Vermittelt',
    STATUS_ABSAGE_DURCH_DISPONENT: 'Absage durch Disponent',
    STATUS_ABSAGE_DURCH_KUNDE: 'Absage durch Kunde',
    STATUS_ABSAGE_DURCH_BEWERBER: 'Absage durch Bewerber',
    STATUS_EINLADUNG_ZUM_VG: 'Einladung zum VG',
    STATUS_NOCHMAL_ANRUFEN: 'nochmal anrufen',
    STATUS_PROBEARBEIT: 'Probearbeit',
    STATUS_PROFIL_AN_KUNDEN: 'Profil an Kunden weitergeleitet',
    STATUS_RÜCKRUF_FÜR_VEREINBARUNG: 'Rückruf für Vereinbarung VC/Interview',
    STATUS_VC_INTERVIEW_NICHT_WAHRGENOMMEN: 'VC/Interview nicht wahrgenommen',
    STATUS_VC_INTERVIEW_VEREINBART: 'VC/Interview vereinbart',
    STATUS_VG_DURCHGEFÜHRT: 'VG durchgeführt',
    STATUS_VG_NICHT_ERSCHIENEN: 'VG nicht erschienen',
    STATUS_TALENTPOOL: 'Talentpool',
    STATUS_BEFINDET_SICH_AKTUELL_IM_INTERVIEW:
      'befindet sich aktuell im Interview',
    STATUS_EINSTELLUNGSTEST_ABGESCHLOSSEN: 'Einstellungstest abgeschlossen',
    SPECIFY_NODES:
      'Du musst mindestens einen Knoten im Flowchart zwischen dem Start Knoten und dem End Knoten angeben.',
    SPECIFY_END_NODES:
      'Du musst einen End Session Knoten im Flowchart angeben.',
    INVALID_FLOWCHART: 'Ungültiger Flowchart',
    IS_DANKE_MESSAGE_SAVED:
      'Bitte speichern Sie die "Danke" Nachricht im Tab "Automatisierung"',
    IS_SPRACHE_MESSAGE_SAVED:
      'Bitte speichern Sie die "Sprache" Nachricht im Tab "Automatisierung"',
    IS_CVUpload_MESSAGE_SAVED:
      'Bitte speichern Sie die "CV Upload" Nachricht im Tab "Automatisierung"',
    STELLENANZEIGE_ERSTELLEN_MESSAGE:
      'Deine Änderungen in den Fragen konnten im Flowchart nicht übernommen werden. Bitte überprüfe den Flowchart.',
    ADD_END_SESSION_NODE_MESSAGE:
      'Füge ein End Session Node im Flowchart hinzu!',
    DELETE_MESSAGE: 'Möchten Sie wirklich die Nachricht löschen: ',
    NEED_TO_ADD_END_SESSION: 'Add an end session node to your workflow',
    ERROR_WHEN_OPEN_APPLICANT: 'Fehler beim Öffnen des Bewerbers',
    UPDATE_JOB_ADVERTISEMENT: 'Stellenanzeige aktualisieren',
    PUBLISH: 'Veröffentlichen',
    ASK_QUESTIONS_PROMT:
      'Hast du noch Fragen an mich? Du kannst die Fragen jetzt stellen. Nutze dazu das Textfeld oder die Spracheingabe.',
    JOB_AD_TEXT:
      'Unten ist der Text für eine Stellenausschreibung. Welche Fragen würden Sie einem Bewerber stellen, um festzustellen, ob er die Anforderungen für die Stellenausschreibung erfüllt? Formulieren Sie maximal 10 Fragen und geben Sie an, ob es sich um eine Ja-, Nein- oder Eingabefeldfrage handelt: ',
    CLICK_TO_SEE_IMAGE: 'Bild ansehen',
    MESSAGE_AFTER_EDIT_QUESTION_TYPE:
      'Sie haben den Fragetyp geändert. Bitte überprüfen Sie das Flussdiagramm.',
    CANT_DELETE_LAST_LINK:
      'Sie können den letzten Link nicht löschen. Das Flussdiagramm muss mindestens einen Link enthalten.',
    FLOWCHART_START_NODE_MULTIPLE_EDGES:
      'Flussdiagramm mit mehreren Links vom Startknoten ist kein gültiges Flussdiagramm.',
    // flowchart.ts
    selectLocation: 'Standort auswählen',
    Handynummer: 'Handynummer',
    Abschicken: 'Abschicken',
    DELETE_FLOWCHART: 'Flowchart wirklich löschen?',
    EXISTIERT_BEREITS: 'existiert bereits',
    KNOTEN_HINZUFUGEN: 'Knoten hinzufügen',
    VERBINDUNG_AKTUALISIEREN: 'Verbindung aktualisieren',
    LINK_UPDATE_WITH_INVALID_ANSWER:
      'Linkaktualisierung mit ungültiger Nachrichtenantwort ist nicht erlaubt.',
    MESSAGE_MULTIPLE_LINKS_WITH_SAME_VALUE_AND_SAME_CONDITION:
      'Mehrere Links von demselben Knoten mit identischer Antwort und Bedingung sind ungültig.',
    REACTIVATING_JOB_OFFER_CONTAINS_DELETED_WORKFLOW:
      'Die Reaktivierung der Stellenausschreibung enthält einen gelöschten Workflow. Bitte korrigieren Sie den Workflow und versuchen Sie es erneut.',

    ReloadAutoSaveData:
      'Möchten Sie die automatisch gespeicherten Daten laden?',
    MessageExist: 'Die Nachricht existiert bereits',
    MessageExistInfo:
      'Die Nachricht existiert bereits im Flowchart. Bitte löschen Sie sie und erstellen Sie sie erneut.',
    MessageNotExist: 'Die Nachricht existiert nicht',
    MessageNotExistInfo: 'Die Nachricht wurde den Fragen nicht hinzugefügt.',
    CanNotConnect: 'kann nicht mit einer Condition verbunden werden',
    MustHaveCondition: 'muss eine Condition haben',
    ConditionNotWithYesNoMessage:
      'Condition kann nicht mit Ja/Nein-Nachricht verbunden werden',
    ConditionNotWithSingleMultiMessage:
      'Condition kann nicht mit Einzelauswahl/Mehrfachauswahl oder Dokument-Upload-Nachricht verbunden werden',
    ConditionWithValue: 'Condition mit dem Wert',
    DoesNotExistInMessage: 'existiert nicht in der Nachricht',
    ConditionWithYesNoMessage:
      'Condition kann nur mit Ja/Nein-Nachricht verbunden werden',
    ConditionWithSingleMultiMessage:
      'Condition kann nur mit Einzelauswahl/Mehrfachauswahl oder Dokument-Upload-Nachricht verbunden werden',
    ConditionNotWithStart:
      'Condition kann nicht mit Start-Nachricht verbunden werden',
    SourceOfConditionNotExist: 'Quelle der Condition existiert nicht',
    ConditionOneMessage:
      'Condition kann nur mit einer Nachricht verbunden werden',
    doesNotExist: 'existiert nicht',
    HasAnotherSource: 'hat eine andere Quelle',
    HasAlreadyCondition: 'hat bereits eine Condition',
    HasConnectWithCurrentCondition:
      'ist bereits mit der aktuellen Condition verbunden',
    CanNotConnectYesNoCondition:
      'kann nicht mit Ja- oder Nein-Condition verbunden werden',
    NotYesNoMessage: 'ist keine Ja/Nein-Nachricht',
    NotSingleMultiMessage:
      'ist keine Einzelauswahl/Mehrfachauswahl oder Dokument-Upload-Nachricht',
    ConditionWithOtherTarget:
      'Condition wurde bereits mit einem anderen Ziel verbunden',
    ActionWithOtherTarget:
      'Aktion wurde bereits mit einem anderen Ziel verbunden',
    StartNotAsTarget: 'Start-Nachricht kann nicht als Ziel verbunden werden',
    EndNotAsSource:
      'Sitzungsende-Nachricht kann nicht als Quelle verbunden werden',
    NotLoop:
      'Es konnte keine Verbindungsschleife zwischen zwei Nachrichten erstellt werden',
    MessageWithOtherTarget:
      'Nachricht wurde bereits mit einem anderen Ziel verbunden',
    ConditionNotWithCondition:
      'Condition kann nicht mit einer anderen Condition verbunden werden',
    ActionConditiontarget:
      'Aktion kann nicht mit einer Condition als Ziel verbunden werden',
    ActionNotWithAction:
      'Aktion kann nicht mit einer anderen Aktion als Ziel verbunden werden',
    ConditionBetweenMessageCondition:
      'Condition kann nicht zwischen Nachricht und Condition verbunden werden',
    ActionBetweenMessageCondition:
      'Aktion kann nicht zwischen Nachricht und Condition verbunden werden',
    ActionBetweenMessageAction:
      'Aktion kann nicht zwischen Nachricht und Aktion verbunden werden',
    ActionBetweenConditionCondition:
      'Aktion kann nicht zwischen Condition und Condition verbunden werden',
    ActionBetweenConditionAction:
      'Aktion kann nicht zwischen Condition und Aktion verbunden werden',
    ConditionNotWithAction:
      'Condition kann nicht mit einer Aktion verbunden werden',
    StandaloneNotUsed:
      'Einige eigenständige Nachrichten wurden nicht verwendet',
    StandaloneNotUsedSaveDelete:
      'Möchten Sie diese ungenutzten eigenständigen Nachrichten speichern oder löschen?',
    AnswerOptionsNotUsed:
      'Einige Antwortmöglichkeiten sind nicht verbunden',
    AnswerOptionsNotUsedInfo:
      'Folgende Antwortmöglichkeiten sind nicht über eine Condition mit einer anderen Nachricht verbunden:',
    AnswerOptionsNotUsedContinue:
      'Möchten Sie das Stellenangebot trotzdem speichern?',
    SwitchToFlowchart: 'Bitte wechseln Sie zum Reiter Flowchart',
    SwitchToFlowchartInfo:
      'Wenn Sie das aktuelle Stellenangebot speichern möchten, wechseln Sie bitte zum Reiter Flowchart.',
    MessageNoConnection: 'Einige Nachrichten wurden nicht verbunden',
    ConnectAllMessage: 'Bitte verbinden Sie alle Nachrichten.',
    MessageConditionActionError:
      'Einige Nachrichten, Conditionen oder Aktionen enthalten Fehler',
    MessageConditionActionErrorInfo:
      'Bitte überprüfen Sie alle Nachrichten, Conditionen und Aktionen.',
    LineError: 'Einige Verbindungen enthalten Fehler',
    LineErrorInfo: 'Bitte überprüfen Sie alle Verbindungen.',
    FlowchartEmpty: 'Flowchart ist leer',
    FlowchartEmptyInfo: 'Flowchart darf nicht leer sein.',
    SelectMode: 'Auswahlmodus',
    DragMode: 'Ziehen-Modus',
    UndoMessage: 'Nachricht rückgängig machen',
    RedoMessage: 'Nachricht wiederherstellen',
    UndoFlowchart: 'Flowchart rückgängig machen',
    RedoFlowchart: 'Flowchart wiederherstellen',
    ZoomOut: 'Verkleinern',
    ZoomIn: 'Vergrößern',
    RemoveFlowchart: 'Flowchart entfernen',
    AddNewFlowchart: 'Neues Flowchart hinzufügen',
    CreateANewNode: 'Neuen Knoten erstellen',
    FullScreenMode: 'Vollbildmodus',
    DuplicateFlowchart: 'Aktuelles Flowchart duplizieren',
    ResetFlowchart: 'Aktuelles Flowchart zurücksetzen',
    SameSourceTarget: 'Die Quelle und das Ziel dürfen nicht gleich sein.',
    ConditionActionOrderWrong:
      'Die Reihenfolge von Condition oder Aktion ist falsch.',
    ConditionSameValue:
      'Die Condition hat denselben Wert wie die andere Condition.',
    RemoveFailedMessage:
      'Bitte entferne die fehlgeschlagenen Nachrichten im Flussdiagramm, bevor du einen neuen Knoten hinzufügst.',
    BothMessageSame:
      'Beide Nachrichten sind identisch, bitte entferne eine davon.',
    // matching.ts
    SearchInAllColumns: 'Suche in allen Spalten...',
    AnalysiereAnzeigenMitAI: 'Analysiere Anzeigen mit AI',
    AnalysiereKandidatenMitAI: 'Analysiere Kandidaten mit AI',
    StartMatchesWithAI: 'Starte Matches mit AI',
    BlacklistAbgleichen: 'Blacklist abgleichen',
    Matches: 'Matches',
    Beschäftigungsgruppe: 'Beschäftigungsgruppe',
    Quote: 'Quote',
    keineMatchesText: 'Keine Matches gefunden',

    //applicants-downloader.html
    AngabenZurPerson: 'Angaben zur Person',
    Geschlecht: 'Geschlecht',
    Adresse: 'Adresse',
    Geburtsland: 'Geburtsland',
    Geburtsort: 'Geburtsort',
    Staatsangehörigkeit: 'Staatsangehörigkeit',
    Sprachen: 'Sprachen',
    BestätigungscodeSMS: 'Bestätigungscode SMS',
    EmailBestätigt: 'Email bestätigt',
    KFZ: 'KFZ',
    Führerschein: 'Führerschein',
    EMailVonMONAGesendet: 'E-Mail von MONA gesendet',
    SMSVonMONAGesendet: 'SMS von MONA gesendet',
    TelefonanrufVonMONAGesendet: 'Telefonanruf von MONA gesendet',
    Ausbildung: 'Sprachtest',
    Monate: 'Monate',
    Abschluss: 'Abschluss',
    höchsterAbschluss: 'höchster Abschluss',
    Hauptschulabschluss: 'Hauptschulabschluss',
    MittlereReife: 'Mittlere Reife',
    OhneAbschluss: 'Ohne Abschluss',
    Abitur: 'Abitur',
    höchsteAusbildung: 'höchste Ausbildung',
    ohneAusbildung: 'ohne Ausbildung',
    Berufsausbildung: 'Berufsausbildung',
    mitAbschluss: 'mit Abschluss',
    Bachelor: 'Bachelor',
    Promotion: 'Promotion',
    Diplom: 'Diplom',
    Meister: 'Meister',
    Bemerkungen: 'Bemerkungen',
    Qualifikationen: 'Qualifikationen',
    Vorschläge: 'Vorschläge',
    Match: '- Match',
    Berufserfahrung: 'Berufserfahrung',
    Sprachtest: 'Sprachtest',
    GrammatikUndSatzbau: 'Grammatik und Satzbau',
    Wortschatz: 'Wortschatz',
    KohärenzUndKlarheit: 'Kohärenz und Klarheit',
    Anmerkungen: 'Anmerkungen',
    Talent360Info: 'Talent360 Info',
    Einsatzort: 'Einsatzort',
    Kandidat: 'Kandidat',
    BewerberLog: 'Bewerber Log',
    MonaLog: 'MONA Log',
    TranskriptionDesVideos: 'Transkription des Videos.',
    VideoAntwort: 'Video Antwort',
    TranskriptionDesAudios: 'Transkription des Audios.',
    EigeneFelder: 'Eigene Felder',
    EinstellungstestErgebnisse: 'Einstellungstest Ergebnisse',
    Punkte: 'Punkte',
    Aufgabe: 'Aufgabe',
    erreichtePunkte: 'erreichte Punkte',
    keineDatenVorhanden: 'keine Daten Vorhanden',

    //applicant-info.html
    Schließen: 'Schließen',
    Archivieren: 'Archivieren',
    Editieren: 'Editieren',
    Exportieren: 'Exportieren',
    EinstellungstestSenden: 'Einstellungstest senden',
    VertragErstellen: 'Vertrag erstellen',
    SendeDokumentAnBewerber: 'Sende Dokument an Bewerber',
    KomplettPDFAbrufen: 'Komplett-PDF abrufen',
    ProzessStarten: 'Prozess starten',
    Stufe2: 'Stufe 2',
    Stufe3: 'Stufe 3',
    Handy: 'Handy',
    Anruf: 'Anruf',
    LogAlsPDFExportieren: 'Log als PDF exportieren',
    VideoAnsehen: 'Video ansehen',
    eigenesFeldErgänzen: 'eigenes Feld ergänzen',
    Dateien: 'Dateien',
    Dateiname: 'Dateiname',
    EMailSchicken: 'E-Mail schicken',
    SMSSchicken: 'SMS schicken',
    anrufenLassen: 'anrufen lassen',
    KundeWarSehrZufrieden: 'Kunde war sehr zufrieden...',
    abgeschlosseneBerufsausbildungAlsMechaniker:
      'abgeschlossene Berufsausbildung als Mechaniker...',
    Erfahrung: 'Erfahrung',
    zehnJahreErfahrung: '10 Jahre Erfahrung...',
    Unternehmen: 'Unternehmen',
    FieldName: 'Feld Name',
    FieldValue: 'Feld Wert',
    Remove: 'Entfernen',
    FeldErgänzen: 'Feld ergänzen',
    Submit: 'Bestätigen',
    DateiHierherZiehen: 'Datei hierher ziehen',
    ProfilErstellt: 'Profil erstellt',
    noData: 'Keine Daten verfügbar',
    erfolg: 'Erfolg',
    fehler: 'Fehler',
    dateDesc: 'Datum (Absteigend)',
    dateAsc: 'Datum (Aufsteigend)',
    typeDesc: 'Typ (Absteigend)',
    typeAsc: 'Typ (Aufsteigend)',

    //applicants.html
    ArchivierteAusblenden: 'Archivierte ausblenden',
    ArchivierteAnzeigen: 'Archivierte anzeigen',
    AlleZeigen: 'Alle zeigen',
    nichtAlleZeigen: 'nicht alle zeigen',
    Schnellerfassung: 'Schnellerfassung',
    BewerberInDenLetzten30Tagen: 'Bewerber in den letzten 30 Tagen',
    LadeAlle: 'Lade Alle',
    exportExcel: 'Export Excel',
    exportToExcelAlle: 'Export nach Excel - Alle',
    applicantReactivatedSuccessfully: 'Bewerber erfolgreich reaktiviert',
    applicantArchivedSuccessfully: 'Bewerber erfolgreich archiviert',
    systemStatus: 'System Status',

    //reporting.html
    ReportingErstellen: 'Reporting erstellen',
    erstellen: 'Erstellen',
    Export: 'Export',
    OneWeek: 'Woche',
    keineReportingText: 'Keine reporting gefunden',
    BitteWählenSieEinZeitraum: 'Bitte wählen Sie ein Zeitraum',
    //upload.html
    BewerberExcelImport: 'Bewerber Excel-Import',
    IndexStellenanzeigen: 'Index Stellenanzeigen',
    TalentionUpload: 'Talention Upload',
    IndexUpload: 'Index Upload',
    BewerberUpload: 'Bewerber Upload',
    ExcelStandardVorlageDownloaden: 'Excel-Standard-Vorlage downloaden',
    BewerberKontaktieren: 'Bewerber kontaktieren',
    BewerberÜbernehmen: 'Bewerber übernehmen',
    BewerberImportListe: 'Bewerber-Import Liste',
    Bewerberin: 'Bewerber/in',
    Mobilnummer: 'Mobilnummer',
    TalentionDatenHochladen: 'Talention Daten hochladen',
    wurdenAusgelesenUndAnalysiertMitKI:
      'wurden ausgelesen und analysiert mit KI',
    IndexAnzeigendatenJSONUpload: 'Index Anzeigendaten JSON Upload',
    Hochladen: 'Hochladen',
    IndexAnzeigendatenJSONUploadError:
      'JSON-Datei kann nicht verarbeitet werden',
    DateiErfolgreichHochgeladen: 'Datei erfolgreich hochgeladen',
    DateiErfolgreichHochgeladenMessage:
      'Es kann bis zu 60 Sekunden zur vollständigen Verarbeitung dauern',
    MandantAuswählen: 'Mandant auswählen',
    MatchingEinstellungen: 'Matching-Einstellungen',
    FragenSuchen: 'Fragen suchen',
    StandardFragen: 'Standard Fragen',
    EigeneFragen: 'Eigene Fragen',
    ausgewählte: 'ausgewählte',
    AusgewählteFragenSpeichern: 'Ausgewählte Fragen speichern',
    //applicant-email.html
    EmailAutomatisierungfuerBewerber:
      'Email Automatisierung für Bewerber - Interviews',
    Modelauswaehlen: 'Modell auswählen',
    Vorlage: 'Vorlage',
    Testmail: 'Testmail',
    TestmailAnSchicken: 'Testmail schicken an',
    BewerberDaten: 'Bewerber-Daten',
    BewerberDatenAbrufen: 'Bewerber-Daten abrufen',
    BewerberImport: 'Bewerber-Import',
    BewerberDatenHochladen: 'Bewerber-Daten hochladen',
    VideosGenerierenFuer: 'Videos generieren für',
    AlleEmailsSchicken: 'Alle Emails schicken',

    //data-warehouse.html
    SelectAndConnectEndpoints: 'Endpunkte auswählen und verbinden',
    SelectSourceEndpoint: 'Wählen Sie Quellendpunkt aus',
    SelectDestinationEndpoint: 'Wählen Sie Zielendpunkt aus',
    ConnectEndpoints: 'Endpunkte verbinden',

    //settings.html
    DatenImport: 'Daten Import',
    DataWarehouse: 'Data Warehouse',
    Integrationen: 'Integrationen',
    Blacklist: 'Blacklist',
    BewerberLeadgenerierung: 'Bewerber-Leadgenerierung',
    KundenLeadgenerierung: 'Kunden-Leadgenerierung',
    KIStudio: 'KI-Studio',
    SucheNachNameOderAktionOderMedium:
      'Suche nach Name oder Aktion oder Medium',

    //agent-edit.html
    Agentbearbeiten: 'Agent bearbeiten',
    AgentennamenEingeben: 'Agentennamen eingeben',
    Ausführungsrhythmus: 'Ausführungsrhythmus',
    WähleRhythmus: 'Wähle den Rhythmus',
    Manuell: 'Manuell',
    Wöchentlich: 'Wöchentlich',
    CustomInterval: 'Benutzerdefiniertes Intervall',
    ZeitfürtäglicheAusführung: 'Zeit für tägliche Ausführung',
    WochentagefürAusführung: 'Wochentage für Ausführung',
    WähleWochentage: 'Wähle Wochentage',
    Montag: 'Montag',
    Dienstag: 'Dienstag',
    Mittwoch: 'Mittwoch',
    Donnerstag: 'Donnerstag',
    Freitag: 'Freitag',
    Samstag: 'Samstag',
    Sonntag: 'Sonntag',
    ZeitfürwöchentlicheAusführung: 'Zeit für wöchentliche Ausführung',
    Intervallbeispiel: 'Intervall (z.B. alle 6 Stunden)',
    IntervallinStunden: 'Intervall in Stunden',
    Aufgabehinzufügen: 'Aufgabe hinzufügen',
    Aufgabentitel: 'Aufgabentitel',
    Aufgabename: 'Aufgabenname',
    Textaufforderung: 'Textaufforderung',
    AngehängtesDokument: 'Angehängtes Dokument',
    agentUpdateSuccessText: 'Agent erfolgreich aktualisiert.',
    agentUpdateErrorText: 'Fehler beim Aktualisieren des Agenten.',
    agentLoadErrorText: 'Fehler beim Laden der Agenten.',
    agenterstellen: 'Agent erstellen',
    agentSavedSuccessfully: 'Agent erfolgreich gespeichert.',
    agentSaveError: 'Agent konnte nicht gespeichert werden.',
    folderNameRequired: 'Der Ordnername darf nicht leer sein.',

    //blacklist.html
    emailBlacklist: 'E-Mail Blacklist',
    BlacklistanzeigenKunden: 'Blacklist anzeigen Kunden',
    Blacklisthochladen: 'Blacklist hochladen',
    BlacklistLength: 'Kunden auf der Schwarzen Liste',
    emailAdress: 'E-Mail Adresse',
    AddBlacklistMember: 'Blacklist-Mitglied hinzufügen',
    uploadlimit: 'maximal 100 auf einmal hochladen',
    uploadInstruction:
      'bei großen Uploads eine E-Mail schicken an support@mona-ai.de mit der Datei im JSON, Excel oder csv-Format',
    Clear: 'Leeren',
    Neuhochgeladen: 'Neu hochgeladen wurden: ',
    noDataFound: 'keine Daten gefunden',
    noNewEntriesFound: 'keine neuen Einträge gefunden',
    uploadTooManyEntries:
      'mehr als 100 Einträge. Liste wird nicht hochgeladen. Bitte nur neue Einträge hochladen.',
    searchPlaceholder: 'Suchwort eingeben',
    notInBlacklistYet: ' ist noch nicht in Blacklist enthalten',
    discardChanges: 'Änderungen verwerfen?',
    wirdNichtGespeichert: 'Änderungen werden verworfen und nicht gespeichert.',
    discard: 'Verwerfen',
    searchRequirement: 'Suchanforderung',
    searchMinimumChars: 'Bitte geben Sie mindestens 3 Zeichen ein, um zu suchen',
    searching: 'Suche läuft...',
    searchError: 'Fehler beim Suchen aufgetreten. Bitte versuchen Sie es erneut.',
    uploading: 'Hochladen...',
    uploadSuccess: 'Upload erfolgreich',
    newEmailsAdded: 'Neue E-Mails hinzugefügt',
    duplicatesSkipped: 'Duplikate übersprungen',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    checking: 'Überprüfung läuft...',
    emailExists: 'E-Mail existiert bereits',
    emailAlreadyInBlacklist: 'Diese E-Mail ist bereits in der Blacklist',
    adding: 'Hinzufügen...',
    emailAddedSuccessfully: 'E-Mail erfolgreich zur Blacklist hinzugefügt',
    errorAddingEmail: 'Fehler beim Hinzufügen der E-Mail zur Blacklist',
    enterEmail: 'E-Mail-Adresse eingeben',
    addToBlacklist: 'Zur Blacklist hinzufügen',
    addEmailInfo: 'Geben Sie eine gültige E-Mail-Adresse ein, um sie zur Blacklist hinzuzufügen. E-Mails auf der Blacklist werden automatisch herausgefiltert.',
    searchButtonNotice: 'Geben Sie mindestens 3 Zeichen ein und klicken Sie auf die Suchen-Schaltfläche',
    maxShown: 'max. angezeigt',
    bulkUploadGuide: 'Bulk-Upload-Anleitung',
    overview: 'Übersicht',
    bulkUploadOverview: 'Laden Sie bis zu 100 E-Mail-Adressen auf einmal über Datei-Upload oder manuelle Texteingabe hoch.',
    uploadMethods: 'Upload-Methoden',
    method1FileUpload: 'Methode 1: Datei-Upload (Empfohlen)',
    supportedFormats: 'Unterstützte Formate',
    excelFormat: 'Excel-Format',
    excelFormatDesc: 'E-Mails in die erste Spalte eintragen, eine pro Zeile',
    steps: 'Schritte',
    fileUploadSteps: '1) Klicken Sie auf "Datei auswählen" 2) Wählen Sie Ihre Datei aus 3) Klicken Sie auf Upload-Button',
    method2ManualEntry: 'Methode 2: Manuelle Texteingabe',
    manualEntryDesc: 'Geben Sie E-Mails direkt in das Textfeld unten ein oder fügen Sie sie ein',
    format: 'Format',
    oneEmailPerLine: 'Eine E-Mail pro Zeile, keine Leerzeichen, muss @ und . enthalten',
    importantRules: 'Wichtige Regeln',
    rule1: 'Maximal 100 E-Mails pro Upload',
    rule2: 'E-Mails müssen @ und . Symbole enthalten',
    rule3: 'Keine Leerzeichen in E-Mail-Adressen erlaubt',
    rule4: 'Duplikate werden automatisch übersprungen',
    rule5: 'Für größere Uploads kontaktieren Sie support@mona-ai.de',
    exampleFormat: 'Beispielformat',
    chooseUploadMethod: 'Upload-Methode wählen',
    fileUpload: 'Datei-Upload',
    supportedFiles: 'Unterstützt: .xlsx, .xls, .json Dateien',
    manualEntry: 'Manuelle Eingabe',
    manualEntryPlaceholder: 'E-Mail-Adressen eingeben, eine pro Zeile:\nexample1@domain.com\nexample2@company.org\nexample3@website.net',


    //interview-cohorts
    InterviewCohorts: 'Interview-Kohorten',
    DropoutAnalysis: 'Abbruchanalyse',
    ApplicantFlow: 'Bewerberfluss',
    applicants: 'Bewerber',
    droppedOff: 'abgebrochen',
    completed: 'abgeschlossen',
    CriticalDropoutZone: 'Kritische Abbruchzone',
    ModerateDropoutZone: 'Moderate Abbruchzone',
    LowDropoutZone: 'Geringe Abbruchzone',
    DropoffRate: 'Abbruchrate',
    Stage: 'Phase',
    Total: 'Gesamt',
    Dropped: 'Abgebrochen',
    Completed: 'Abgeschlossen',
    ApplicantsWhoDroppedOffAt: 'Bewerber, die abgebrochen haben bei',
    InterviewDropoutAnalysis: 'Interview-Abbruchanalyse',

    InterviewCohortsProcessFlow: 'Interviewprozess-Fluss',
    InterviewCohortsDropoutAnalysis: 'Abbruchanalyse - Wo Bewerber aussteigen',
    InterviewCohortsDropoffByQuestion: 'Abbruch nach Frage',
    InterviewCohortsTotalApplicants: 'Gesamtzahl der Bewerber',
    InterviewCohortsQuestion: 'Frage',
    InterviewCohortsApplicants: 'Bewerber',
    InterviewCohortsDropoff: 'Abbruch',
    InterviewCohortsNoData: 'Keine Interviewdaten für den ausgewählten Zeitraum verfügbar',
    InterviewCohortsNumberOfApplicants: 'Anzahl der Bewerber',
    InterviewCohortsApplicantsDroppedOff: 'Bewerber, die abgebrochen haben',
    InterviewCohortsShowCancellations: 'Abbrüche anzeigen',
    InterviewCohortsHideCancellations: 'Abbrüche ausblenden',
    InterviewCohortsCancellation: 'Abbruchpunkt',

    AgentDashboardThinkingMode: 'Denkmodus',
    AgentDashboardInternetMode: 'Internet-Modus',
    AgentDashboardTools: 'Tools',
    AgentDashboardThinking: 'Denken',
    AgentDashboardInternet: 'Internet',
    AgentDashboardBrowserAutomationTitle: 'Browser-Automatisierung',
    AgentDashboardMemory: 'Erinnerung',
    AgentDashboardFeedback: 'Feedback',
    AgentDashboardBrowserAutomationToolTitle: 'Browser-Automatisierungstool',
    AgentDashboardSalesforceUpdate: 'Salesforce-Aktualisierung',
    AgentDashboardPremiumFeature: 'Premium-Funktion',
    AgentDashboardUpgrade: 'Upgrade',
    AgentDashboardLegalNoticeSms: 'SMS',
    AgentDashboardLegalNoticeEmail: 'E-Mail',
    AgentDashboardFileTypeImage: 'Bild',
    AgentDashboardFileTypeDocument: 'Dokument',
    AgentDashboardFileTypeCode: 'Code',
    AgentDashboardFileTypeData: 'Daten',
    AgentDashboardFileTypeSpreadsheet: 'Tabelle',
    AgentDashboardFileTypeFile: 'Datei',
    AgentDashboardCsvHeaderName: 'Name',
    AgentDashboardDefaultToolName: 'Tool',
    AgentDashboardBrowserAutomationName: 'Browser-Automatisierung',
    AgentDashboardGeneralAssistant: 'Allgemeiner KI-Assistent',
    AgentDashboardDefaultSystemPrompt: 'Sie sind ein hilfreicher KI-Assistent.',
    AgentDashboardOK: 'OK',

    // Workspace translations
    WorkspaceTitle: "Felix's Workspace",
    WhatsOnYourMind: "What's on your mind today?",
    NewIdeas: '12 new ideas',
    CheckingQuestions: 'Checking questions…',
    AIEmployees: 'AI Employees',

    // Agent names
    AgentFields: 'Fields',
    AgentVine: 'Vine',
    AgentBuzz: 'Buzz',
    AgentCedar: 'Cedar',
    AgentFinn: 'Finn',
    AgentOliver: 'Oliver',
    AgentBloom: 'Bloom',
    AgentMarket: 'Market',
    AgentSparkle: 'Sparkle',
    AgentFeast: 'Feast',
    AgentSugar: 'Sugar',
    AgentSwift: 'Swift',
    AgentGreen: 'Green',
    AgentEco: 'Eco',
    AgentSpark: 'Spark',
    AgentFlow: 'Flow',
    AgentMason: 'Mason',
    AgentArtie: 'Artie',
    AgentRidge: 'Ridge',
    AgentBrick: 'Brick',
    AgentTile: 'Tile',
    AgentCool: 'Cool',
    AgentCycle: 'Cycle',
    AgentCraft: 'Craft',
    AgentStitch: 'Stitch',
    AgentGem: 'Gem',
    AgentDough: 'Dough',
    AgentGourmet: 'Gourmet',
    AgentForge: 'Forge',
    AgentClay: 'Clay',
    AgentWeave: 'Weave',
    AgentGuard: 'Guard',

    // Agent roles
    RoleFarmer: 'Farmer',
    RoleVineyardOwner: 'Vineyard Owner',
    RoleBeekeeper: 'Beekeeper',
    RoleForester: 'Forester',
    RoleFishFarmer: 'Fish Farmer',
    RoleOrganicFarmer: 'Organic Farmer',
    RoleHorticulturist: 'Horticulturist',
    RoleMarketTrader: 'Market Trader',
    RoleCleaningServiceProvider: 'Cleaning Service Provider',
    RoleCaterer: 'Caterer',
    RolePastryChef: 'Pastry Chef',
    RoleCourierServiceOperator: 'Courier Service Operator',
    RoleLandscapingServiceOwner: 'Landscaping Service Owner',
    RoleWasteManagementContractor: 'Waste Management Contractor',
    RoleElectrician: 'Electrician',
    RolePlumber: 'Plumber',
    RoleCarpenter: 'Carpenter',
    RolePainterAndDecorator: 'Painter and Decorator',
    RoleRoofer: 'Roofer',
    RoleBricklayer: 'Bricklayer',
    RoleTiler: 'Tiler',
    RoleHVACTechnician: 'HVAC Technician',
    RoleBicycleRepairTechnician: 'Bicycle Repair Technician',
    RoleFurnitureMaker: 'Furniture Maker',
    RoleTailor: 'Tailor',
    RoleJeweler: 'Jeweler',
    RoleBaker: 'Baker',
    RoleSpecialtyFoodProducer: 'Specialty Food Producer',
    RoleMetalworker: 'Metalworker',
    RoleCeramicist: 'Ceramicist',
    RoleTextileManufacturer: 'Textile Manufacturer',
    RoleSecurityServicesContractor: 'Security Services Contractor',
    MehrErfahren: 'Mehr erfahren',
    HilfeNichtVerfügbar: 'Hilfe für diesen Bereich ist nicht verfügbar.',
    HelpDashboardOverview: 'Das Dashboard zeigt Ihnen eine Übersicht über Ihre wichtigsten Kennzahlen, aktuelle Stellenanzeigen und Bewerbungen.',
    HelpJobOfferTitle: 'Geben Sie hier den Titel Ihrer Stellenanzeige ein. Dieser wird in Suchergebnissen und auf Ihrer Karriereseite angezeigt.',
    HelpJobOfferLanguage: 'Wählen Sie die Hauptsprache für Ihre Stellenanzeige. Diese bestimmt die Sprache der automatisch generierten Inhalte.',
    HelpJobOfferAvatar: 'Wählen Sie einen Avatar für Ihre KI-generierten Videos aus. Der Avatar wird Ihre Stellenanzeige präsentieren.',
    HelpApplicantFiltering: 'Nutzen Sie die Filter, um Bewerber nach Status, Qualifikationen oder anderen Kriterien zu sortieren.',
    HelpWorkflowBasic: 'Grundlegende Workflows automatisieren einfache Aufgaben wie E-Mail-Versendung bei Bewerbungseingang.',
    HelpWorkflowAdvanced: 'Erweiterte Workflows bieten komplexe Automatisierung mit Bedingungen und mehreren Aktionen.',
    HelpReportingFilters: 'Verwenden Sie die Filter, um Berichte für bestimmte Zeiträume und Stellenanzeigen zu erstellen.',
    HelpProfileSettings: 'Hier können Sie Ihre Unternehmenseinstellungen, Sprache und Integrationen konfigurieren.',
    HelpDashboardCommunication: 'Übersicht über versendete E-Mails, SMS und Anrufe im Verhältnis zu verfügbaren Kontingenten.',
    HelpDashboardWorkflows: 'Zeigt aktive Workflows im Verhältnis zur maximalen Anzahl verfügbarer Workflows.',
    HelpDashboardApplicants: 'Zeigt die Anzahl der Bewerber im Verhältnis zum maximalen Limit an.',
    TooltipExportApplicants: 'Export selected applicant data as Excel file for reporting and analysis',
    TooltipReloadApplicants: 'Reload the applicant list and refresh all data',
    TooltipArchiveApplicants: 'Archive selected applicants for long-term retention',
    TooltipDeleteApplicants: 'Permanently delete selected applicants from the system',
    TooltipExportJobOffers: 'Export job offers as JSON file for system integration',
    TooltipReloadJobOffers: 'Reload the job offers list and refresh all data',
    TooltipReactivateJobOffers: 'Reactivate accidentally deleted job offers',
    TooltipDeleteJobOffers: 'Permanently delete selected job offers',
    TooltipShowContracts: 'Open direct access to legal documents and contracts',
    TooltipImportJobOffers: 'Import job offers from JSON files for system integration',
    TooltipCreateJobOffer: 'Create new job offers for open positions',
    TooltipExportAllApplicants: 'Export all applicant data as Excel file',
    TooltipFilterApplicants: 'Use filters to sort and manage applicants by status and criteria',
    reload: 'Neu Laden',
    MitInterview: 'Mit Interview',
    Einzelkontaktierung: 'Einzelkontaktierung',

    StaffingConsultant: "Personalberatung",
    ProjectManagement: "Projektmanagement",
    ProblemInput: "Problem-Eingabe",
    ServicePackages: "Service-Pakete",
    KPIDashboard: "KPI-Dashboard",
    ManageCustomerProjects: "Kundenprojekte verwalten",
    CreateNewProject: "Neues Projekt erstellen",
    ProjectName: "Projektname",
    Customer: "Kunde",
    ProjectStatus: "Status",
    Created: "Erstellt",
    EstimatedCost: "Geschätzte Kosten",
    Duration: "Dauer",
    Days: "Tage",
    Actions: "Workflows",
    Conditions: "Bedingungen",
    DescribeCustomerProblem: "Kundenproblem beschreiben",
    Category: "Kategorie",
    ProblemTitle: "Problem-Titel",
    ProblemDescription: "Problem-Beschreibung",
    Urgency: "Dringlichkeit",
    Low: "Niedrig",
    High: "Hoch",
    Critical: "Kritisch",
    Budget: "Budget",
    Timeline: "Zeitplan",
    Analyzing: "Analysiere...",
    AnalyzeProblem: "Problem analysieren",
    AIRecommendations: "KI-Empfehlungen",
    Confidence: "Vertrauen",
    CreateProject: "Projekt erstellen",
    ServicePackageBuilder: "Service-Paket-Builder",
    CreateCustomServicePackages: "Benutzerdefinierte Service-Pakete erstellen",
    PackageName: "Paket-Name",
    Description: "Beschreibung",
    AIServices: "KI-Services",
    HumanServices: "Human-Services",
    AvailableAIServices: "Verfügbare KI-Services",
    SelectedAIServices: "Ausgewählte KI-Services",
    AvailableHumanServices: "Verfügbare Human-Services",
    SelectedHumanServices: "Ausgewählte Human-Services",
    PackageSummary: "Paket-Zusammenfassung",
    TotalCost: "Gesamtkosten",
    SavePackage: "Paket speichern",
    SavedPackages: "Gespeicherte Pakete",
    ProjectPerformanceMetrics: "Projekt-Leistungsmetriken",
    Refresh: "Aktualisieren",
    ExportReport: "Bericht exportieren",
    TotalProjects: "Gesamtprojekte",
    ActiveProjects: "Aktive Projekte",
    CompletedProjects: "Abgeschlossene Projekte",
    TotalRevenue: "Gesamtumsatz",
    AvgDuration: "Durchschn. Dauer",
    SuccessRate: "Erfolgsrate",
    MonthlyProjects: "Monatliche Projekte",
    RevenueOverTime: "Umsatz im Zeitverlauf",
    Projects: "Projekte",
    Revenue: "Umsatz",
    ProjectDetails: "Projektdetails",
    ProjectInformation: "Projektinformationen",
    ActualCost: "Tatsächliche Kosten",
    ActualDuration: "Tatsächliche Dauer",
    Tasks: "Aufgaben",
    AddTask: "Aufgabe hinzufügen",
    NoTasksYet: "Noch keine Aufgaben",
    AddFirstTask: "Erste Aufgabe hinzufügen",
    TaskName: "Aufgabenname",
    AssignedTo: "Zugewiesen an",
    EstimatedHours: "Geschätzte Stunden",
    ActualHours: "Tatsächliche Stunden",
    DueDate: "Fälligkeitsdatum",
    CompletedDate: "Abschlussdatum",
    Saving: "Speichere...",
    SaveProject: "Projekt speichern",
    DeleteProject: "Projekt löschen",
    LoadingProject: "Projekt wird geladen...",
    GeschaetzterErtrag: "Geschätzter Ertrag",
    Deckungsbeitrag: "Deckungsbeitrag",
    ProblemAnalysisQuestionnaire: "Problem-Analyse Fragebogen",
    AIAssistantBot: "KI-Assistent Bot",
    YourAnswer: "Ihre Antwort",
    SubmitAnswer: "Antwort absenden",
    Processing: "Verarbeitung...",
    QuestionnaireComplete: "Fragebogen abgeschlossen",
    TaskPipelineGenerated: "Aufgabenpipeline wurde erstellt",
    RecommendationsBasedOnQuestionnaire: "Empfehlungen basierend auf Ihrem Fragebogen",
    RecommendedSolutions: "Empfohlene Lösungen",
    AISolutions: "KI-Lösungen",
    HumanSolutions: "Menschliche Lösungen",
    CreateAIAgent: "KI-Agent erstellen",
    StartRecruiting: "Recruiting starten",
    StartMatching: "Matching starten",
    CreateWorkflow: "Workflow erstellen",

    // Basic Auth and Custom Headers
    BasicAuth: 'Basic Authentication',
    EnableBasicAuth: 'Basic Auth aktivieren',
    Username: 'Benutzername',
    EnterUsername: 'Benutzername eingeben',
    Password: 'Passwort',
    EnterPassword: 'Passwort eingeben',
    CustomHeaders: 'Benutzerdefinierte Header',
    AddHeader: 'Header hinzufügen',
    HeaderKey: 'Header-Schlüssel',
    HeaderValue: 'Header-Wert',
    QuickBearerToken: 'Schnelle Bearer Token Einrichtung',
    EnterBearerToken: 'Bearer Token eingeben',
    SetBearerToken: 'Bearer Token setzen',
    TestConnection: 'Verbindung testen',
    EnterTestURL: 'Test-URL eingeben',
    DealValue: 'Deal-Wert',
    // Enterprise plan restrictions
    EnterpriseFeature: 'Enterprise Feature',
    EnterpriseOnly: 'Nur für Enterprise-Nutzer verfügbar',
    UpgradeToEnterprise: 'Auf Enterprise upgraden',
    // Auto-Recharge translations
    AutoRecharge: 'Auto-Recharge (Pay as You Go)',
    AutoRechargeSettings: 'Auto-Recharge Einstellungen',
    AutoRechargeDescription: 'Aktivieren Sie Auto-Recharge, um automatisch Credits aufzuladen, wenn Ihr Guthaben unter einen bestimmten Schwellenwert fällt.',
    EnableAutoRecharge: 'Auto-Recharge aktivieren',
    RechargeWhenBelow: 'Aufladen wenn Credits unter',
    RechargeAmount: 'Aufladebetrag',
    CurrentCredits: 'Aktuelle Credits',
    AutoRechargeNote: 'Bei aktiviertem Auto-Recharge wird Ihr Konto automatisch belastet, wenn Ihre Credits unter den Schwellenwert fallen.',
    SavingSettings: 'Einstellungen werden gespeichert...',
    SettingsSaved: 'Einstellungen erfolgreich gespeichert',
    ErrorSavingSettings: 'Fehler beim Speichern der Einstellungen',
    AutoRechargeError: 'Auto-Recharge fehlgeschlagen',
    Kalender: 'Kalender',

    WählenSieEineOptionZumErstellenIhresInterviews: 'Wählen Sie eine Option zum Erstellen Ihres Interviews',
    BlankJobOffer: 'Blank',
    VorlagenJobOffer: 'Vorlagen',
    LeeresInterview: 'Leeres Interview',
    ErstellenSieEinNeuesInterviewVonGrundAuf: 'Erstellen Sie ein neues Interview von Grund auf. Perfekt für individuelle Anforderungen und vollständige Kontrolle über alle Details.',
    VollständigeAnpassung: 'Vollständige Anpassung',
    EigeneInhalte: 'Eigene Inhalte',
    FlexibleGestaltung: 'Flexible Gestaltung',
    LeeresInterviewErstellen: 'Leeres Interview erstellen',
    VorlagenDurchsuchen: 'Vorlagen durchsuchen',
    NachVorlagenSuchen: 'Nach Vorlagen suchen...',
    VorlageJobOffer: 'Vorlage',
    InterviewVorlage: 'Interview-Vorlage',
    VorgefertigtesInterviewSchnelleErstellung: 'Vorgefertigtes Interview für schnelle Erstellung',
    AvatarJobOffer: 'Avatar',
    WeiblichJobOffer: 'Weiblich',
    MännlichJobOffer: 'Männlich',
    TerminJobOffer: 'Termin',
    AnspracheJobOffer: 'Ansprache',
    DuJobOffer: 'Du',
    SieJobOffer: 'Sie',
    VerwendenJobOffer: 'Verwenden',
    KeineVorlagenGefunden: 'Keine Vorlagen gefunden',
    VersuechenSieEinenAnderenSuchbegriff: 'Versuchen Sie einen anderen Suchbegriff oder erstellen Sie ein leeres Interview.',
    FehlerBeimErstellenDesInterviews: 'Fehler beim Erstellen des Interviews. Bitte versuchen Sie es erneut.',
    InterviewWurdeErfolgreichErstellt: 'Interview wurde erfolgreich erstellt',
    BitteGebenSieEinenPromptEin: 'Bitte geben Sie einen Prompt ein',
    KeineVorlagenVerfügbar: 'Keine Vorlagen verfügbar',
    BitteWählenSieEineVorlageAus: 'Bitte wählen Sie eine Vorlage aus der Liste aus',
    VideoLimitReached: 'Video-Limit erreicht. Bitte später erneut versuchen oder Support kontaktieren.',
    AIInterviewAktivierenTitel: 'KI-Interview aktivieren?',
    AIInterviewAktivierenText: 'Möchten Sie für dieses Interview KI-Fragen und Ziele konfigurieren?',
    QRCode: 'QR-Code',

    // Rich Email Text Editor
    EditApplicantMessage: 'E-Mail Editor',
    RichEmailEditorVorname: 'Vorname',
    RichEmailEditorNachname: 'Nachname',
    RichEmailEditorFirmenname: 'Firmenname',
    RichEmailEditorInterviewURL: 'Interview URL',
    RichEmailEditorCalendly: 'Kalender URL',
    RichEmailEditorExportHTML: 'Export HTML',
    RichEmailEditorSave: 'Speichern',
    RichEmailEditorBold: 'Fett',
    RichEmailEditorItalic: 'Kursiv',
    RichEmailEditorUnderline: 'Unterstrichen',
    RichEmailEditorInsertImage: 'Bild einfügen',
    RichEmailEditorInsertFirstName: 'Vorname einfügen',
    RichEmailEditorInsertLastName: 'Nachname einfügen',
    RichEmailEditorInsertCompanyName: 'Firmenname einfügen',
    RichEmailEditorInsertInteractionButton: 'Interview-Button einfügen',
    RichEmailEditorInsertCalendlyButton: 'Calendly-Button einfügen',
    RichEmailEditorExportToHTML: 'Als HTML exportieren',
    RichEmailEditorUploadingImage: 'Bild wird hochgeladen...',
    RichEmailEditorPlaceholder: 'Beginnen Sie hier mit der Eingabe Ihrer E-Mail...',
    RichEmailEditorImageUploadError: 'Fehler beim Lesen der Bilddatei. Bitte versuchen Sie es erneut.',
    RichEmailEditorInteractionLinkClicked: 'Link angeklickt! Interview-URL wird vom Backend beim Versenden der E-Mail gesetzt.',
    RichEmailEditorCalendlyLinkClicked: 'Calendly-Link angeklickt! Calendly-URL wird vom Backend beim Versenden der E-Mail gesetzt.',
    RichEmailEditorClickHere: 'Hier klicken',
    RichEmailEditorScheduleMeeting: 'Termin vereinbaren',
    RichEmailEditorStartInterview: 'Interview starten',
    RichEmailEditorTable: 'Tabelle',
    RichEmailEditorInsertTable: 'Tabelle einfügen',
    RichEmailEditorInsertTableCustom: 'Tabelle einfügen...',
    RichEmailEditorInsertTableColumns: 'Spalten:',
    RichEmailEditorInsertTableRows: 'Zeilen:',
    RichEmailEditorIncrease: 'Erhöhen',
    RichEmailEditorDecrease: 'Verringern',
    RichEmailEditorInsertTablePrompt: 'Größe eingeben (Spalten x Zeilen), z.B. 5x3',
    RichEmailEditorInsertTableInvalid: 'Ungültiges Format. Bitte Spalten x Zeilen eingeben, z.B. 5x3',
    RichEmailEditorFontColor: 'Schriftfarbe',
    RichEmailEditorHighlightColor: 'Texthervorhebungsfarbe',
    RichEmailEditorNoColor: 'Keine Farbe',
    RichEmailEditorOtherColors: 'Weitere Farben...',
    RichEmailEditorCustomColor: 'Benutzerdefinierte Farbe',
    RichEmailEditorAlign: 'Ausrichtung',
    RichEmailEditorAlignLeft: 'Links ausrichten',
    RichEmailEditorAlignCenter: 'Zentriert ausrichten',
    RichEmailEditorAlignRight: 'Rechts ausrichten',
    RichEmailEditorAlignJustify: 'Blocksatz',
    RichEmailEditorLineSpacing: 'Zeilenabstand',
    RichEmailEditorInsertLink: 'Link einfügen',
    RichEmailEditorLinkUrl: 'URL:',
    RichEmailEditorLinkUrlPlaceholder: 'https://example.com',
    RichEmailEditorLinkUrlInvalid: 'Bitte geben Sie eine gültige URL ein.',
    RichEmailEditorRemoveLink: 'Link entfernen',
    RichEmailEditorRemoveLinkPrompt: 'Möchten Sie den Link für den ausgewählten Text entfernen?',
    RichEmailEditorTableBorderColor: 'Rahmenfarbe',
    RichEmailEditorTableBorderWidth: 'Rahmenbreite',
    RichEmailEditorTableCellBackground: 'Zellenhintergrund',
    RichEmailEditorTableCellAlign: 'Zellenausrichtung',
    RichEmailEditorTableCellVerticalAlign: 'Vertikale Ausrichtung',
    RichEmailEditorTableAlignTop: 'Oben',
    RichEmailEditorTableAlignMiddle: 'Mitte',
    RichEmailEditorTableAlignBottom: 'Unten',
    RichEmailEditorTableCellAlignTopLeft: 'Oben links ausrichten',
    RichEmailEditorTableCellAlignTopCenter: 'Oben zentriert ausrichten',
    RichEmailEditorTableCellAlignTopRight: 'Oben rechts ausrichten',
    RichEmailEditorTableCellAlignMiddleLeft: 'Mitte links ausrichten',
    RichEmailEditorTableCellAlignMiddleCenter: 'Mitte zentriert ausrichten',
    RichEmailEditorTableCellAlignMiddleRight: 'Mitte rechts ausrichten',
    RichEmailEditorTableCellAlignBottomLeft: 'Unten links ausrichten',
    RichEmailEditorTableCellAlignBottomCenter: 'Unten zentriert ausrichten',
    RichEmailEditorTableCellAlignBottomRight: 'Unten rechts ausrichten',
    RichEmailEditorTableInsert: 'Einfügen',
    RichEmailEditorTableDelete: 'Löschen',
    RichEmailEditorTableInsertAbove: 'Oberhalb einfügen',
    RichEmailEditorTableInsertBelow: 'Unterhalb einfügen',
    RichEmailEditorTableInsertLeft: 'Links einfügen',
    RichEmailEditorTableInsertRight: 'Rechts einfügen',
    RichEmailEditorTableDeleteRows: 'Zeilen löschen',
    RichEmailEditorTableDeleteColumns: 'Spalten löschen',
    RichEmailEditorTableMergeCells: 'Zellen verbinden',
    RichEmailEditorTableSplitCells: 'Zellen teilen',
    RichEmailEditorShape: 'Form',
    RichEmailEditorShapeRectangle: 'Rechteck',
    RichEmailEditorShapeRoundedRectangle: 'Abgerundetes Rechteck',
    RichEmailEditorShapeCircle: 'Kreis',
    RichEmailEditorShapeTriangle: 'Dreieck',
    RichEmailEditorShapeDiamond: 'Raute',
    RichEmailEditorShapeArrow: 'Pfeil',
    RichEmailEditorShapeFillColor: 'Füllfarbe',
    RichEmailEditorShapeBorderColor: 'Rahmenfarbe',
    RichEmailEditorShapeBorderWidth: 'Rahmenbreite',
    RichEmailEditorShapeBorderRadius: 'Eckenradius',
    RichEmailEditorShapeDelete: 'Form löschen',
    RichEmailEditorShapeWidth: 'B',
    RichEmailEditorShapeHeight: 'H',
    RichEmailEditorShapeRotation: '↻',
    RichEmailEditorImageCopy: 'Bild duplizieren',
    RichEmailEditorImageDelete: 'Bild löschen',
    AgentConfig: 'Agent E-Mail',
    AgentConfigEmailHeader: 'Kopfzeile',
    AgentConfigEmailHeaderDesc: 'Gestalten Sie die Kopfzeile für E-Mails, die der Agent automatisch versendet. Sie können Logo, Bilder, Tabellen und Grafiken einfügen.',
    AgentConfigEmailHeaderPlaceholder: 'Gestalten Sie hier die Kopfzeile für automatisch vom Agent versendete E-Mails...',
    AgentConfigEmailFooter: 'Fußzeile',
    AgentConfigEmailFooterDesc: 'Gestalten Sie die Fußzeile für E-Mails, die der Agent automatisch versendet. Sie können Logo, Datenschutzhinweise, Bilder, Tabellen und Grafiken einfügen.',
    AgentConfigEmailFooterPlaceholder: 'Gestalten Sie hier die Fußzeile für automatisch vom Agent versendete E-Mails...',
    AgentConfigSaved: 'Agent-E-Mail-Footer gespeichert',
    AgentConfigSaveFailed: 'Agent-E-Mail-Footer konnte nicht gespeichert werden',
    AgentConfigHeaderSaved: 'Agent-E-Mail-Kopfzeile gespeichert',
    AgentConfigHeaderSaveFailed: 'Agent-E-Mail-Kopfzeile konnte nicht gespeichert werden',
    AgentConfigInsertTable: 'Tabelle einfügen',
    AgentConfigInsertLink: 'Link einfügen',
    AgentConfigInsertLinkPrompt: 'Link-URL eingeben (z. B. Datenschutzrichtlinie):',
    AgentConfigInsertLinkLabel: 'Linktext (optional):',
    AccountOverview: 'Accountübersicht',
    CurrentPlan: 'Aktueller Plan',
    Available: 'Verfügbar',
    Billing: 'Rechnung',
    PricingPlans: 'Weitere Pakete erkunden',
    ExploreOurFlexiblePricingOptionsAndUpgradeYourPlan: 'Erkunden Sie unsere flexiblen Preisoptionen und upgraden Sie Ihren Plan.',
    ViewPricing: 'Pakete ansehen',
    DangerZone: 'Gefahrenzone',
    DangerZoneDescription: 'In diesem Bereich können Sie Ihr Konto löschen oder ein neues Passwort generieren.',
    PleaseWaitForEmailGeneration: 'E-Mail-Adresse wird generiert...',
    EmailGenerationTimeout: 'E-Mail-Adresse konnte nicht generiert werden.',
    EmailAccountGeneratedSuccessfully: 'E-Mail-Adresse erfolgreich generiert.',
    ApplicantMaxCountReached: 'Maximale Anzahl von Bewerbern erreicht für diesen Monat.',
    WorkflowExecuted: 'Workflow wurde erfolgreich angewendet.',
    ApplicantsDuplicatedAndContacted: 'Bewerber wurden erfolgreich dupliziert und kontaktiert.',
    DialCode: 'Ländervorwahl',
    CVUpload: 'CV hochladen',

    //Delete or Archive Component
    TheseItems: 'diesen Dateien',
    EnterDelete: 'Geben Sie "DELETE" ein',
    TextIsNotCorrect: 'Der Text ist nicht korrekt',
    DeleteApplicants: 'Bewerber Löschen',
    WhatWouldYouLikeToDoWith: 'Was möchten Sie mit',
    Archive: 'Archivieren',
    MoveToArchive: 'In Archiv verschieben',
    DeletePermanently: 'Endgültig löschen',
    FinalWarningToDelete: 'Bestätigen Sie, dass Sie diese Sammlung löschen möchten. Geben Sie dazu "DELETE" ein:',
    AreYouSureYouWantToDelete: 'Sind Sie sicher, dass Sie löschen möchten?',
    ThisActionCannotBeUndone: 'Diese Aktion kann nicht rückgängig gemacht werden.',

    //Help Icon
    UploadLogoInterview: 'Laden Sie hier Ihr Firmenlogo hoch. Dieses Logo wird im Interview angezeigt. Achtung es führt zu doppelten Logos im Interview.',
    HelpCallMP3: 'Dies ist der Anruf, der an den Bewerber gesendet wird. Um den Text zu ändern, kontaktieren Sie bitte den Support oder Sie können Ihre eigene MP3-Datei hochladen.',
    AIFragenVerwendenHelp: 'Bitte wenden Sie sich an Ihren Customer Success Manager, um diese Funktion zu aktivieren.Geben Sie hier Ihre Ziele an. Mona wird nach dem Interview weitere Fragen stellen, um Ihre Ziele zu erfüllen. Bsp. Finde heraus, ob der Bewerber einen Stapler fahren kann.',
    AutomatischeBewerbungHelp: 'Wenn aktiviert, können sich Bewerber automatisch für die Stelle bewerben, ohne manuelle Eingaben. Das System verarbeitet die Bewerbung automatisch.',
    SprachsteuerungHelp: 'Aktiviert die Sprachsteuerung für das Interview. Bewerber können mit dem Avatar sprechen und erhalten gesprochene Antworten.',
    CVParsingZuBeginnDesGesprächsHelp: 'Wenn aktiviert, wird der Lebenslauf des Bewerbers zu Beginn des Gesprächs automatisch analysiert und die Informationen werden für das Interview verwendet.',
    AutomatischerEinstellungstestHelp: 'Wenn aktiviert, wird automatisch ein Einstellungstest an den Bewerber gesendet, um dessen Qualifikationen zu prüfen.',
    BrowserspracheErzwingenHelp: 'Wenn aktiviert, wird die Sprache des Interviews basierend auf der Browsersprache des Bewerbers automatisch festgelegt.',
    FeedbackHelp: 'Wenn aktiviert, können Bewerber am Ende des Interviews Feedback geben. Dies hilft Ihnen, den Bewerbungsprozess zu verbessern.',
    CustomAvatar: 'Eigener Avatar',
    CustomAvatarHelp: 'Verwenden Sie einen eigenen Avatar mit benutzerdefinierter Avatar-ID und Stimmen-ID.',
    AvatarId: 'Avatar-ID',
    VoiceId: 'Stimmen-ID',
    CustomAvatarRequired: 'Sowohl Avatar-ID als auch Stimmen-ID sind erforderlich',
    CustomAvatarError: 'Fehler bei eigenem Avatar',
    CustomAvatarErrorMessage: 'Bitte geben Sie sowohl Avatar-ID als auch Stimmen-ID für den eigenen Avatar an.',
    Teilbar: 'Teilbar',
    TeilbarHelp: 'Wenn aktiviert, können Bewerber dieses Stellenangebot mit Freunden teilen.',
    CVFilter: 'CV-Filter',
    CVFilterDescription: 'Konfigurieren Sie automatische CV-Filterkriterien',
    CVFilterEnable: 'CV-Filter aktivieren',
    CVFilterEnableDesc: 'Filtert eingehende CVs automatisch basierend auf Ihren Kriterien',
    CVFilterMode: 'Filtermodus',
    CVFilterModeDesc: 'Wählen Sie, wann CVs gefiltert werden sollen',
    CVFilterCriteria: 'Filterkriterien',
    CVFilterCriteriaDesc: 'Definieren Sie die Kriterien für die CV-Filterung',
    CVFilterStructureHint: 'Empfohlene Struktur',
    CVFilterPromptPlaceholder: 'Geben Sie hier Ihre Filterkriterien ein...',
    CVFilterValidatePrompt: 'Kriterien validieren',
    CVFilterPromptRequired: 'Bitte geben Sie Filterkriterien ein',
    CVFilterValidationSkipped: 'Validierung übersprungen - Prompt wird wie eingegeben gespeichert',
    CVFilterValidateFirst: 'Prompt validieren',
    CVFilterValidateMessage: 'Bitte validieren Sie Ihren Prompt vor dem Speichern. Möchten Sie jetzt validieren?',
    CVFilterSaved: 'CV-Filter-Einstellungen erfolgreich gespeichert',
    CVFilterTest: 'Filter testen',
    CVFilterTestDesc: 'Testen Sie Ihren Filter mit Beispiel-CV-Daten',
    CVFilterTestData: 'Test-CV-Daten (JSON)',
    CVFilterLoadSample: 'Beispiel laden',
    CVFilterTestPlaceholder: 'CV-Daten im JSON-Format einfügen...',
    CVFilterRunTest: 'Test ausführen',
    CVFilterTestDataRequired: 'Bitte geben Sie Test-CV-Daten ein',
    CVFilterExplanation: 'Erklärung',
    CVFilterMatched: 'Erfüllt',
    CVFilterFailed: 'Nicht erfüllt',
    CVFilterTestError: 'Testfehler',
    CVFilterTestPassed: 'CV hat Filter bestanden',
    CVFilterTestRejected: 'CV abgelehnt',
    Validate: 'Validieren',
    SaveAnyway: 'Trotzdem speichern',
    CVFilterConfigure: 'CV-Filter konfigurieren',
    KontaktierungNachrichten: 'Kontaktierung & Nachrichten',
    NichtKonfiguriert: 'Nicht konfiguriert',
    Konfiguriert: 'Konfiguriert',
    CVFilterExtractedProfile: 'Extrahiertes Profil',
    CVFilterCreditsRemaining: 'Verbleibende Credits',
    CVFilterHelp: 'Hilfe',
    CVFilterAskMia: 'Frag Mia zum CV-Filter...',
    CVFilterAskQuestion: 'Frage stellen...',
    CVFilterHelpful: 'War das hilfreich?',
    CVFilterThanks: 'Danke für dein Feedback!',
    CVFilterSourceFilter: 'Quellenfilter',
    CVFilterSourceFilterDesc: 'Bestimmen Sie, welche Bewerberquellen gefiltert werden sollen',
    CVFilterAllSources: 'Alle Quellen filtern',
    CVFilterAllSourcesDesc: 'CV-Filter wird auf alle Bewerber angewendet',
    CVFilterExcludeSources: 'Quellen ausschließen',
    CVFilterExcludeSourcesDesc: 'Ausgewählte Quellen werden NICHT gefiltert (passieren direkt)',
    CVFilterIncludeSources: 'Nur bestimmte Quellen filtern',
    CVFilterIncludeSourcesDesc: 'NUR ausgewählte Quellen werden gefiltert',
    CVFilterSelectExcludeSources: 'Wählen Sie Quellen aus, die vom Filter AUSGENOMMEN werden sollen:',
    CVFilterSelectIncludeSources: 'Wählen Sie Quellen aus, die gefiltert werden sollen:',
    CVFilterExcludedCount: 'Ausgeschlossene Quellen',
    CVFilterIncludedCount: 'Gefilterte Quellen',
    CVFilterIncludeMode: 'Passende CVs einschließen',
    CVFilterIncludeModeDesc: 'Definieren Sie Kriterien, die Bewerber erfüllen MÜSSEN, um eingeschlossen zu werden',
    CVFilterExcludeMode: 'Passende CVs ausschließen',
    CVFilterExcludeModeDesc: 'Definieren Sie Kriterien, die Bewerber AUSSCHLIESSEN, wenn sie zutreffen',
    CVFilterCriterionType: 'Kriteriumstyp',
    CVFilterSelectType: 'Typ auswählen...',
    CVFilterOperator: 'Bedingung',
    CVFilterSelectOperator: 'Bedingung auswählen...',
    CVFilterValue: 'Wert',
    CVFilterEnterValue: 'Wert eingeben...',
    CVFilterSelectLevel: 'Level auswählen...',
    CVFilterRequirement: 'Anforderung',
    CVFilterRequired: 'Erforderlich',
    CVFilterPreferred: 'Bevorzugt',
    CVFilterAddedCriteria: 'Hinzugefügte Kriterien',
    CVFilterNoCriteria: 'Noch keine Kriterien hinzugefügt. Nutzen Sie das Formular oben, um Filterkriterien hinzuzufügen.',
    CVFilterCriteriaRequired: 'Bitte fügen Sie mindestens ein Filterkriterium hinzu, bevor Sie aktivieren',
    CVFilterSkills: 'Skills / Fähigkeiten',
    CVFilterEducation: 'Ausbildung / Studium',
    CVFilterLocation: 'Standort / Region',
    CVFilterSalary: 'Gehaltsvorstellung',
    CVFilterCustom: 'Benutzerdefiniert',
    CVFilterFreetext: 'Freitext / Promptbares Kriterium',
    CVFilterMinYears: 'Mindestens X Jahre',
    CVFilterMaxYears: 'Höchstens X Jahre',
    CVFilterContainsExp: 'Enthält Erfahrung in',
    CVFilterNotContainsExp: 'Enthält KEINE Erfahrung in',
    CVFilterHasAllSkills: 'Hat ALLE dieser Skills',
    CVFilterHasAnySkill: 'Hat MINDESTENS einen dieser Skills',
    CVFilterHasNoSkills: 'Hat KEINEN dieser Skills',
    CVFilterMinEducation: 'Mindestens Abschluss',
    CVFilterFieldOfStudy: 'Fachrichtung',
    CVFilterHasCertification: 'Hat Zertifizierung',
    CVFilterFluentIn: 'Fließend in',
    CVFilterBasicIn: 'Grundkenntnisse in',
    CVFilterNativeLanguage: 'Muttersprache',
    CVFilterInRegion: 'In Region/Stadt',
    CVFilterNotInRegion: 'NICHT in Region/Stadt',
    CVFilterWillingRelocate: 'Bereit umzuziehen',
    CVFilterMaxSalary: 'Maximal',
    CVFilterSalaryRange: 'Im Bereich',
    CVFilterAvailableWithin: 'Verfügbar innerhalb von X Tagen',
    CVFilterImmediatelyAvailable: 'Sofort verfügbar',
    CVFilterCustomCriterion: 'Freitext-Kriterium eingeben',
    CVFilterAddCriterion: 'Kriterium hinzufügen',
    CVFilterGenerateFromJob: 'Aus Stellenanzeige generieren',
    CVFilterJobOfferHint: 'Fügen Sie Ihre Stellenausschreibung ein und wir generieren passende Filterkriterien automatisch.',
    CVFilterJobOfferPlaceholder: 'Stellenausschreibung hier einfügen...',
    CVFilterJobOfferRequired: 'Bitte fügen Sie eine Stellenausschreibung ein',
    CVFilterGenerating: 'Generiere...',
    CVFilterGenerateCriteria: 'Kriterien generieren',
    CVFilterCriteriaGenerated: '{count} Kriterien generiert',
    CVFilterGenerationFailed: 'Kriterien konnten nicht generiert werden',
    CVFilterOrManually: 'oder manuell hinzufügen',
    CVFilterCredentials: 'API Zugangsdaten',
    CVFilterCredentialsDesc: 'Ihre MONA API Zugangsdaten für den CV-Filter',
    CVFilterUid: 'User ID (UID)',
    CVFilterUidPlaceholder: 'Ihre MONA User ID',
    CVFilterApiKey: 'API Key',
    CVFilterApiKeyPlaceholder: 'Ihr MONA API Key',
    CVFilterNoCredits: 'Keine CV-Filter verfügbar',
    CVFilterRejected: 'CV-Filter Abgelehnt',
    CVFilterBuyCredits: 'CV-Filter kaufen',
    CVFilterCreditsNeeded: 'Sie benötigen CV-Filter Credits, um fortzufahren',
    CVFilterCurrentCredits: 'Verbleibende CV-Filter',
    CVFilterPopular: 'Beliebt',
    CVFilterSelectedPackage: 'Ausgewähltes Paket',
    CVFilterProcessing: 'Verarbeite...',
    CVFilterPurchase: 'Jetzt kaufen',
    CVFilterPurchaseError: 'Fehler beim Kauf. Bitte versuchen Sie es erneut.',
    CVFilterNoEducationRequired: 'Kein Abschluss erforderlich',
    CVFilterPhD: 'Promotion/PhD',
    CVFilterYears: 'Jahre',
    CVFilterProfileExperience: 'Berufserfahrung',
    CVFilterProfileSkills: 'Fähigkeiten',
    CVFilterRedFlags: 'Warnhinweise',
    CVFilterAssistant: 'CV-Filter Assistent',
    CVUploadDragDrop: 'CV hier ablegen oder klicken zum Auswählen',
    CVUploadFormats: 'PDF, DOC, DOCX (max. 10 MB)',
    CVUploadRemove: 'Entfernen',
    CVUploadTooLarge: 'Datei zu groß. Maximal 10 MB erlaubt.',
    CVUploadInvalidFormat: 'Ungültiges Dateiformat. Bitte PDF, DOC oder DOCX hochladen.',
    CVUploadError: 'Fehler beim Hochladen. Bitte erneut versuchen.',
    CVFilterTestUpload: 'CV hochladen zum Testen',
    CVFilterTestUploadDesc: 'Laden Sie einen Lebenslauf hoch, um Ihre Filterkriterien zu testen',
    CVFilterUploadCv: 'CV hochladen',
    CVFilterAnalyzing: 'CV wird analysiert...',
    CVFilterApiKeyLimit: 'Maximal 10 aktive API-Schlüssel. Bitte löschen Sie zuerst einen Schlüssel.',
    CVFilterUploadRequired: 'Bitte laden Sie einen CV hoch',
    CVFilterTestHint: 'Laden Sie einen CV hoch, um zu sehen, ob er Ihre Kriterien erfüllt.',
    CVFilterNoCriteriaTest: 'Fügen Sie zuerst Filterkriterien hinzu, bevor Sie testen können.',
    CVFilterOptional: 'Optional',

    // Phone Number Validation Modal
    TelefonnummerValidierung: 'Telefonnummer Validierung',
    ValidierungsBeschreibung: 'Verifizieren Sie Ihre Telefonnummer per Sprachanruf. Sie erhalten einen Anruf und müssen den unten angezeigten Validierungscode eingeben.',
    Schritt1: 'Geben Sie unten Ihre Telefonnummer ein',
    Schritt2: 'Klicken Sie auf Validieren, um einen Anruf zu erhalten',
    Schritt3: 'Geben Sie den Code ein, wenn Sie dazu aufgefordert werden',
    AnzeigeName: 'Anzeigename',
    AnzeigeNamePlatzhalter: 'z.B. Büro, Mobil, Privat',
    Validieren: 'Per Anruf validieren',
    Zurücksetzen: 'Zurücksetzen',
    BitteEinLandAuswählen: 'Bitte wählen Sie ein Land aus.',
    BitteTelefonnummerEingeben: 'Bitte geben Sie eine Telefonnummer ein.',
    BitteKeineFührendeNull: 'Bitte keine führende 0 oder Ländervorwahl erneut eingeben.',
    BitteKeineLändervorwahlErneut: 'Bitte geben Sie die Ländervorwahl nicht erneut ein.',
    UngültigeZeichen: 'Die Telefonnummer enthält ungültige Zeichen. Nur Ziffern, Leerzeichen, Bindestriche und Klammern sind erlaubt.',
    UngültigeTelefonnummerLänge: 'Die Telefonnummer muss zwischen 6 und 15 Ziffern haben.',
    BitteKorrigierenSieDieTelefonnummer: 'Bitte korrigieren Sie die Telefonnummer vor der Validierung.',
    ValidierungLäuft: 'Verifizierungsanruf wird gestartet...',
    VerifizierungsanrufGestartet: 'Verifizierungsanruf gestartet!',
    BitteAnrufAnnehmen: 'Bitte nehmen Sie den Anruf an und geben Sie diesen Code ein, wenn Sie dazu aufgefordert werden.',
    ValidationCode: 'Validierungscode',
    VerifizierungFehlgeschlagen: 'Verifizierung fehlgeschlagen',
    TelefonnummerNichtValidiert: 'Telefonnummer konnte nicht validiert werden.',
    FehlerBeiDerValidierung: 'Bei der Validierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

    indexLogin: 'Geben Sie Ihre Index-Login-Anmeldeinformationen ein. Dies sind dieselben Anmeldeinformationen, die Sie verwenden, um sich auf der Index-Website anzumelden.',
    indexPassword: 'Geben Sie Ihr Index-Passwort ein. Dies ist dasselbe Passwort, das Sie verwenden, um sich auf der Index-Website anzumelden.',
    indexApiKey: 'Generieren Sie den API-Schlüssel direkt hier und fügen Sie ihn in dieses Feld ein.',
    compleetAPIKeys: 'Geben Sie Ihre Compleet-API-Schlüssel ein. Diese API-Schlüssel erhalten Sie vom Compleet-Support für jede Ihrer Niederlassungen.',
    compleetRecruitingApiKey: 'Geben Sie Ihren Compleet-API-Schlüssel ein. Sie erhalten diesen API-Schlüssel vom Compleet-Support.',
    compleetvendorexternalAccountId: 'Geben Sie die externe Account-ID für Compleet Vendor ein.',
    compleetvendorsource: 'Geben Sie die Quelle für Compleet Vendor ein.',
    compleetvendortargets: 'Geben Sie die Ziele für Compleet Vendor ein.',
    compleetVendorApiKey: 'Geben Sie Ihren Compleet Vendor API-Schlüssel ein. Sie erhalten diesen API-Schlüssel vom Compleet-Support.',
    talentClientId: 'Geben Sie Ihre Talent360 Client ID ein.',
    talentClientSecret: 'Geben Sie Ihr Talent360 Client Secret ein.',
    talentAPIBaseUrl: 'Die Basis-URL für die Talent360 API.',
    talentAccessTokenUrl: 'Die URL für den Zugriffstoken-Endpunkt der Talent360 API.',
    talentPublicAudience: 'Die öffentliche Audience-URL für die Talent360 API.',
    talentionClientId: 'Geben Sie Ihre Talention Client ID ein. Diese finden Sie in Ihrem Talention Account oder beim Support von Talention.',
    talentionClientSecret: 'Geben Sie Ihr Talention Client Secret ein. Dieses finden Sie in Ihrem Talention Account oder beim Support von Talention.',
    talentionAccountId: 'Geben Sie Ihre Talention Account ID ein.',
    talentionAccountOptionBranches: 'Geben Sie die erlaubten Mandanten für Talention ein.',
    talentionMonaStatusEingang: 'Geben Sie den Status für Eingang in MONA ein.',
    talentionMonaStatusImInterview: 'Geben Sie den Status für Interview läuft in MONA ein.',
    talentionMonaStatusInterviewAbgeschlossen: 'Geben Sie den Status für Interview abgeschlossen in MONA ein.',
    talentionMonaStatusAbgelehnt: 'Geben Sie den Status für Abgelehnt in MONA ein.',
    talentionDuplicateStatus: 'Geben Sie den Status für Duplikat in MONA ein.',
    talentionAccountOption: 'Die Filteroption für Talention Account.',
    covetoApiKey: 'Geben Sie Ihren Coveto API-Schlüssel ein.',
    covetoCustomernumber: 'Geben Sie Ihre Coveto Kundennummer ein.',
    covetoUsername: 'Geben Sie Ihren Coveto Benutzernamen ein.',
    covetoPassword: 'Geben Sie Ihr Coveto Passwort ein.',
    covetoURL: 'Geben Sie die Coveto API URL ein.',
    covetoStatus: 'Geben Sie den Coveto Status ein.',
    covetoMandanten: 'Geben Sie die Coveto Mandanten ein.',
    covetoMandantNewApplicant: 'Geben Sie den Coveto Mandanten für neue Bewerber ein.',
    hr4youusername: 'Geben Sie Ihren HR4YOU Benutzernamen ein. Diese Daten finden Sie in Ihrem HR4YOU Account oder beim Support von HR4YOU.',
    hr4youpassword: 'Geben Sie Ihr HR4YOU Passwort ein. Diese Daten finden Sie in Ihrem HR4YOU Account oder beim Support von HR4YOU.',
    hr4youurl: 'Geben Sie die HR4YOU API URL ein. Diese Daten finden Sie in Ihrem HR4YOU Account oder beim Support von HR4YOU.',
    hr4youUserStatus: 'Geben Sie die HR4YOU User Status ID ein.',
    hr4youapplicantGeneralStatus: 'Geben Sie die HR4YOU Bewerber Status ID ein.',
    hr4youconsultant: 'Geben Sie die HR4YOU Consultant ID ein.',
    hr4youmainUserGroup: 'Geben Sie die HR4YOU Usergruppen ID ein.',
    hr4youUserStatusToPull: 'Status des Bewerbers, welcher durch Mona abgerufen werden darf',
    hr4youStatusEingang: 'Geben Sie den Status für Eingang in MONA ein.',
    hr4youStatusInterviewBegonnen: 'Geben Sie den Status für Interview begonnen in MONA ein.',
    hr4youStatusInterviewAbgeschlossen: 'Geben Sie den Status für Interview abgeschlossen in MONA ein.',
    googleTypeOfPullingData: 'Der Typ der Daten, die von Google Calendar abgerufen werden.',
    outlookTypeOfPullingData: 'Der Typ der Daten, die von Microsoft Outlook abgerufen werden.',
    monaApiKey: 'Geben Sie Ihren Mona API-Schlüssel ein. Sie erhalten diesen von https://api-docs.mona-ai.cloud.',
    monaTypeOfPullingData: 'Der Typ der Daten, die von der Mona API abgerufen werden.',
    uid: 'Geben Sie Ihre User ID ein.',
    customApiTypeOfPullingData: 'Der Typ der Daten, die von der Custom API abgerufen werden.',
    zapierTypeOfPullingData: 'Der Typ der Daten, die von Zapier abgerufen werden.',
    zvooveBewerberApiKey: 'Geben Sie Ihren Zvoove Bewerber API-Schlüssel ein.',
    zvooveBewerberApiLink: 'Geben Sie Ihren Zvoove Bewerber API-Link ein.',
    zvooveStellenApiKey: 'Geben Sie Ihren Zvoove Stellen API-Schlüssel ein.',
    zvooveStellenApiLink: 'Geben Sie Ihren Zvoove Stellen API-Link ein.',
    zvoooveNextLevelApiKey: 'Geben Sie Ihren Zvoove Next Level API-Schlüssel ein.',
    zvooveNextLevelApiLink: 'Geben Sie Ihren Zvoove Next Level API-Link ein.',
    username: 'Geben Sie Ihren Benutzernamen ein.',
    aiFindApiKey: 'Geben Sie Ihren aiFind API-Schlüssel ein.',
    aiFindHostName: 'Geben Sie den aiFind Hostnamen ein.',
    aiFindProcess: 'Wählen Sie den Mona Prozess für aiFind aus.',
    aiFindProcessMona: 'Geben Sie den Tag zum Abrufen für aiFind ein.',
    aiFindProcessMonaWorking: 'Geben Sie den Tag in Bearbeitung für aiFind ein.',
    aiFindProcessMonaDone: 'Geben Sie den Tag wenn fertig für aiFind ein.',
    aiFindNoteCategory: 'Geben Sie die Note Kategorie für aiFind ein.',
    smtpHost: 'Geben Sie den SMTP-Host-Server ein (z.B. smtp.gmail.com).',
    smtpPort: 'Geben Sie den SMTP-Port ein (z.B. 587 für TLS oder 465 für SSL).',
    smtpUsername: 'Geben Sie Ihren SMTP-Benutzernamen ein (normalerweise Ihre E-Mail-Adresse).',
    smtpPassword: 'Geben Sie Ihr SMTP-Passwort ein. Bei Gmail verwenden Sie ein App-Passwort.',
    TLS: 'Aktivieren Sie TLS (Transport Layer Security) für eine sichere Verbindung.',
    smtpTypeOfPullingData: 'Der Typ der Daten, die über SMTP abgerufen werden.',
    imapHost: 'Geben Sie den IMAP-Host-Server ein (z.B. imap.gmail.com).',
    imapPort: 'Geben Sie den IMAP-Port ein (z.B. 993 für SSL oder 143 für TLS).',
    imapUsername: 'Geben Sie Ihren IMAP-Benutzernamen ein (normalerweise Ihre E-Mail-Adresse).',
    imapPassword: 'Geben Sie Ihr IMAP-Passwort ein. Bei Gmail verwenden Sie ein App-Passwort.',
    imapTLS: 'Aktivieren Sie TLS (Transport Layer Security) für eine sichere IMAP-Verbindung.',
    imapTypeOfPullingData: 'Der Typ der Daten, die über IMAP abgerufen werden.',
    zapierWebhook: 'Ihre eindeutige Zapier Webhook URL wird nach dem Speichern generiert.',
    n8nWebhook: 'Ihre eindeutige n8n Webhook URL wird nach dem Speichern generiert.',
    n8nTypeOfPullingData: 'Der Typ der Daten, die von n8n abgerufen werden.',
    onlyfyApiKey: 'Geben Sie Ihren Onlyfy API-Schlüssel ein. Diese Daten finden Sie in Ihrem Onlyfy Account oder beim Support von Onlyfy.',
    onlyfyApiUrl: 'Geben Sie die Onlyfy API URL ein. Diese Daten finden Sie in Ihrem Onlyfy Account oder beim Support von Onlyfy.',
    onlyfyStatusDocumentsSubmitted: 'Geben Sie den Status für Eingang in MONA ein.',
    onlyfyStatusInterviewRunning: 'Geben Sie den Status für Interview läuft ein.',
    onlyfyStatusInterviewCompleted: 'Geben Sie den Status für Interview abgeschlossen ein.',
    onlyfyStatusInterviewCancelled: 'Geben Sie den Status für Interview abgebrochen ein.',
    onlyfyStatusCalled1x: 'Geben Sie den Status für 1. Anruf ein.',
    onlyfyStatusCalled2x: 'Geben Sie den Status für 2. Anruf ein.',
    onlyfyStatusCalled3xReject: 'Geben Sie den Status für 3. Anruf ein.',
    onlyfyStatusAutoReject: 'Geben Sie den Status für automatisch abgelehnt ein.',
    personioClientId: 'Geben Sie Ihre Personio Client ID ein, die Sie von Personio erhalten haben.',
    personioClientSecret: 'Geben Sie Ihr Personio Client Secret ein, das Sie von Personio erhalten haben.',
    personioTypeOfPullingData: 'Der Typ der Daten, die von Personio abgerufen werden.',
    syncEmployees: 'Aktivieren Sie diese Option, um Mitarbeiterdaten mit MONA zu synchronisieren.',
    syncApplications: 'Aktivieren Sie diese Option, um Bewerbungsdaten mit MONA zu synchronisieren.',
    Agents: 'Agenten',
    'Agent Builder': 'Agent Builder',
    'Data Pipeline': 'Data Pipeline',
    Profil: 'Profil',
    Searches: 'Suchen',
    Shortlist: 'Shortlist',
    Home: 'Home',
    ARS: 'ARS',
    'Daten Import': 'Daten Import',
    'MONA Pool': 'MONA Pool',
    Contacts: 'Kontakte',
    Sequences: 'Sequenzen',
    Analytics: 'Analysen',
    Integrations: 'Integrationen',

    //pool-search (flow: 1. Suchen → 2. Matching → 3. Terminieren)
    PoolSearchGreeting: 'Hallo {name}, beschreibe wen du suchst',
    PoolSearchPlaceholder: 'z.B. Buchhalter in Frankfurt, Elektriker in Merzig...',
    PoolSearchCityOrRemote: 'Stadt oder Remote',
    PoolSearchNeededForSearch: 'Pflichtfeld',
    PoolSearchLocation: 'Standort',
    PoolSearchJobTitle: 'Jobtitel',
    PoolSearchSkills: 'Fähigkeiten',
    PoolSearchFindSimilar: 'Ähnliche finden',
    PoolSearchJobDescription: 'Stellenbeschreibung',
    PoolSearchBoolean: 'Boolean',
    PoolSearchSelectManually: 'Manuell auswählen',
    PoolSearchFiltersSet: 'Folgende <highlight>Filter</highlight> wurden erkannt',
    PoolSearchEditFilters: 'Anpassen',
    PoolSearchJobTitles: 'Jobtitel',
    PoolSearchAddTitle: 'Titel hinzufügen...',
    PoolSearchAddSkill: 'Fähigkeit hinzufügen...',
    PoolSearchCollapse: 'Zuklappen',
    PoolSearchCriteriaSet: 'Zusätzliche <highlight>Kriterien</highlight> für das Matching',
    PoolSearchEditCriteria: 'Anpassen',
    PoolSearchAddCriterion: 'Kriterium hinzufügen...',
    PoolSearchThinking: 'Suche läuft',
    PoolSearchUnderstandingQuery: 'Anfrage wird analysiert...',
    PoolSearchSearchingDatabases: 'Datenbank wird durchsucht...',
    PoolSearchAnalyzingProfiles: 'Profile werden geprüft...',
    PoolSearchRankingResults: 'Ergebnisse werden sortiert...',
    PoolSearchResetSearch: 'Zurück',
    PoolSearchRunSearch: 'Kandidaten suchen',
    PoolSearchFilters: 'Filter',
    PoolSearchCriteria: 'Kriterien',
    PoolSearchNewSearch: 'Neue Suche',
    PoolSearchCandidates: 'Kandidaten',
    PoolSearchMatches: 'Matches',
    PoolSearchAiRanked: 'KI-Matching aktiv',
    PoolSearchStartMatching: 'KI-Matching starten',
    PoolSearchShowing: 'Zeige',
    PoolSearchOf: 'von',
    PoolSearchShortlisted: 'Ausgewählt',
    PoolSearchShortlistAction: 'Auswählen',
    PoolSearchMatchReason: 'Begründung',
    PoolSearchFailed: 'Suche fehlgeschlagen. Bitte erneut versuchen.',
    PoolSearchMatchingFailed: 'Matching fehlgeschlagen. Bitte erneut versuchen.',
    PoolSearchFoundMatches: '{count} Matches gefunden',
    PoolSearchEnterLocation: 'Bitte gib einen Standort ein.',

    //pool-search agentic mode
    PoolSearchAgenticMode: 'Agentic Mode',
    PoolSearchAgenticTitle: 'Agentic Mode verfügbar',
    PoolSearchAgenticDesc: 'Du hast den gesamten Prozess erfolgreich durchlaufen. Ab jetzt kannst du den Agentic Mode aktivieren — die Suche, das Matching und die Terminierung laufen dann automatisch ab.',
    PoolSearchAgenticHint: 'Aktiviere den Agentic Mode auf der Startseite und gib nur die maximale Anzahl an Interviews an.',
    PoolSearchAgenticGotIt: 'Verstanden',
    PoolSearchMaxInterviews: 'Max. Interviews',
    PoolSearchStartAutomatic: 'Automatisch starten',
    PoolSearchScheduleStep: 'Terminieren',
    PoolSearchAgentChat: 'Agent Chat',
    PoolSearchChap: 'CHAP',

    // Workspace Sidebar — Todo List
    SidebarTodaysTasks: 'Heutige Aufgaben',
    SidebarNoTasks: 'Keine Aufgaben für heute',
    SidebarUpcomingInterviews: 'Anstehende Interviews',
    SidebarNoInterviews: 'Keine anstehenden Interviews',
    SidebarConnectCalendar: 'Verbinde deinen Kalender, um anstehende Interviews zu sehen',

    // Workspace Sidebar — Task Type Categories
    TaskCatInterviewApplicant: 'Interview',
    TaskCatScheduleApplicant: 'Terminierung',
    TaskCatAskMissingInfo: 'Information',
    TaskCatSendProfile: 'Profil senden',
    TaskCatWriteJobOffer: 'Stellenanzeige',
    TaskCatReviewApplications: 'Bewerbungen prüfen',
    TaskCatSendRejection: 'Absage',
    TaskCatFollowUpCandidate: 'Follow-up Kandidat',
    TaskCatFollowUpClient: 'Follow-up Kunde',
    TaskCatCheckReferences: 'Referenzen prüfen',
    TaskCatPrepareContract: 'Vertrag vorbereiten',
    TaskCatUpdatePipeline: 'Pipeline aktualisieren',
    TaskCatSourceCandidates: 'Sourcing',
    TaskCatOnboardNewHire: 'Onboarding',
    TaskCatHiring: 'Einstellung',
    TaskCatFollowUp: 'Follow-up',
    TaskCatAdmin: 'Admin',
    TaskCatOutreach: 'Outreach',

    // Location Teams Embedded
    LocTeamsLocationsAndTeams: 'Standorte & Teams',
    LocTeamsLocation: 'Standort',
    LocTeamsLocations: 'Standorte',
    LocTeamsCreateLocation: 'Standort erstellen',
    LocTeamsRefresh: 'Aktualisieren',
    LocTeamsLoadingLocations: 'Lade Standorte und Google Maps...',
    LocTeamsNoLocations: 'Keine Standorte vorhanden',
    LocTeamsNoLocationsHint: 'Erstellen Sie einen neuen Standort, um ihn auf der Karte anzuzeigen',
    LocTeamsUnassigned: 'nicht zugewiesen',
    LocTeamsUnassignedAgents: 'Nicht zugewiesene Agenten',
    LocTeamsSelectLocationFirst: 'Wählen Sie zuerst einen Standort auf der Karte',
    LocTeamsOnline: 'Online',
    LocTeamsPhysical: 'Physisch',
    LocTeamsAssignedAgents: 'Zugewiesene Agenten',
    LocTeamsNoAgentsAssigned: 'Noch keine Agenten zugewiesen',
    LocTeamsAssignAgent: 'Agent zuweisen',
    LocTeamsTeams: 'Teams',
    LocTeamsMembers: 'Mitglieder',
    LocTeamsNoTeamsAtLocation: 'Keine Teams an diesem Standort',
    LocTeamsRemoveFromLocation: 'Vom Standort entfernen',
    LocTeamsEditLocation: 'Bearbeiten',
    LocTeamsDeleteLocation: 'Löschen',
    LocTeamsSaveLocation: 'Speichern',
    LocTeamsStreet: 'Straße',
    LocTeamsZip: 'PLZ',
    LocTeamsCity: 'Ort',
    LocTeamsCountry: 'Land',
    LocTeamsTimezone: 'Zeitzone',
    LocTeamsLocationSaved: 'Standort gespeichert',
    LocTeamsLocationDeleted: 'Standort gelöscht',
    LocTeamsDeleteLocationTitle: 'Standort löschen?',
    LocTeamsDeleteLocationMsg: '"{{name}}" wird gelöscht. Das kann nicht rückgängig gemacht werden.',
    LocTeamsLocationSaveFailed: 'Der Standort konnte nicht gespeichert werden.',
    LocTeamsLocationDeleteFailed: 'Der Standort konnte nicht gelöscht werden.',
    LocTeamsLocationInUseTitle: 'Standort kann nicht gelöscht werden',
    LocTeamsLocationInUseMsg: '"{{name}}" wird noch verwendet:',
    LocTeamsUsageTeams: 'Teams',
    LocTeamsUsagePeople: 'Organigramm – Personen',
    LocTeamsUsageAgents: 'Organigramm – Agenten',
    LocTeamsUsageLocationTeams: 'Standort-Teams',
    LocTeamsUsageProfile: 'Profil',

    // Workflow Template Gallery
    StartFromScratch: 'Von Grund auf neu',
    CreateBlankWorkflow: 'Leeren Workflow erstellen',
    ChooseWorkflowTemplate: 'Workflow-Vorlage auswählen',
    SearchTemplates: 'Vorlagen suchen...',
    UseTemplate: 'Vorlage verwenden',
    NoTemplatesFound: 'Keine Vorlagen gefunden',
    AdjustSearchOrFilter: 'Versuche deine Suche oder Filterkriterien anzupassen',
    WfCatHR: 'HR',
    WfCatData: 'Daten',
    WfCatSupport: 'Support',
    WfAiPlaceholder: 'Beschreibe den Workflow, den du brauchst — z.B. Auto-Antwort auf eingehende Bewerbungen',
    WfAiPlaceholderShort: 'Beschreibe deinen nächsten Workflow...',
    WfAiIntro: 'Beschreibe den Workflow, den du erstellen möchtest, und ich baue ihn für dich. Zum Beispiel:<br><br>• <strong>E-Mail Auto-Antwort</strong> auf eingehende Bewerbungen<br>• <strong>CV-Parsing-Pipeline</strong> mit automatischer Profilerstellung<br>• <strong>Geplante Berichte</strong> mit täglichen Zusammenfassungen<br>• <strong>Kandidaten-Ansprache</strong> für neue Stellenangebote',
    WfAiSugAutoReply: 'Auto-Antwort auf eingehende Bewerbungen',
    WfAiSugParseCv: 'CVs parsen und Bewerberprofile erstellen',
    WfAiSugDailyReport: 'Täglicher Operations-Report',
    WfAiSugOnboarding: 'Onboarding-Workflow mit Willkommens-E-Mails',
    WfAiSugReactivation: 'Kandidaten-Reaktivierung für inaktive Profile',
    WfAiSugGdpr: 'DSGVO-Einwilligungserneuerung mit automatischen Erinnerungen',
    WfAiSugContracts: 'Geplanter Workflow für auslaufende Verträge',
    WfAiErrorRetry: 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    WfAiWorkflowDiscarded: 'Workflow verworfen. Beschreibe einen neuen oder wähle unten eine Vorlage.',
    WfAiReadyToSave: 'Soll ich diesen Workflow speichern?',
    WfAiSaveWorkflow: 'Workflow speichern',
    WfAiDiscard: 'Verwerfen',
    WfAiModify: 'Workflow anpassen',
    WfAiSaved: 'gespeichert',
    WfAiClose: 'Schließen',
    WfAiCreateAnother: 'Weiteren Workflow erstellen',
    WfAiSaveError: 'Fehler beim Speichern des Workflows. Bitte versuche es erneut.',
    AllAgents: 'Alle Agents',
    Role: 'Rolle',
    NoDescription: 'Keine Beschreibung',
    NoWorkflowsLinked: 'Keine Workflows verknüpft',
    NoIntegrationsConnected: 'Keine Integrationen verbunden',
    NoActivityRecorded: 'Keine Aktivität aufgezeichnet',
    EditAgentViaPrompt: 'Agent per Prompt bearbeiten',
    AgentEditPlaceholder: 'z.B. Füge Shopify-Skill hinzu...',
    AddIntegration: 'Integration hinzufügen',
    OrgAiPlaceholder: 'Organigramm bearbeiten oder Workflow erstellen...',
    Activity: 'Aktivität',
    Organigramm: 'Organigramm',
    LocationsTeams: 'Locations & Teams',
    NoOrgStructure: 'Keine Organisationsstruktur vorhanden',
    SwitchToWorkflows: 'Wechsle zur Workflow-Ansicht oder erstelle eine Struktur über den KI-Assistenten.',
    ChooseAction: 'Aktion auswählen',
    ActionCommunication: 'Kommunikation',
    ActionSendEmail: 'E-Mail senden',
    ActionSendSMS: 'SMS senden',
    ActionAIAssistant: 'KI-Assistent',
    ActionReviewResume: 'Lebenslauf prüfen',
    ActionScoreCandidate: 'Kandidat bewerten',
    ActionScheduling: 'Terminplanung',
    ActionScheduleInterview: 'Interview planen',
    ActionSendCalendarLink: 'Kalenderlink senden',
    ActionDataManagement: 'Datenverwaltung',
    ActionUpdateStatus: 'Status aktualisieren',
    ActionAddNote: 'Notiz hinzufügen',
    AdKiTools: 'KI-Tools',
    AdToolsSubtitle: 'Erweitere deine Konversation mit intelligenten Tools',
    AdToolEmail: 'E-Mail',
    AdToolEmailSend: 'Nachrichten senden',
    AdToolDb: 'Datenbank',
    AdToolDbFind: 'Informationen finden',
    AdToolDbUseCv: 'Nutze CV Parser oder Integrationen',
    AdToolIndex: 'Index Anzeigendaten',
    AdToolIndexSearch: 'Schnelle Suche',
    AdToolIndexReq: 'Integrationen → User/Pass + API Key',
    AdToolUrlParser: 'URL-Parser',
    AdToolUrlParserDesc: 'Inhalte analysieren',
    AdToolCvParser: 'CV-Parser',
    AdToolCvParserDesc: 'Lebensläufe analysieren',
    AdToolCall: 'Anrufen',
    AdToolCallStart: 'Telefonate starten',
    AdToolSms: 'SMS',
    AdToolSmsShort: 'Kurznachrichten',
    AdToolReminder: 'Erinnerung',
    AdToolReminderDesc: 'Termine setzen',
    AdPremiumFeature: 'Premium Feature',
    AdCompanySmtp: 'Firmenname + SMTP in Profil',
    AdCompanyMissing: 'Firmenname in Profil fehlt',
    AdSearchAgents: 'Suche nach Agenten...',
    AdSelectAgent: 'Agent auswählen',
    AdSelectOrSwitch: 'Agent auswählen oder wechseln',
    AdChatHistory: 'Chat-Verlauf',
    AdHistory: 'Verlauf',
    AdNewChat: 'Neuer Chat',
    AdClose: 'Schließen',
    AdHistoryLoading: 'Chat-Verlauf wird geladen...',
    AdMessages: 'Nachrichten',
    AdNoHistory: 'Kein Verlauf gefunden',
    AdNoHistoryDesc: 'Es wurden noch keine Gespräche mit diesem Agenten geführt.',
    AdStartNewChat: 'Neues Gespräch starten',
    AdDropFiles: 'Dateien hier ablegen',
    AdDropFilesDesc: 'Lassen Sie Ihre Dateien hier fallen, um sie hochzuladen',
    AdUploadFiles: 'Dateien hochladen',
    AdUploadFilesDesc: 'Dateien hochladen und in die Unterhaltung einbeziehen',
    AdInternetToggle: 'Internet aktivieren/deaktivieren',
    AdInternetDesc: 'Aktiviert Websuche/Browsing für aktuelle Informationen. Antworten können langsamer sein.',
    AdInternet: 'Internet',
    AdThinkingToggle: 'Denken aktivieren/deaktivieren',
    AdThinkingDesc: 'Aktiviert mehrstufiges Denken für gründlichere Antworten. Kann etwas länger dauern.',
    AdThinking: 'Denken',
    AdShowTools: 'KI-Tools anzeigen',
    AdTools: 'Tools',
    AdSkills: 'Skills',
    AdSendMessage: 'Nachricht senden',
    AdAgentPreparing: 'Agent wird vorbereitet...',
    AdFirstMsgHint: 'Die erste Nachricht kann einen Moment dauern (Agent-Authentifizierung). Danach sind Antworten schnell.',
    AdPlaceholder: 'Wie kann ich dir heute helfen?',
    AdGdpr: 'DSGVO-konform',
    AdGdprDetails: 'Details zum Datenschutz einsehen',
    AdDisclaimer: 'MONA Agents können Fehler machen. Überprüfen Sie wichtige Informationen.',
    AdSmsSuccess: 'SMS erfolgreich gesendet',
    AdRecipient: 'Empfänger',
    AdMessage: 'Nachricht',
    AdServerResponse: 'Server-Antwort',
    AdSaveToMemory: 'In Erinnerung speichern',
    AdDataPipeline: 'Datenpipeline',
    AdCandidatesFound: 'Kandidaten gefunden',
    AdContactInfo: 'Kontaktinformationen gefunden',
    AdExperience: 'Berufserfahrung',
    AdCallSuccess: 'Anruf erfolgreich',
    AdLivestreamToggle: 'Livestream anzeigen/ausblenden',
    AdSkillsSubtitle: 'Erweitere deine Analyse mit spezialisierten Skills',
    AdAnalysisSkills: 'Analysis Skills',
    AdFilterSkills: 'Filter skills...',
    AdLoadingSkills: 'Loading skills...',
    AdError: 'Fehler',
    AdUnknownError: 'Unbekannter Fehler',
    AdSendError: 'Entschuldigung, es gab einen Fehler bei der Verarbeitung Ihrer Nachricht.',
    AdNewConversation: 'Neues Gespräch',
    AdConversation: 'Gespräch',
    AdBrowserAutomation: 'Browser Automation',
    AdBrowserTask: 'Aufgabe beschreiben:',
    AdBrowserTaskPlaceholder: 'z.B. Gehe zu LinkedIn und suche nach Senior Entwicklern in Berlin',
    AdBrowserUrl: 'URL (optional):',
    AdBrowserUrlPlaceholder: 'https://beispiel.com',
    AdBrowserCredentials: 'Anmeldedaten (Optional)',
    AdBrowserUseCredentials: 'Anmeldedaten verwenden',
    AdBrowserEmail: 'E-Mail oder Benutzername',
    AdBrowserPassword: 'Passwort',
    AdBrowserAdvanced: 'Erweiterte Einstellungen',
    AdBrowserMaxSteps: 'Max. Schritte',
    AdBrowserOutputFormat: 'Ausgabeformat',
    AdBrowserScreenshots: 'Screenshots aufnehmen',
    AdBrowserDebug: 'Debug-Modus aktivieren',
    AdBrowserExtraction: 'Daten-Extraktion (Optional)',
    AdBrowserExtractData: 'Spezifische Daten extrahieren',
    AdBrowserFieldName: 'Feldname',
    AdBrowserSelector: 'CSS Selector oder Beschreibung',
    AdBrowserAddRule: 'Regel hinzufügen',
    AdBrowserTemplates: 'Vorlagen',
    AdBrowserLinkedIn: 'LinkedIn Suche',
    AdBrowserSalesforce: 'Salesforce Update',
    AdBrowserScraping: 'Daten Scraping',
    AdBrowserForm: 'Formular ausfüllen',
    AdBrowserCode: 'Generierter Code',
    AdCopy: 'Kopieren',
    AdCancel: 'Abbrechen',
    AdInsertInChat: 'In Chat einfügen',
    AdExecute: 'Ausführen',
    AdLivestreamAvailable: 'Livestream verfügbar',
    AdOpenLivestream: 'Livestream öffnen',
    AdBrowserRunning: 'Browser Automation wird ausgeführt...',
    AdBrowserStillRunning: 'Browser Automation läuft noch... (Livestream ist verfügbar)',
    AdFilesGenerated: 'Dateien generiert',
    AdDocFailed: 'Dokumenterstellung fehlgeschlagen',
    AdPreview: 'Vorschau',
    AdDownload: 'Herunterladen',
    AdDocSuccess: 'Die Dokumenterstellung wurde abgeschlossen. Die generierten Dateien stehen zum Download bereit.',
    AdAgentPreparingTitle: 'Agent wird vorbereitet',
    AdAgentPreparingMsg: 'Bitte warten Sie, bis der Agent bereit ist.',
    AdPremiumTitle: 'Premium Feature',
    AdPremiumMsg: 'Diese Funktion ist nur in den Plänen Agents-Pro, Ultra oder Enterprise verfügbar.',
    AdUpgrade: 'Upgrade',
    AdDbSetup: 'Datenbank einrichten',
    AdDbSetupMsg: 'Um die Datenbank zu nutzen, müssen Sie erst Daten hinzufügen.',
    AdUseCvParser: 'CV Parser verwenden',
    AdGoIntegrations: 'Zu Integrationen',
    AdIndexSetup: 'Index konfigurieren',
    AdIndexSetupMsg: 'Gehen Sie zu Integrationen und konfigurieren Sie Index.',
    AdGoProfile: 'Zu Profil-Einstellungen',
    AdEmailSetup: 'E-Mail konfigurieren',
    AdEmailSetupMsg: 'Um E-Mails zu versenden, gehen Sie zu Profil und konfigurieren Sie SMTP.',
    AdSmsSetup: 'SMS konfigurieren',
    AdSmsSetupMsg: 'Um SMS zu versenden, tragen Sie Ihren Firmennamen im Profil ein.',
    AdCallSetup: 'Anrufe konfigurieren',
    AdCallSetupMsg: 'Um Anrufe zu tätigen, tragen Sie Ihren Firmennamen im Profil ein.',
    AdCopied: 'Kopiert!',
    AdCodeCopied: 'Der Code wurde in die Zwischenablage kopiert.',
    AdCopyError: 'Code konnte nicht kopiert werden.',
    AdFileOpenError: 'Die Datei konnte nicht geöffnet werden.',
    AdFileDownloadError: 'Die Datei konnte nicht heruntergeladen werden.',
    AdCodeCopy: 'Code kopieren',
    AdConfirm: 'Bestätigen',
    AdLegalPhone: 'Telefonanruf',
    AdLegalSms: 'SMS',
    AdLegalEmail: 'E-Mail',
    AdLegalConfirmMsg: 'Ich bestätige, dass ich berechtigt bin, diese Kommunikation im Namen meines Unternehmens zu initiieren.',
    AdBackToChat: 'Zurück zum Chat',
    AdScheduledRuns: 'Geplante Ausführungen',
    AdDeactivate: 'Deaktivieren',
    AdActivate: 'Aktivieren',
    AdDelete: 'Löschen',
    AdRequiredData: 'Benötigte Daten',
    AdExampleQuestions: 'Beispiel-Fragen',
    AdUploadFilesOptional: 'Dateien hochladen (optional)',
    AdDropFilesOrClick: 'Dateien hier ablegen oder klicken',
    AdDataSource: 'Datenquelle (optional)',
    AdNoPipeline: 'Keine Pipeline',
    AdUrlDownload: 'URL (Datei herunterladen)',
    AdEmailReport: 'Ergebnis per E-Mail:',
    AdEmailPlaceholder: 'email@firma.com',
    AdDescribeTask: 'Beschreibe deine Analyse-Aufgabe...',
    AdStartAnalysis: 'Analyse starten',
    AdSetupSchedule: 'Als Zeitplan einrichten',
    AdAutoRun: 'Automatisch ausführen lassen',
    AdTime: 'Uhrzeit:',
    AdDays: 'Tage:',
    AdDaily: 'Täglich',
    AdWeekdays: 'Mo-Fr (Werktags)',
    AdMoWeFr: 'Mo, Mi, Fr',
    AdTuTh: 'Di, Do',
    AdMonday: 'Montag',
    AdTuesday: 'Dienstag',
    AdWednesday: 'Mittwoch',
    AdThursday: 'Donnerstag',
    AdFriday: 'Freitag',
    AdSaturday: 'Samstag',
    AdSunday: 'Sonntag',
    AdReportEmail: 'E-Mail für Report:',
    AdReportPlaceholder: 'report@firma.com',
    AdSaveSchedule: 'Zeitplan speichern',
    AdRuntime: 'Laufzeit:',
    AdAnalysisComplete: 'Analyse abgeschlossen',
    AdDiscussWithAgent: 'Mit Agent besprechen',
    AdNewAnalysis: 'Neue Analyse',
    AdRetry: 'Erneut versuchen',
    AdExamples: 'Beispiele',
    ApiKeyDuration: 'Gültigkeit',
    Unlimited: 'Unbegrenzt',
    Warning: 'Warnung',
    UnlimitedApiKeyWarning: 'Du bist dabei, einen API-Schlüssel zu generieren, der 10 Jahre gültig ist. Dies ist ein Sicherheitsrisiko. Bist du sicher?',
    ConfirmApiKey: 'Bestätigen',
    AllPermissionsEnabledByDefault: 'Alle Berechtigungen sind standardmäßig aktiviert. Erweitere den Berechtigungsbereich unten, um sie anzupassen.',
    DeepInterviewCredits: 'Verbleibende Deep Interview Credits',
    AdditionalCredits: 'Zusätzliche Credits',
    PurchaseMoreCredits: 'Weitere Credits kaufen',
    RunningOutOfCredits: 'Gehen Ihnen die Credits aus? Als Pro-Nutzer können Sie jederzeit zusätzliche Credits per Pay-per-Use nachkaufen.',
    CreditsPayPerUseNote: 'Credits werden sofort nach der Zahlung verfügbar. Preise werden beim Checkout angezeigt.',
    ApiKeysDescription: 'Erstellen und verwalten Sie API-Schlüssel für den externen Zugriff.',
    CurrentAPIKeys: 'Aktuelle API-Schlüssel',
    CustomizePermissions: 'Berechtigungen anpassen',
    MaxApiKeysReached: 'Maximale Anzahl an API-Schlüsseln erreicht',
    MobileNummer: 'Mobilnummer',
    NeuesPasswortGenerieren: 'Neues Passwort generieren',
    AllgemeineEinstellungen: 'Allgemeine Einstellungen',
    StandortnameExistiertBereits: 'Standortname existiert bereits',
    VerantwortlichePerson: 'Verantwortliche Person',

    // Agent Chat (Ac prefix)
    AcPleaseWait: 'Bitte warten',
    AcCvProcessing: 'Lebenslauf wird verarbeitet und Agent erstellt...',
    AcAgentCreated: 'Agent wurde erstellt und dem Konto hinzugefügt.',
    AcAgentCreatedNote: 'Agent-Erstellung abgeschlossen. Bitte aktualisieren Sie die Agentenliste, falls der Agent nicht sofort sichtbar ist.',
    AcCvProcessingFailed: 'Der Lebenslauf konnte nicht verarbeitet werden.',
    AcPremiumFeature: 'Premium Feature',
    AcPremiumFeatureMsg: 'Diese Funktion ist nur für zahlende Nutzer verfügbar (Agents-Pro, Agents-Ultra oder Agents-Enterprise).',
    AcUpgrade: 'Upgrade',
    AcSetupDatabase: 'Datenbank einrichten',
    AcDatabaseEmpty: 'Die Datenbank enthält noch keine Bewerberdaten. Sie können Bewerber hinzufügen über:',
    AcUseCvParser: 'CV Parser verwenden',
    AcGoToIntegrations: 'Zu Integrationen',
    AcConfigureIndex: 'Index konfigurieren',
    AcGoToProfile: 'Zu Profil',
    AcGoToProfileSettings: 'Zu Profil-Einstellungen',
    AcAgentSelectError: 'Beim Auswählen des Agenten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    AcCreditsExhausted: 'Credits aufgebraucht',
    AcCreditsExhaustedMsg: 'Dein Guthaben reicht nicht aus, um eine Anfrage zu senden. Möchtest du jetzt Credits aufladen?',
    AcLater: 'Später',
    AcTopUpCredits: 'Credits aufladen',
    AcChooseKnowledgeType: 'Wähle Wissenstyp',
    AcWhereToSaveFile: 'Wo soll diese Datei gespeichert werden?',
    AcThisChatOnly: 'Nur für diesen Chat',
    AcAgentKnowledgeBase: 'Agent Wissensbasis',
    AcCompanyKnowledgeBase: 'Unternehmens-Wissensbasis',
    AcUploadError: 'Upload Fehler',
    AcInvalidFileType: 'Ungültiger Dateityp',
    AcLimitReached: 'Limit erreicht',
    AcLimitReachedMsg: 'Maximal 50 Dateien und 500 MB pro Agent erlaubt.',
    AcKnowledgeBaseUpdated: 'Wissensbasis aktualisiert',
    AcKnowledgeBaseUpdatedMsg: 'Wir trainieren den Agenten mit den neuen Dateien. Die Anpassung kann ca. 5 Minuten dauern.',
    AcOnlyPdfDocxTxt: 'Nur PDF, DOCX oder TXT Dateien erlaubt',
    AcTooLong: 'Zu lang',
    AcNoAgentsFound: 'Keine Agenten gefunden',
    AcNoAgentsFoundMsg: 'Sie haben noch keine eigenen Agenten erstellt. Möchten Sie jetzt einen Agenten erstellen?',
    AcCreateAgent: 'Agent erstellen',
    AcCopiedHeader: 'Kopiert',
    AcMessageCopied: 'Nachricht wurde in die Zwischenablage kopiert.',
    AcSavedHeader: 'Gespeichert',
    AcMessageSavedToMemory: 'Nachricht wurde im Gedächtnis gespeichert.',
    AcFileOpenFailed: 'Die Datei konnte nicht geöffnet werden.',
    AcFileDownloadFailed: 'Die Datei konnte nicht heruntergeladen werden.',
    AcNowActivate: 'Jetzt aktivieren',
    AcCancelOnboarding: 'Onboarding abbrechen?',
    AcContinueConfiguring: 'Weiter konfigurieren',
    AcFinishAnyway: 'Trotzdem beenden',
    AcMandatoryStepsPending: 'Pflichtschritte ausstehend',
    AcGoBack: 'Zurueck',
    AcContinueAnyway: 'Trotzdem fortfahren',

    // Workflow Builder (Wb prefix)
    WbDemoDataLoad: 'Demo-Daten laden',
    WbSelectConfiguration: 'Konfiguration auswählen',
    WbStartNewConfiguration: 'Neue Konfiguration starten',
    WbDeleteLocation: 'Standort löschen',
    WbNoLocationsAvailable: 'Keine Standorte verfügbar',
    WbSelectMemberType: 'Mitgliedstyp auswählen',
    WbAddHumanTeamMember: 'Menschliches Teammitglied hinzufügen',
    WbSelectAgentCollection: 'Agenten-Sammlung auswählen',
    WbSelectAgent: 'Agent auswählen',
    WbAddApiMember: 'API-Mitglied hinzufügen',
    WbDeleteWorkflow: 'Workflow löschen',
    WbCancelWorkflow: 'Workflow abbrechen',
    WbUseTemplate: 'Vorlage verwenden',
    WbTestWorkflow: 'Workflow testen?',
    WbSelectTeam: 'Team auswählen',
    WbInviteToPlatform: 'Zur Plattform einladen',
    WbInvitationSent: 'Einladung gesendet',
    WbAddKnowledge: 'Wissen hinzufügen',
    WbTestAgent: 'Agent testen',
    WbConnectAgents: 'Agenten verbinden',
    WbLoadTemplate: 'Vorlage laden',
    WbConfigureTriggerFor: 'Trigger konfigurieren für',
    WbTriggerManual: 'Manuell (Bei Bedarf)',
    WbTriggerTimeBased: 'Zeitbasiert (Täglich)',
    WbTriggerInterval: 'Intervall (Wiederholend)',
    WbTriggerApiWebhook: 'API Webhook',
    WbNext: 'Weiter',
    WbSave: 'Speichern',
    WbTriggerSaved: 'Trigger-Konfiguration gespeichert für',
    WbConfigureSchedule: 'Zeitplan konfigurieren',
    WbConfigureInterval: 'Intervall konfigurieren',
    WbScheduleTimePlaceholder: 'Zeit eingeben (z.B. 09:00)',
    WbScheduleIntervalPlaceholder: 'Intervall eingeben (z.B. 30m, 1h, 2d)',
    WbConfigureApiWebhook: 'API Webhook konfigurieren',
    WbApiEndpointPlaceholder: 'API Endpoint URL eingeben',

    // Hybrid Dashboard (Hd prefix)
    HdFindCandidates: 'Kandidaten finden',
    HdFindCandidatesEn: 'Find candidates',
    HdAutomateOutreach: 'Outreach automatisieren',
    HdAutomateOutreachEn: 'Automate outreach',
    HdScreenFaster: 'Schneller screenen',
    HdScreenFasterEn: 'Screen faster',
    HdBuildPipeline: 'Pipeline aufbauen',
    HdBuildPipelineEn: 'Build pipeline',
    HdIntegrateTools: 'Tools integrieren',
    HdIntegrateToolsEn: 'Integrate tools',
    HdReduceCosts: 'Kosten senken',
    HdReduceCostsEn: 'Reduce costs',
    HdPositionsFilled: 'Stellen besetzt!',
    HdPositionFilledSingular: 'Stelle besetzt!',
    HdPositionsFilledEn: 'Positions Filled!',
    HdPositionFilledSingularEn: 'Position Filled!',
    HdPositionsNoLongerListed: 'Wir haben festgestellt, dass diese Stellen nicht mehr auf Ihrer Karriereseite verfügbar sind:',
    HdPositionNoLongerListed: 'Wir haben festgestellt, dass diese Stelle nicht mehr auf Ihrer Karriereseite verfügbar ist:',
    HdPositionsNoLongerListedEn: 'We noticed these positions are no longer listed on your careers page:',
    HdPositionNoLongerListedEn: 'We noticed this position is no longer listed on your careers page:',
    HdDidMonaHelp: 'Hat MONA AI Ihnen bei der Besetzung geholfen?',
    HdDidMonaHelpEn: 'Did MONA AI help you fill it?',
    HdDidMonaHelpPlural: 'Hat MONA AI Ihnen bei der Besetzung geholfen?',
    HdDidMonaHelpPluralEn: 'Did MONA AI help you fill them?',
    HdYesMonaHelped: 'Ja, MONA hat geholfen!',
    HdYesMonaHelpedEn: 'Yes, MONA helped!',
    HdNoOtherSource: 'Nein, andere Quelle',
    HdNoOtherSourceEn: 'No, other source',
    HdNotFilledYet: 'Noch nicht besetzt',
    HdNotFilledYetEn: 'Not filled yet',
    HdThanksForFeedbackHelped: 'Danke für Ihr Feedback! Wir freuen uns, dass wir helfen konnten.',
    HdThanksForFeedbackHelpedEn: 'Thanks for your feedback! We\'re glad we could help.',
    HdThanksForFeedback: 'Danke für Ihr Feedback!',
    HdThanksForFeedbackEn: 'Thanks for your feedback!',
    HdLinkedInConnected: 'LinkedIn verbunden',
    HdLinkedInConnectedEn: 'LinkedIn Connected',
    HdLinkedInConnectedMsg: 'Dein LinkedIn-Konto wurde erfolgreich verbunden. Du kannst jetzt Kandidaten auf LinkedIn suchen.',
    HdLinkedInConnectedMsgEn: 'Your LinkedIn account has been successfully connected. You can now search candidates on LinkedIn.',
    HdLinkedInConnectionError: 'Die LinkedIn-Verbindung konnte nicht gespeichert werden. Bitte versuche es erneut.',
    HdLinkedInConnectionErrorEn: 'Could not save LinkedIn connection. Please try again.',
    HdLinkedInAgent: 'LinkedIn Agent',
    HdLinkedInAgentDesc: 'KI-Agent für LinkedIn Sourcing, Lead-Generierung und Outreach-Kampagnen.',
    HdLinkedInAgentDescEn: 'AI agent for LinkedIn sourcing, lead generation, and outreach campaigns.',
    HdLinkedInAgentGreeting: 'Hallo! Ich bin dein LinkedIn Agent. Ich helfe dir, Kandidaten auf LinkedIn zu finden und zu kontaktieren.',
    HdLinkedInAgentGreetingEn: 'Hello! I\'m your LinkedIn Agent. I help you find and contact candidates on LinkedIn.',
    HdDashboardHelper: 'Dashboard Helper',
    HdDashboardHelperDesc: 'Interner Hilfsagent für Dashboard-Kalender- und E-Mail-Operationen. Verwaltet Kalendertermine und E-Mail-Kommunikation.',
    HdDashboardHelperDescEn: 'Internal helper agent for dashboard calendar and email operations. Manages calendar events and email communications.',
    HdDashboardHelperInstructions: 'Du bist ein Dashboard-Hilfsagent, der Kalendertermine und E-Mail-Kommunikation verwaltet. Hilf Nutzern, ihren Kalender anzuzeigen, Meetings zu planen und E-Mail-Operationen effizient zu verwalten.',
    HdDashboardHelperInstructionsEn: 'You are a dashboard helper agent that manages calendar events and email communications. Help users view their calendar, schedule meetings, and manage email operations efficiently.',
    HdJobMonitoring: 'Job-Monitoring',
    HdJobMonitoringEn: 'Job Monitoring',
    HdPositionsDaily: 'Stellen · Tägliche Prüfung',
    HdPositionsDailyEn: 'positions · Daily check',
    HdCareersPage: 'Karriereseite',
    HdCareersPageEn: 'Careers Page',
    HdOpenPositions: 'Offene Stellen',
    HdOpenPositionsEn: 'Open Positions',
    HdFound: 'gefunden',
    HdFoundEn: 'found',
    HdLastCheck: 'Letzte Prüfung',
    HdLastCheckEn: 'Last Check',
    HdNever: 'Noch nie',
    HdNeverEn: 'Never',
    HdWorkflowDesc: 'Dieser Workflow prüft täglich automatisch Ihre Stellenangebote und synchronisiert sie in unsere Plattform. Die synchronisierten Daten finden Sie unter "Externe Stellenangebote" im Menü.',
    HdWorkflowDescEn: 'This workflow automatically checks your job listings daily and syncs them into our platform. You can find the synced data under "External Job Offers" in the menu.',
    HdRefreshNow: 'Jetzt aktualisieren',
    HdRefreshNowEn: 'Refresh now',
    HdClose: 'Schließen',
    HdCloseEn: 'Close',
    HdJobsRefreshed: 'Stellenangebote wurden aktualisiert',
    HdJobsRefreshedEn: 'Job listings have been refreshed',
    HdRefreshFailed: 'Fehler beim Aktualisieren',
    HdRefreshFailedEn: 'Failed to refresh',
    HdNotetakerConfigured: 'Notetaker konfiguriert!',
    HdNotetakerConfiguredEn: 'Notetaker Configured!',
    HdNotetakerConfiguredMsg: 'Dein Notetaker-Agent wurde erstellt. Lade notetaker@mona-agents.com zu deinem nächsten Meeting ein.',
    HdNotetakerConfiguredMsgEn: 'Your Notetaker agent has been created. Invite notetaker@mona-agents.com to your next meeting.',
    HdOptimizeJobPostings: 'Optimiere meine Stellenanzeigen für mehr Bewerbungen und besseres SEO',
    HdOptimizeJobPostingsEn: 'Optimize my job postings for more applications and better SEO',
    HdLinkedInConnectError: 'LinkedIn-Verbindung konnte nicht gestartet werden. Bitte versuche es erneut.',
    HdLinkedInConnectErrorEn: 'Could not start LinkedIn connection. Please try again.',
    HdError: 'Fehler',
    HdErrorEn: 'Error',

    // mona-communication-list translations
    LadeMatchesImHintergrund: 'Lade Matches im Hintergrund...',
    LadeVertriebshistorieImHintergrund: 'Lade Vertriebshistorie im Hintergrund...',
    ProzentAbgeschlossen: '% abgeschlossen',
    MatchesGeladen: 'Matches geladen',
    WeitereMatchesLaden: 'Matches laden',
    Lade: 'Lade...',
    MatchingAusgewaehlt: 'Matching ausgewählt',
    KeineDatenVorhanden: 'Keine Daten vorhanden',
    WeitereKontakteLaden: 'Kontakte laden',
    Ladet: 'Lädt...',
    KorrespondenzenGeladen: 'Korrespondenzen geladen',
    WeitereLaden: 'laden',
    Weitere: 'Weitere',
    PDFOeffnen: 'PDF öffnen',
    EmailAnzeigen: 'E-Mail anzeigen',
    Dokument: 'Dokument',
    Kriterien: 'Kriterien',
    JobOffer: 'Job Offer',
    EmailEditor: 'Email Editor',
    SwitchToNormalMode: 'Switch to Normal Mode',
    SwitchToHTMLMode: 'Switch to HTML Mode',
    EmailVorschau: 'Email Vorschau',
    UploadAttachment: 'Upload Attachment',
    Uploading: 'Uploading…',
    UploadBtn: 'Upload',
    MatchingHeader: 'Matching',

    // mona-agent-builder.page
    AgentBuilderEditAgent: 'Agent bearbeiten',
    AgentBuilderCreateNewAgent: 'Neuen Agent erstellen',
    AgentBuilderSelectAgent: 'Agent auswählen',
    AgentBuilderUpdateAgent: 'Agent aktualisieren',
    AgentBuilderCreateMyAgent: 'Meinen Agenten erstellen',
    AgentBuilderStep1Title: 'Schritt 1: Grundinformationen',
    AgentBuilderStep1Short: 'Schritt 1',
    AgentBuilderStep2Title: 'Schritt 2: Konfiguration',
    AgentBuilderStep2Short: 'Schritt 2',
    AgentBuilderStep3Title: 'Schritt 3: Anweisungen',
    AgentBuilderStep3Short: 'Schritt 3',
    AgentBuilderStep4Title: 'Schritt 4: Zugriffsrechte',
    AgentBuilderStep4Short: 'Schritt 4',
    AgentBuilderStep5Title: 'Zusammenfassung',
    AgentBuilderMONAIntroTitle: 'MONA wird:',
    AgentBuilderMONAIntroBullet1: '1–3 gezielte Fragen zu Ihren Personalherausforderungen stellen',
    AgentBuilderMONAIntroBullet2: 'Tools empfehlen und Anweisungen basierend auf Ihren Bedürfnissen generieren',
    AgentBuilderMONAIntroBullet3: 'Ihnen die Wahl zwischen Individuellem Agent (mit Tools) oder MONARI Agent (konversational) geben',
    AgentBuilderMONAResultTitle: 'MONA AI Konfiguration abgeschlossen',
    AgentBuilderMONARecommendedTools: 'Empfohlene Tools:',
    AgentBuilderMONAGeneratedInstructions: 'Generierte Anweisungen:',
    AgentBuilderMONAResultHint: 'Wählen Sie unten Ihren bevorzugten Agententyp – Tools werden nur von Individuellen Agents verwendet.',
    AgentBuilderMONAITitle: 'MONA AI Interview',
    AgentBuilderMONAQuestionWord: 'Frage',
    AgentBuilderMONAOfTotal: 'von',
    AgentBuilderMONAPreviousAnswers: 'Ihre vorherigen Antworten:',
    AgentBuilderMONAAnswerPrefix: 'F',
    AgentBuilderMONATextareaPlaceholder: 'Bitte beschreiben Sie Ihre Personalherausforderungen detailliert...',
    AgentBuilderMONASkipInterview: 'Interview überspringen',
    AgentBuilderMONANextQuestion: 'Nächste Frage',
    AgentBuilderMONAGenerateAgent: 'Agent generieren',
    AgentBuilderAgentNameLabel: 'Agenten-Name',
    AgentBuilderAgentNameHint: 'Wählen Sie einen eindeutigen, beschreibenden Namen für Ihren Agenten (max. 20 Zeichen)',
    AgentBuilderDuplicateName: 'Dieser Name wird bereits verwendet.',
    AgentBuilderAgentIconLabel: 'Agent Icon',
    AgentBuilderAgentIconHint: 'Wählen Sie ein Icon für Ihren Agent oder lassen Sie es automatisch auswählen',
    AgentBuilderChangeIcon: 'Icon ändern',
    AgentBuilderChooseAgentIcon: 'Agent Icon wählen',
    AgentBuilderUploadOwnImage: 'Eigenes Bild hochladen',
    AgentBuilderUploadImage: 'Bild hochladen',
    AgentBuilderSupportedFormats: 'Unterstützte Formate: JPG, PNG, GIF, WebP (max. 5MB)',
    AgentBuilderYourUploadedImages: 'Ihre hochgeladenen Bilder',
    AgentBuilderCustomBadge: 'Eigenes',
    AgentBuilderStandardIcons: 'Standard Icons',
    AgentBuilderAgentTypeLabel: 'Agenten-Typ',
    AgentBuilderAgentTypeHint: 'Wählen Sie, welche Art von Agent Sie erstellen möchten',
    AgentBuilderCustomAgentTitle: 'Individueller Agent',
    AgentBuilderCustomAgentSubtitle: 'Perfekt für Aufgabenautomatisierung',
    AgentBuilderCustomAgentFeat1: 'Kann Tools verwenden (E-Mail, Datenbank, etc.)',
    AgentBuilderCustomAgentFeat2: 'Führt Aktionen und Aufgaben aus',
    AgentBuilderCustomAgentFeat3: 'Integriert sich in Ihren Workflow',
    AgentBuilderMonariAgentTitle: 'Monari Agent',
    AgentBuilderMonariAgentSubtitle: 'Perfekt für Gespräche & Beratung',
    AgentBuilderMonariFeat1: 'Wissensbasierte Gespräche',
    AgentBuilderMonariFeat2: 'Expertenberatung & Anleitung',
    AgentBuilderMonariFeat3: 'Keine Tools – reine Konversation',
    AgentBuilderExpertiseLabel: 'Fachbereiche',
    AgentBuilderExpertiseHint: 'Fügen Sie Bereiche hinzu, in denen Ihr Monari Agent spezialisiert ist (z.B. recruiting, talentakquise)',
    AgentBuilderExpertisePlaceholder: 'z.B. recruiting, talentakquise, hr_strategie',
    AgentBuilderGreetingLabel: 'Begrüßungsnachricht',
    AgentBuilderGreetingHint: 'Schreiben Sie eine einladende Nachricht, die Ihr Monari Agent zur Begrüßung der Benutzer verwenden wird',
    AgentBuilderGreetingPlaceholder: 'Geben Sie eine Begrüßungsnachricht für Ihren Monari Agent ein',
    AgentBuilderToolsLabel: 'Verfügbare Tools',
    AgentBuilderToolsHint: 'Wählen Sie die Tools aus, die Ihr Individueller Agent zur Durchführung von Aufgaben verwenden kann',
    AgentBuilderToolsAutoMONA: 'Tools automatisch von MONA AI basierend auf Ihren Antworten ausgewählt',
    AgentBuilderSelectAllTools: 'Alle auswählen',
    AgentBuilderDeselectAllTools: 'Alle abwählen',
    AgentBuilderToolLockedShort: 'Dieses Tool ist derzeit gesperrt',
    AgentBuilderToolLockedLong: 'Dieses Tool ist derzeit gesperrt und wird in Kürze verfügbar sein.',
    AgentBuilderMONASelectedBadge: 'Von MONA AI ausgewählt',
    AgentBuilderInstructionsLabel: 'Agenten-Anweisungen',
    AgentBuilderInstructionsHint: 'Fügen Sie bis zu 10 klare Anweisungen hinzu, die das Verhalten Ihres Agenten leiten (max. 200 Zeichen pro Anweisung)',
    AgentBuilderMinCharsBanner: 'Mindestens 100 Zeichen in den Anweisungen erforderlich. Es fehlen noch {remaining} Zeichen.',
    AgentBuilderInstructionItem: 'Anweisung',
    AgentBuilderInstructionsAdded: '{current}/10 Anweisungen hinzugefügt',
    AgentBuilderInstructionSidebarTitle: 'Anweisung',
    AgentBuilderInstructionEnter: 'Anweisung eingeben',
    AgentBuilderInstructionPlaceholder: 'Geben Sie hier Ihre Anweisung ein...',
    AgentBuilderInstructionDuplicate: 'Diese Anweisung existiert bereits.',
    AgentBuilderAccessTypeLabel: 'Zugriffstyp',
    AgentBuilderAccessTypeHint: 'Wählen Sie, ob Ihr Agent öffentlich oder eingeschränkt zugänglich sein soll',
    AgentBuilderPublicTitle: 'Öffentlich',
    AgentBuilderPublicDesc: 'Jeder kann diesen Agenten verwenden',
    AgentBuilderRestrictedTitle: 'Eingeschränkt',
    AgentBuilderRestrictedDesc: 'Nur bestimmte E-Mail-Adressen haben Zugriff',
    AgentBuilderApprovalTitle: 'Genehmigung erforderlich',
    AgentBuilderApprovalDesc: 'Benutzer müssen um Erlaubnis fragen, bevor sie den Agenten verwenden können',
    AgentBuilderCreatorLabel: 'Ersteller',
    AgentBuilderAuthorizedUsersLabel: 'Berechtigte Benutzer',
    AgentBuilderAuthorizedUsersHint: 'Fügen Sie Benutzer mit spezifischen Berechtigungen hinzu',
    AgentBuilderPermEditDesc: 'Kann alles (bearbeiten, lesen, chatten)',
    AgentBuilderPermReadDesc: 'Kann chatten und Anweisungen sehen',
    AgentBuilderPermChatDesc: 'Kann nur chatten',
    AgentBuilderEmailPlaceholder: 'E-Mail-Adresse eingeben',
    AgentBuilderPermissionPlaceholder: 'Berechtigung',
    AgentBuilderPermEdit: 'Bearbeiten',
    AgentBuilderPermRead: 'Lesen',
    AgentBuilderPermChat: 'Chatten',
    AgentBuilderSummaryTitle: 'Zusammenfassung',
    AgentBuilderSummaryType: 'Typ',
    AgentBuilderSummaryTools: 'Tools',
    AgentBuilderSelectedCountSuffix: 'ausgewählt',
    AgentBuilderSummaryExpertise: 'Fachbereiche',
    AgentBuilderExpertiseAreasSuffix: 'Bereiche',
    AgentBuilderSummaryInstructions: 'Anweisungen',
    AgentBuilderSummaryInstructionsAddedSuffix: 'hinzugefügt',
    AgentBuilderInstructionsAddedSuffix: 'Anweisungen hinzugefügt',
    AgentBuilderUsersAuthorizedSuffix: 'Benutzer berechtigt',
    AgentBuilderUserCountShort: 'Benutzer',
    AgentBuilderSummaryAccess: 'Zugriff',
    AgentBuilderSummaryApprovalSuffix: 'Genehmigung erforderlich',
    AgentBuilderExportTemplate: 'Als Vorlage exportieren',
    AgentBuilderMyAgents: 'Meine Agents',
    AgentBuilderActive: 'Aktiv',
    AgentBuilderInactive: 'Inaktiv',
    AgentBuilderTypeCustom: 'Individueller Agent',
    AgentBuilderTypeMonari: 'Monari Agent',
    AgentBuilderMONAFloatToggle: 'MONA AI',
    AgentBuilderMONAFloatOn: 'deaktivieren',
    AgentBuilderMONAFloatOff: 'aktivieren',
    AgentBuilderMONAConfiguredToast: 'MONA AI hat Ihren Agenten basierend auf Ihren Antworten konfiguriert! Sie können jetzt Ihren bevorzugten Agententyp wählen.',
    MONAInterviewQuestion1: 'Welcher Bereich—Kandidatensuche, Bewerbungsprüfung, Compliance, Mitarbeiterbindung oder Technologie-Integration—bereitet Ihnen derzeit die größten Schwierigkeiten?',
    MONAInterviewQuestion2: 'Wie viele offene Stellen verwalten Sie und bei welcher Besetzungsrate haben Sie Probleme?',
    MONAInterviewQuestion3: 'Benötigen Sie Echtzeit-Einblicke, automatisierte Nachrichtenkampagnen oder rechtliche Compliance-Prüfungen?',
    AgentBuilderLoading: 'Lädt...',
    AgentBuilderToastToolLocked: 'Dieses Tool ist derzeit gesperrt und wird in Kürze verfügbar sein.',
    AgentBuilderToastAllToolsSelected: 'Alle verfügbaren Tools wurden ausgewählt',
    AgentBuilderToastAllToolsCleared: 'Alle Tools wurden abgewählt',
    AgentBuilderToastAgentNotLoaded: 'Agent-Daten konnten nicht geladen werden',
    AgentBuilderToastLoadedForEdit: 'Agent "{name}" zum Bearbeiten geladen',
    AgentBuilderToastLoadError: 'Fehler beim Laden des Agenten',
    AgentBuilderToastFileLimit: 'Limit erreicht (max. 50 Dateien und 500 MB).',
    AgentBuilderToastFilesQueued: '{count} Datei(en) vorgemerkt. Sie werden nach dem Erstellen des Agenten hochgeladen.',
    AgentBuilderToastFileRemoved: 'Datei entfernt',
    AgentBuilderToastFileRemoveError: 'Konnte Datei nicht entfernen',
    AgentBuilderToastInvalidImage: 'Bitte wählen Sie eine gültige Bilddatei (JPG, PNG, GIF, WebP)',
    AgentBuilderToastImageTooLarge: 'Die Datei ist zu groß. Maximale Größe: 5MB',
    AgentBuilderToastImageUploadOk: 'Bild erfolgreich hochgeladen!',
    AgentBuilderToastUploadFailedGeneric: 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.',
    AgentBuilderToastUploadUnauthorized: 'Keine Berechtigung zum Hochladen. Bitte melden Sie sich erneut an.',
    AgentBuilderToastUploadCanceled: 'Upload wurde abgebrochen.',
    AgentBuilderToastUploadUnknown: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    AgentBuilderToastUploadFirebaseError: 'Firebase-Verbindungsfehler. Bitte laden Sie die Seite neu.',
    AgentBuilderToastToolsLoadFailed: 'Verfügbare Tools konnten nicht geladen werden. Bitte laden Sie die Seite neu.',
    AgentBuilderToastNotLoggedIn: 'Sie sind nicht eingeloggt. Bitte loggen Sie sich erneut ein.',
    AgentBuilderToastDbFailed: 'Datenbankverbindung konnte nicht hergestellt werden. Bitte laden Sie die Seite neu.',
    AgentBuilderToastValidName: 'Bitte geben Sie einen gültigen und eindeutigen Agentennamen ein',
    AgentBuilderToastPickTool: 'Bitte wählen Sie mindestens ein Tool für den individuellen Agenten aus',
    AgentBuilderToastAddInstruction: 'Bitte fügen Sie mindestens eine Anweisung hinzu',
    AgentBuilderToastEmptyInstruction: 'Leere Anweisungen sind nicht erlaubt',
    AgentBuilderToastDuplicateInstruction: 'Doppelte Anweisungen sind nicht erlaubt',
    AgentBuilderToastMinChars: 'Bitte geben Sie mindestens 100 Zeichen in den Anweisungen ein',
    AgentBuilderCreatingAgentLoading: 'Agent wird erstellt...',
    AgentBuilderAccountSetupLoading: 'Ihr Konto wird für die Agentenerstellung eingerichtet...',
    AgentBuilderToastAddExpertise: 'Bitte fügen Sie mindestens einen Fachbereich für den Monari-Agenten hinzu',
    AgentBuilderToastGreetingRequired: 'Bitte geben Sie eine Begrüßungsnachricht für den Monari-Agenten an',
    AgentBuilderToastUpdateSuccess: 'Agent erfolgreich aktualisiert!',
    AgentBuilderToastCreateSuccess: 'Agent erfolgreich erstellt!',
    AgentBuilderToastAnswerRequired: 'Bitte geben Sie eine Antwort',
    AgentBuilderToastExportNameRequired: 'Bitte geben Sie einen Agentennamen ein, bevor Sie exportieren.',
    AgentBuilderToastExportSuccess: 'Agent-Template für "{name}" wurde exportiert!',
    AgentBuilderErrorNotLoggedIn: 'Benutzer nicht eingeloggt. Bitte melden Sie sich erneut an.',
    AgentBuilderErrorStorageInit: 'Firebase Storage konnte nicht initialisiert werden. Bitte laden Sie die Seite neu.',
    AgentBuilderErrorStorageRef: 'Firebase Storage Referenz konnte nicht erstellt werden',
    AgentBuilderErrorUploadTaskRetry: 'Upload-Task konnte nach Neuinitialisierung nicht erstellt werden',
    AgentBuilderErrorUploadTaskFailed: 'Upload-Task konnte nicht erstellt werden',
    AgentBuilderErrorCreateGeneric: 'Erstellung des Agenten fehlgeschlagen.',
    AgentBuilderErrorApiKey: 'API-Schlüssel konnte nicht erstellt werden. Bitte versuchen Sie es später erneut.',
    AgentBuilderErrorNetwork: 'Netzwerkfehler aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    AgentBuilderErrorSystem: 'Systemfehler aufgetreten. Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
    AgentBuilderErrorUnknown: 'Unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    AgentBuilderPermLegendEdit: 'Bearbeiten:',
    AgentBuilderPermLegendRead: 'Lesen:',
    AgentBuilderPermLegendChat: 'Chatten:',

    // mona-agent-chat.page
    AgentChatActive: 'aktiv',
    AgentChatAgentCreating: 'Agent wird erstellt...',
    AgentChatStepPrepareTemplate: 'Template vorbereiten',
    AgentChatStepCreateConfig: 'Konfiguration erstellen',
    AgentChatStepActivateAI: 'KI aktivieren',
    AgentChatStepSave: 'Speichern',
    AgentChatStepFinalize: 'Fertigstellen',
    AgentChatHelloIAm: 'Hallo! Ich bin',
    AgentChatHowCanIHelp: 'Wie kann ich Ihnen helfen?',
    AgentChatAgentsTitle: 'Agenten',
    AgentChatNoCount: 'Keine',
    AgentChatAgentsOnline: 'Agenten Online',
    AgentChatSearchPlaceholder: 'Suche nach Namen, Fähigkeiten oder Beschreibung...',
    AgentChatFilterAll: 'Alle',
    AgentChatFilterExperts: 'Experten-Agenten',
    AgentChatFilterSystem: 'System‑Agenten',
    AgentChatFilterYourAgents: 'Deine Agenten',
    AgentChatPinnedAgents: 'Fixierte Agenten',
    AgentChatPinnedDesc: 'Deine bevorzugten Agenten für schnellen Zugriff',
    AgentChatUnpinAgent: 'Agent entfixieren',
    AgentChatPinAgent: 'Agent fixieren',
    AgentChatCardProfile: 'Profil',
    AgentChatCardExperience: 'Erfahrung',
    AgentChatCardSpecialist: 'Spezialist',
    AgentChatCardKnowledge: 'Wissen',
    AgentChatCardMore: 'weitere',
    AgentChatCardIntegration: 'Integration',
    AgentChatCardRequires: 'Benötigt:',
    AgentChatPublic: 'Öffentlich',
    AgentChatRestricted: 'Eingeschränkt',
    AgentChatApprovalRequired: 'Genehmigung erforderlich',
    AgentChatUsersAuthorized: 'Benutzer berechtigt',
    AgentChatEmailsAuthorized: 'E-Mail(s) berechtigt',
    AgentChatCreatedBy: 'Erstellt von:',
    AgentChatExpertsTitle: 'Experten-Agenten',
    AgentChatExpertsDesc: 'Vorgefertigte Spezialisten für optimale Ergebnisse',
    AgentChatSystemTitle: 'System‑Agenten',
    AgentChatSystemDesc: 'Integrations‑Agenten (ATS) – erfordern Aktivierung unter Integrationen',
    AgentChatYourAgentsTitle: 'Deine Agenten',
    AgentChatYourAgentsDesc: 'Personalisierte Agenten nach deinen Anforderungen',
    AgentChatOwnAgent: 'Eigener Agent',
    AgentChatPersonalAgentDesc: 'Dein persönlicher KI Agent, angepasst an deine spezifischen Bedürfnisse und Arbeitsweise.',
    AgentChatPersonalized: 'Personalisiert',
    AgentChatNoAgentsYet: 'Noch keine Agenten',
    AgentChatCreateFirstDesc: 'Erstelle deinen ersten KI Agenten und starte deine Reise in die Zukunft der Kommunikation',
    AgentChatCreateFirstAgent: 'Ersten Agent erstellen',
    AgentChatNoResults: 'Keine Ergebnisse gefunden',
    AgentChatNoResultsPrefix: 'Keine Agenten entsprechen deiner Suche nach',
    AgentChatNoResultsSuffix: 'Versuche andere Suchbegriffe.',
    AgentChatResetSearch: 'Suche zurücksetzen',
    AgentChatAddAgent: 'Agent hinzufügen',
    AgentChatDragHint: 'Ziehen Sie Nachrichten in ein anderes Fenster, um sie zu teilen',
    AgentChatMessageTo: 'Nachricht an',
    AgentChatDescribeTask: 'Aufgabe beschreiben:',
    AgentChatBrowserPlaceholder: 'z.B. Gehe zu LinkedIn und suche nach Senior Entwicklern in Berlin',
    AgentChatURLOptional: 'URL (optional):',
    AgentChatURLPlaceholder: 'https://beispiel.com',
    AgentChatLivestreamAvailable: 'Livestream verfügbar',
    AgentChatOpenLivestream: 'Livestream öffnen',
    AgentChatCancel: 'Abbrechen',
    AgentChatExecute: 'Ausführen',
    AgentChatCandidatesFound: 'Kandidaten gefunden',
    AgentChatShowDetails: 'Details anzeigen',
    AgentChatExportList: 'Liste exportieren',
    AgentChatRefineSearch: 'Suche verfeinern',
    AgentChatContactFound: 'Kontaktinformationen gefunden',
    AgentChatWorkExperience: 'Berufserfahrung',
    AgentChatSendEmail: 'E-Mail senden',
    AgentChatViewCV: 'Lebenslauf ansehen',
    AgentChatSaveContact: 'Kontakt speichern',
    AgentChatSmsSuccess: 'SMS erfolgreich gesendet',
    AgentChatRecipient: 'Empfänger',
    AgentChatMessageLabel: 'Nachricht',
    AgentChatServerResponse: 'Server-Antwort',
    AgentChatSaveToMemory: 'In Erinnerung speichern',
    AgentChatDataPipeline: 'Datenpipeline',
    AgentChatCallSuccess: 'Anruf erfolgreich',
    AgentChatFilesGenerated: 'Dateien generiert',
    AgentChatDocFailed: 'Dokumenterstellung fehlgeschlagen',
    AgentChatPreview: 'Vorschau',
    AgentChatDownload: 'Herunterladen',
    AgentChatDocError: 'Die Dokumenterstellung wurde abgeschlossen, es wurden jedoch keine Dateien generiert. Bitte überprüfen Sie Ihre Anfrage und versuchen Sie es erneut.',
    AgentChatToggleLivestream: 'Livestream anzeigen/ausblenden',
    AgentChatToolRequired: 'Tool benötigt',
    AgentChatToolNotActivated: 'Dieses Tool ist für den Agenten nicht aktiviert:',
    AgentChatActivating: 'Aktiviere…',
    AgentChatActivateTool: 'Tool aktivieren',
    AgentChatAISpecialist: 'KI-Spezialist',
    AgentChatActivateTemplate: 'Agent-Vorlage aktivieren',
    AgentChatTemplateDesc: 'Dieser spezialisierte KI-Agent wird für Sie personalisiert und in Ihrer Agent-Bibliothek gespeichert.',
    AgentChatSkillsLabel: 'Fähigkeiten:',
    AgentChatCreateAgentBtn: 'Agent erstellen',
    AgentChatAddToConversation: 'Agent zur Unterhaltung hinzufügen',
    AgentChatSearchNameCategory: 'Suche nach Name oder Kategorie',
    AgentChatDeleteLabel: 'Löschen',
    AgentChatAlreadyAdded: 'Bereits hinzugefügt',
    AgentChatClose: 'Schließen',
    AgentChatAITools: 'KI-Tools',
    AgentChatToolsSubtitle: 'Erweitere deine Konversation mit intelligenten Tools',
    AgentChatToolEmail: 'E-Mail',
    AgentChatToolEmailDesc: 'Nachrichten senden',
    AgentChatToolDatabase: 'Datenbank',
    AgentChatToolDatabaseDesc: 'Informationen finden',
    AgentChatToolIndex: 'Index Anzeigendaten',
    AgentChatToolIndexDesc: 'Schnelle Suche',
    AgentChatToolUrlParser: 'URL-Parser',
    AgentChatToolUrlParserDesc: 'Inhalte analysieren',
    AgentChatToolCVParser: 'CV-Parser',
    AgentChatToolCVParserDesc: 'Lebensläufe analysieren',
    AgentChatToolCall: 'Anrufen',
    AgentChatToolCallDesc: 'Telefonate starten',
    AgentChatToolSmsDesc: 'Kurznachrichten',
    AgentChatToolReminder: 'Erinnerung',
    AgentChatToolReminderDesc: 'Termine setzen',
    AgentChatAgentSettings: 'Agent Einstellungen',
    AgentChatUploading: 'Wird hochgeladen…',
    AgentChatFirstMessageBanner: 'Die erste Nachricht kann einen Moment dauern (Agent-Authentifizierung). Danach sind Antworten schnell.',
    AgentChatAttachFile: 'Datei anhängen',
    AgentChatVoiceInput: 'Spracheingabe',
    AgentChatDisclaimer: 'MONA Agents können Fehler machen. Überprüfen Sie wichtige Informationen.',
    AgentChatManageKnowledge: 'Agenten‑Wissen verwalten',
    AgentChatAgentKnowledgeBase: 'Agent-Wissensbasis',
    AgentChatKnowledgeBaseDesc: 'Wird in der Agent-Dokumentenstruktur gespeichert • dauerhaft verfügbar für den Agenten',
    AgentChatChooseFile: 'Datei wählen',
    AgentChatUploadProgress: 'Upload-Fortschritt',
    AgentChatFilesUploadedOf: 'von {total} Dateien hochgeladen',
    AgentChatSuccessLabel: 'Erfolgreich',
    AgentChatErrorLabel: 'Fehler',
    AgentChatDone: 'Fertig',
    AgentChatSupportedFormats: 'Unterstützte Formate: PNG, JPEG, JPG, PDF, TXT, JSON, XML • Es gelten die Upload‑Limits',
    AgentChatPleaseWait: 'Bitte warten',
    AgentChatCVProcessing: 'Lebenslauf wird verarbeitet und Agent erstellt...',
    AgentChatSuccessHeader: 'Erfolg',
    AgentChatAgentCreatedMsg: 'Agent wurde erstellt und dem Konto hinzugefügt.',
    AgentChatNoteHeader: 'Hinweis',
    AgentChatAgentCreatedNote: 'Agent-Erstellung abgeschlossen. Bitte aktualisieren Sie die Agentenliste, falls der Agent nicht sofort sichtbar ist.',
    AgentChatErrorHeader: 'Fehler',
    AgentChatCVError: 'Der Lebenslauf konnte nicht verarbeitet werden.',
    AgentChatNewCandidate: 'Neuer Kandidat',
    AgentChatCVGreeting: 'Hallo! Ich bin {name}, ein automatisch erstellter KI‑Agent basierend auf dem hochgeladenen Lebenslauf.',
    AgentChatCVDescription: 'Automatisch erzeugter Monari‑Agent aus einem Lebenslauf',
    AgentChatPremiumMsg: 'Diese Funktion ist nur für zahlende Nutzer verfügbar (Agents-Pro, Agents-Ultra oder Agents-Enterprise).',
    AgentChatSetupDatabase: 'Datenbank einrichten',
    AgentChatDatabaseEmpty: 'Die Datenbank enthält noch keine Bewerberdaten. Sie können Bewerber hinzufügen über:',
    AgentChatUseCVParser: 'CV Parser verwenden',
    AgentChatGoToIntegrations: 'Zu Integrationen',
    AgentChatConfigureIndex: 'Index konfigurieren',
    AgentChatIndexSetupMsg: 'Um den Index zu aktivieren:\n1. Gehen Sie zu Integrationen\n2. Geben Sie Benutzername und Passwort ein\n3. Generieren Sie einen API-Schlüssel\n4. Aktivieren Sie das Index-Feature in Profil',
    AgentChatGoToProfile: 'Zu Profil',
    AgentChatConfigureEmail: 'E-Mail konfigurieren',
    AgentChatConfigureSMS: 'SMS konfigurieren',
    AgentChatConfigureCalls: 'Anrufe konfigurieren',
    AgentChatEmailSetupFull: 'Um E-Mails zu versenden, müssen Sie einen Firmennamen eintragen und SMTP konfigurieren.',
    AgentChatEmailSetupName: 'Um E-Mails zu versenden, müssen Sie einen Firmennamen in Profil eintragen.',
    AgentChatEmailSetupSmtp: 'Um E-Mails zu versenden, müssen Sie SMTP konfigurieren.',
    AgentChatSmsSetup: 'Um SMS zu versenden, müssen Sie einen Firmennamen in Profil eintragen.',
    AgentChatCallSetup: 'Um Anrufe zu tätigen, müssen Sie einen Firmennamen in Profil eintragen.',
    AgentChatGoToProfileSettings: 'Zu Profil-Einstellungen',
    AgentChatToolExecutedSuffix: 'ausgeführt:',
    AgentChatAgentSelectionError: 'Beim Auswählen des Agenten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    AgentChatWelcomeHowCanIHelp: 'Wie kann ich Ihnen heute helfen?',
    AgentChatWelcomeWhatCanIDo: 'Was kann ich für Sie tun?',
    AgentChatWelcomeHowCanIAssist: 'Womit kann ich Ihnen behilflich sein?',
    AgentChatWelcomeGeneric: 'Hallo! Wie kann ich Ihnen heute helfen?',
    AgentChatExpertGreetingFallback: 'Spezialisierter Experte für deine Anfragen',
    AgentChatUserAgentFallbackDesc: 'Personalisierter Agent basierend auf deinen Anpassungen und Konfigurationen.',
    AgentChatNoAgentsHeader: 'Keine Agenten gefunden',
    AgentChatNoAgentsMsg: 'Sie haben noch keine eigenen Agenten erstellt. Möchten Sie jetzt einen Agenten erstellen?',
    AgentChatLater: 'Später',
    AgentChatSuggestionHelp: 'Wie können Sie mir helfen?',
    AgentChatSuggestionSkills: 'Was sind Ihre Fähigkeiten?',
    AgentChatSuggestionStart: 'Lassen Sie uns beginnen',
    AgentChatSuggestionRecruitment: 'Rekrutierungsstrategie entwickeln',
    AgentChatSuggestionJobPost: 'Stellenausschreibung erstellen',
    AgentChatSuggestionOptimize: 'Bewerbungsprozess optimieren',
    AgentChatSuggestionExecSearch: 'Executive Search durchführen',
    AgentChatSuggestionEvalLeader: 'Führungskraft bewerten',
    AgentChatSuggestionSuccession: 'Nachfolgeplanung erstellen',
    AgentChatCopied: 'Kopiert',
    AgentChatMsgCopied: 'Nachricht wurde in die Zwischenablage kopiert.',
    AgentChatMsgCopyFailed: 'Nachricht konnte nicht kopiert werden.',
    AgentChatNoUserOrAgent: 'Kein Benutzer oder Agent ausgewählt.',
    AgentChatSaved: 'Gespeichert',
    AgentChatMsgSaved: 'Nachricht wurde im Gedächtnis gespeichert.',
    AgentChatMsgSaveFailed: 'Nachricht konnte nicht gespeichert werden.',
    AgentChatMultiWelcome: 'Hallo! Ich bin {name}. Wie kann ich helfen?',
    AgentChatMultiError: 'Fehler beim Senden der Nachricht an den Agenten.',
    AgentChatCodeCopy: 'Code kopieren',
    AgentChatCodeCopied: 'Kopiert!',
    AgentChatCodeCopyFailed: 'Code konnte nicht kopiert werden.',
    AgentChatToolEnabled: 'Das Tool {toolName} wurde aktiviert und dem Agenten hinzugefügt (max. 3 Tools pro Agent). Schicken Sie Ihre Anfrage erneut.',
    AgentChatToolEnableFailed: 'Das Tool konnte nicht aktiviert werden. Bitte versuchen Sie es erneut.',
    AgentChatMaxTools: 'Maximale Anzahl von 3 Tools pro Agent erreicht. Bitte entfernen Sie zuerst ein Tool.',
    AgentChatCandidateSearch: 'Kandidatensuche',
    AgentChatBrowserRunning: 'Browser Automation wird ausgeführt...',
    AgentChatFileOpenError: 'Die Datei konnte nicht geöffnet werden.',
    AgentChatFileDownloadError: 'Die Datei konnte nicht heruntergeladen werden.',
    AgentChatKnowledgeCompany: 'Unternehmen',
    AgentChatKnowledgeAgent: 'Agent',
    AgentChatKnowledgeChat: 'Chat',
    AgentChatKnowledgeUnknown: 'Unbekannt',
    AgentChatNewChat: 'Neuer Chat',
    AgentChatNoMessages: 'Keine Nachrichten',
    AgentChatLastMessage: 'Letzte Nachricht',
    AgentChatActivateIntegration: 'Bitte aktiviere zuerst die Integration "{key}" unter Integrationen, um diesen Agenten zu verwenden.',
    AgentChatActivateNow: 'Jetzt aktivieren',
    AgentChatDetailsFailed: 'Details konnten nicht geladen werden.',
    AgentChatDbHasApplicants: 'Es sind Bewerber in der Datenbank vorhanden. Öffne die Datenpipeline oder stelle Fragen zu deinen Bewerbern.',
    AgentChatDbNoApplicants: 'Keine Bewerber in der Datenbank gefunden. Bitte importiere Bewerber oder aktiviere eine ATS-Integration.',
    AgentChatDbCheckError: 'Fehler beim Prüfen der Bewerber-Datenbank.',
    AgentChatInitializing: 'Initialisiere Agent-Erstellung...',
    AgentChatPrepareTemplateMsg: 'Bereite Agent-Template vor...',
    AgentChatCreateConfigMsg: 'Erstelle Agent-Konfiguration...',
    AgentChatConfigureAIMsg: 'Konfiguriere KI-Fähigkeiten...',
    AgentChatSaveToLibrary: 'Speichere Agent in Ihrer Bibliothek...',
    AgentChatAgentCreatedSuccess: 'Agent erfolgreich erstellt!',
    AgentChatGenerationError: 'Bei der Agent-Erstellung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    AgentChatFileUploadSuccess: 'Die Datei "{fileName}" wurde erfolgreich zur Wissensdatenbank des Agenten hinzugefügt.',
    AgentChatFileDeleteSuccess: 'Die Datei "{fileName}" wurde erfolgreich aus der Wissensdatenbank entfernt.',
    AgentChatFileDeleteFailed: 'Die Datei konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
    AgentChatChooseKnowledgeType: 'Wähle Wissenstyp',
    AgentChatWhereToSave: 'Wo soll diese Datei gespeichert werden?',
    AgentChatChatOnly: 'Nur für diesen Chat',
    AgentChatCompanyKnowledge: 'Unternehmens-Wissensbasis',
    AgentChatCompanyUploadSuccess: 'Die Datei wurde zur Unternehmens-Wissensbasis hinzugefügt.',
    AgentChatUploadErrorHeader: 'Upload Fehler',
    AgentChatUploadFallbackMsg: 'Die Datei konnte nicht hochgeladen werden.',
    AgentChatInvalidFileType: 'Ungültiger Dateityp',
    AgentChatInvalidFileMsg: 'Die Datei "{fileName}" wird nicht unterstützt. Erlaubte Typen: png, jpeg, jpg, pdf, txt, json, xml',
    AgentChatDragDropSuccess: '{count} Datei(en) wurde(n) für diesen Chat hinzugefügt.',
    AgentChatLimitReached: 'Limit erreicht',
    AgentChatLimitReachedMsg: 'Maximal 50 Dateien und 500 MB pro Agent erlaubt.',
    AgentChatKnowledgeUpdated: 'Wissensbasis aktualisiert',
    AgentChatKnowledgeUpdatedMsg: 'Wir trainieren den Agenten mit den neuen Dateien. Die Anpassung kann ca. 5 Minuten dauern.',
    AgentChatToolNameSms: 'SMS',
    AgentChatToolNameEmail: 'E-Mail',
    AgentChatToolNameCall: 'Anruf',
    AgentChatToolNameSearchDb: 'Datenbank durchsuchen',
    AgentChatToolNameSearchIndex: 'Indexsuche',
    AgentChatToolNameReminder: 'Erinnerung',
    AgentChatToolNameCalendar: 'Kalender',
    AgentChatToolNameUrlParser: 'URL-Parser',
    AgentChatToolNameCvParser: 'CV-Parser',
    AgentChatToolNameDocGen: 'Dokument Generator',
    AgentChatToolEmailReady: 'E-Mail Tool ist bereit',
    AgentChatToolDbReady: 'Datenbank Tool ist bereit',
    AgentChatToolIndexReady: 'Index Tool ist bereit',
    AgentChatToolSmsReady: 'SMS Tool ist bereit',
    AgentChatToolCallReady: 'Anruf Tool ist bereit',
    AgentChatToolUrlParserReady: 'URL-Parser ist bereit',
    AgentChatToolCVParserReady: 'CV-Parser ist bereit',
    AgentChatToolReminderReady: 'Erinnerungen sind bereit',
    AgentChatToolCalendarReady: 'Kalender ist bereit',
    AgentChatToolBrowserReady: 'Browser Automation ist bereit',
    AgentChatToolDocGenReady: 'Dokument Generator ist bereit',
    AgentChatBusinessNameMissing: 'Firmenname fehlt',
    AgentChatBusinessNameInProfile: 'Firmenname in Profil fehlt',
    AgentChatFieldLocation: 'Wohnort',
    AgentChatFieldEducation: 'Bildung',
    AgentChatFieldLanguages: 'Sprachen',
    AgentChatSmsDetect: 'SMS gesendet an',
    AgentChatSmsFallback: 'SMS erfolgreich gesendet',
    AgentChatMsgSent: 'Nachricht gesendet',
    AgentChatCallDetect: 'Anruf gestartet',
    AgentChatCallFallback: 'Anruf erfolgreich gestartet',
    AgentChatCallDone: 'Anruf durchgeführt',

    // agent-dashboard.page
    AgentDashboardDropFilesTitle: 'Dateien hier ablegen',
    AgentDashboardDropFilesHint: 'Lassen Sie Ihre Dateien hier fallen, um sie hochzuladen',
    AgentDashboardChatHistory: 'Chat-Verlauf',
    AgentDashboardHistory: 'Verlauf',
    AgentDashboardHelloIAm: 'Hallo! Ich bin',
    AgentDashboardHowCanIHelp: 'Wie kann ich Ihnen helfen?',
    AgentDashboardMessageTo: 'Nachricht an',
    AgentDashboardAgentSelectorTitle: 'Agent auswählen oder wechseln',
    AgentDashboardSelectAgent: 'Agent wählen',
    AgentDashboardUploadFiles: 'Dateien hochladen',
    AgentDashboardSelectMode: 'Modus auswählen',
    AgentDashboardVoiceInput: 'Spracheingabe',
    AgentDashboardExamples: 'Beispiele',
    AgentDashboardBrowserTaskLabel: 'Aufgabe beschreiben:',
    AgentDashboardBrowserTaskPlaceholder: 'z.B. Gehe zu LinkedIn und suche nach Senior Entwicklern in Berlin',
    AgentDashboardExampleUrl: 'https://beispiel.com',
    AgentDashboardLivestreamAvailable: 'Livestream verfügbar',
    AgentDashboardOpenLivestream: 'Livestream öffnen',
    AgentDashboardCancel: 'Abbrechen',
    AgentDashboardExecute: 'Ausführen',
    AgentDashboardFilesGenerated: 'Dateien generiert',
    AgentDashboardDocCreationFailed: 'Dokumenterstellung fehlgeschlagen',
    AgentDashboardPreview: 'Vorschau',
    AgentDashboardDownload: 'Herunterladen',
    AgentDashboardDocCreationNoFiles: 'Die Dokumenterstellung wurde abgeschlossen, es wurden jedoch keine Dateien generiert. Bitte überprüfen Sie Ihre Anfrage und versuchen Sie es erneut.',
    AgentDashboardLivestreamToggle: 'Livestream anzeigen/ausblenden',
    AgentDashboardSmsSuccess: 'SMS erfolgreich gesendet',
    AgentDashboardRecipient: 'Empfänger',
    AgentDashboardMessageLabel: 'Nachricht',
    AgentDashboardServerResponse: 'Server-Antwort',
    AgentDashboardSaveToMemory: 'In Erinnerung speichern',
    AgentDashboardDataPipeline: 'Datenpipeline',
    AgentDashboardCandidatesFound: 'Kandidaten gefunden',
    AgentDashboardContactInfoFound: 'Kontaktinformationen gefunden',
    AgentDashboardWorkExperience: 'Berufserfahrung',
    AgentDashboardCallSuccess: 'Anruf erfolgreich',
    AgentDashboardGdprCompliant: 'DSGVO-konform',
    AgentDashboardGdprDetailsTitle: 'Details zum Datenschutz einsehen',
    AgentDashboardAiActCompliant: 'und AI-Act geprüft',
    AgentDashboardDisclaimer: 'MONA Agents können Fehler machen. Überprüfen Sie wichtige Informationen.',
    AgentDashboardBrowserTaskSection: 'Aufgabenbeschreibung',
    AgentDashboardBrowserTaskModalPlaceholder: 'Beschreiben Sie detailliert, was automatisiert werden soll... Beispiel: Login bei LinkedIn, suche nach Senior Entwicklern in Berlin, extrahiere die ersten 10 Profile',
    AgentDashboardBrowserTargetSite: 'Ziel-Website',
    AgentDashboardBrowserUrlPlaceholder: 'https://beispiel.com (optional)',
    AgentDashboardBrowserCredentials: 'Anmeldedaten (Optional)',
    AgentDashboardBrowserUseCredentials: 'Anmeldedaten verwenden',
    AgentDashboardBrowserEmailPlaceholder: 'E-Mail oder Benutzername',
    AgentDashboardBrowserPasswordPlaceholder: 'Passwort',
    AgentDashboardBrowserAdvancedSettings: 'Erweiterte Einstellungen',
    AgentDashboardBrowserMaxSteps: 'Max. Schritte',
    AgentDashboardBrowserOutputFormat: 'Ausgabeformat',
    AgentDashboardBrowserScreenshots: 'Screenshots aufnehmen',
    AgentDashboardBrowserDebugMode: 'Debug-Modus aktivieren',
    AgentDashboardBrowserExtraction: 'Daten-Extraktion (Optional)',
    AgentDashboardBrowserExtractSpecific: 'Spezifische Daten extrahieren',
    AgentDashboardBrowserFieldName: 'Feldname',
    AgentDashboardBrowserSelectorPlaceholder: 'CSS Selector oder Beschreibung',
    AgentDashboardBrowserAddRule: 'Regel hinzufügen',
    AgentDashboardBrowserTemplates: 'Vorlagen',
    AgentDashboardBrowserLinkedInSearch: 'LinkedIn Suche',
    AgentDashboardBrowserDataScraping: 'Daten Scraping',
    AgentDashboardBrowserFormFilling: 'Formular ausfüllen',
    AgentDashboardBrowserGeneratedCode: 'Generierter Code',
    AgentDashboardBrowserCopy: 'Kopieren',
    AgentDashboardBrowserInsertChat: 'In Chat einfügen',
    AgentDashboardUrlOptional: 'URL (optional):',
    AgentDashboardToolReqBusinessName: 'Firmenname fehlt',
    AgentDashboardToolReqSmtp: 'SMTP E-Mail konfigurieren',
    AgentDashboardEmailToolReady: 'E-Mail Tool ist bereit',
    AgentDashboardEmailToolNotReady: 'Firmenname + SMTP in Profil',
    AgentDashboardDbReqUseCv: 'Nutze CV Parser oder gehe zu Integrationen',
    AgentDashboardDbAccessError: 'Fehler beim Zugriff auf Bewerberdatenbank.',
    AgentDashboardDbToolReady: 'Datenbank Tool ist bereit',
    AgentDashboardDbToolNotReady: 'Nutze CV Parser oder Integrationen',
    AgentDashboardToolReqEnableIndex: 'Index aktivieren',
    AgentDashboardIndexToolReady: 'Index Tool ist bereit',
    AgentDashboardIndexToolNotReady: 'Integrationen → User/Pass + API Key',
    AgentDashboardSmsToolNoBusinessName: 'Firmenname in Profil fehlt',
    AgentDashboardSmsToolReady: 'SMS Tool ist bereit',
    AgentDashboardSmsToolReqUpgrade: 'Upgrade auf Agents-Pro, Ultra oder Enterprise',
    AgentDashboardSmsToolReqBusinessName: 'Firmenname in Profil eintragen',
    AgentDashboardCallToolReady: 'Anruf Tool ist bereit',
    AgentDashboardUrlParserReady: 'URL-Parser ist bereit',
    AgentDashboardCvParserReady: 'CV-Parser ist bereit',
    AgentDashboardReminderReady: 'Erinnerungen sind bereit',
    AgentDashboardCalendarReady: 'Kalender ist bereit',
    AgentDashboardBrowserReady: 'Browser Automation ist bereit',
    AgentDashboardDocGenReady: 'Dokument Generator ist bereit',
    AgentDashboardDefaultGreeting: 'Hallo! Ich bin MONA, Ihr KI\u2011Assistent.',
    AgentDashboardGreetingFallback: 'Hallo! Ich bin {name}.',
    AgentDashboardSendMessageError: 'Entschuldigung, es gab einen Fehler bei der Verarbeitung Ihrer Nachricht.',
    AgentDashboardNewConversation: 'Neues Gespräch',
    AgentDashboardConversation: 'Gespräch',
    AgentDashboardToolNameCall: 'Anruf',
    AgentDashboardToolNameDatabase: 'Datenbank',
    AgentDashboardToolNameIndexSearch: 'Indexsuche',
    AgentDashboardToolNameReminder: 'Erinnerung',
    AgentDashboardToolNameCalendar: 'Kalender',
    AgentDashboardToolNameUrlParser: 'URL-Parser',
    AgentDashboardToolNameCvParser: 'CV-Parser',
    AgentDashboardToolNameDocGen: 'Dokument Generator',
    AgentDashboardAgentInitHeader: 'Agent wird vorbereitet',
    AgentDashboardAgentInitMsg: 'Bitte warten Sie einen Moment, bis der Agent bereit ist.',
    AgentDashboardPremiumMsg: 'Diese Funktion ist nur für zahlende Nutzer verfügbar (Agents-Pro, Agents-Ultra oder Agents-Enterprise).',
    AgentDashboardSetupDbHeader: 'Datenbank einrichten',
    AgentDashboardSetupDbMsg: 'Die Datenbank enthält noch keine Bewerberdaten. Sie können Bewerber hinzufügen über:',
    AgentDashboardUseCvParser: 'CV Parser verwenden',
    AgentDashboardGoToIntegrations: 'Zu Integrationen',
    AgentDashboardConfigIndexHeader: 'Index konfigurieren',
    AgentDashboardConfigIndexMsg: 'Um den Index zu aktivieren:\\n1. Gehen Sie zu Integrationen\\n2. Geben Sie Benutzername und Passwort ein\\n3. Generieren Sie einen API-Schlüssel\\n4. Aktivieren Sie das Index-Feature in Profil',
    AgentDashboardGoToProfile: 'Zu Profil',
    AgentDashboardConfigEmailHeader: 'E-Mail konfigurieren',
    AgentDashboardConfigEmailMsgBoth: 'Um E-Mails zu versenden, müssen Sie einen Firmennamen eintragen und SMTP konfigurieren.',
    AgentDashboardConfigEmailMsgName: 'Um E-Mails zu versenden, müssen Sie einen Firmennamen in Profil eintragen.',
    AgentDashboardConfigEmailMsgSmtp: 'Um E-Mails zu versenden, müssen Sie SMTP konfigurieren.',
    AgentDashboardConfigSmsHeader: 'SMS konfigurieren',
    AgentDashboardConfigSmsMsg: 'Um SMS zu versenden, müssen Sie einen Firmennamen in Profil eintragen.',
    AgentDashboardConfigCallHeader: 'Anrufe konfigurieren',
    AgentDashboardConfigCallMsg: 'Um Anrufe zu tätigen, müssen Sie einen Firmennamen in Profil eintragen.',
    AgentDashboardGoToProfileSettings: 'Zu Profil-Einstellungen',
    AgentDashboardBrowserRunning: 'Browser Automation wird ausgeführt...',
    AgentDashboardBrowserStillRunning: 'Browser Automation läuft noch... (Livestream ist verfügbar)',
    AgentDashboardBrowserStartFailed: 'Browser Automation konnte nicht gestartet werden.',
    AgentDashboardCopiedHeader: 'Kopiert!',
    AgentDashboardCopiedMsg: 'Der Code wurde in die Zwischenablage kopiert.',
    AgentDashboardCopyCodeTitle: 'Code kopieren',
    AgentDashboardCopyCodeFailed: 'Code konnte nicht kopiert werden.',
    AgentDashboardErrorHeader: 'Fehler',
    AgentDashboardSuccessHeader: 'Erfolg',
    AgentDashboardLegalNoticeCall: 'Telefonanruf',
    AgentDashboardLegalNoticeHeader: 'Rechtlicher Hinweis',
    AgentDashboardLegalNoticeMsg: 'Ich bestätige, dass ich berechtigt bin, diese {type} an {target} zu senden/zu starten (Einwilligung & rechtliche Grundlage vorhanden).',
    AgentDashboardConfirm: 'Bestätigen',
    AgentDashboardFallbackTarget: 'diese Nummer',
    AgentDashboardContactLocation: 'Wohnort',
    AgentDashboardContactEducation: 'Bildung',
    AgentDashboardContactLanguages: 'Sprachen',
    AgentDashboardCandidateSearchTitle: 'Kandidatensuche',
    AgentDashboardSearchContextFull: 'Position: {position} • Standort: {location}',
    AgentDashboardSearchContextPosition: 'Position: {position}',
    AgentDashboardPromptCandidateDetails: 'Zeige mir alle verfügbaren Details zu {name}, einschließlich Kontaktdaten, Berufserfahrung, Ausbildung, Fähigkeiten und Lebenslauf.',
    AgentDashboardPromptMultipleCandidates: 'Zeige mir detaillierte Informationen zu folgenden Kandidaten: {names}. Bitte zeige für jeden Kandidaten die vollständigen Kontaktdaten, Berufserfahrung, Fähigkeiten und weitere relevante Informationen.',
    AgentDashboardCsvHeaderNote: 'Notiz',
    AgentDashboardExportFilename: 'kandidaten-liste.csv',
    AgentDashboardPromptRefineSearch: 'Können Sie die Suche verfeinern? Welche zusätzlichen Kriterien soll ich berücksichtigen?',
    AgentDashboardFileOpenFailed: 'Die Datei konnte nicht geöffnet werden.',
    AgentDashboardFileDownloadFailed: 'Die Datei konnte nicht heruntergeladen werden.',
    AgentDashboardSettingsSaved: 'Änderungen gespeichert',
    AgentDashboardSettingsSaveFailed: 'Fehler beim Speichern',
    AgentDashboardAddExpertiseHeader: 'Fachbereich hinzufügen',
    AgentDashboardAddExpertisePlaceholder: 'z.B. Softwareentwicklung',
    AgentDashboardAddButton: 'Hinzufügen',
    AgentDashboardNoProjectConfigured: 'Kein Projekt konfiguriert.',
    AgentDashboardKnowledgeUploaded: 'Datei hinzugefügt. Wir trainieren den Agenten (ca. 5 Minuten).',
    AgentDashboardKnowledgeUploadFailed: 'Upload fehlgeschlagen. Bitte erneut versuchen.',
    AgentDashboardKnowledgeRemoved: 'Datei entfernt',
    AgentDashboardKnowledgeRemoveFailed: 'Konnte Datei nicht entfernen',
    AgentDashboardDeleteAgentHeader: 'Agent löschen',
    AgentDashboardDeleteAgentMsg: 'Bist du sicher, dass du diesen Agenten löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
    AgentDashboardDelete: 'Löschen',
    AgentDashboardBrowserAutomationPrefix: 'Browser Automation:',

    Willkommen: 'Willkommen',
    Hallo: 'Hallo',
    'Wie kann ich Ihnen helfen?': 'Wie kann ich Ihnen helfen?',
    'Nachricht senden': 'Nachricht senden',
    'Sprache wechseln': 'Sprache wechseln',
    Englisch: 'Englisch',
    AgentEinstellungen: 'Agent Einstellungen',
    AgentInformationen: 'Agent Informationen',
    Rolle: 'Rolle',
    PowerUps: 'Power-Ups',
    Aktionen: 'Aktionen',
    AgentZurücksetzen: 'Agent zurücksetzen',
    ChatVerlaufExportieren: 'Chat-Verlauf exportieren',
    newChatButton: 'Neuer Chat',
    powerUpsTitle: 'Power-Ups',
    powerUpsSeeAll: 'Alle anzeigen',
    recentHistory: 'Letzte Chats',
    CommunicationType: 'Kommunikationstyp',
    Phone: 'Telefon',
    PhoneNumber: 'Telefonnummer',
    PleaseEnterAValidNumber: 'Bitte geben Sie eine gültige Nummer ein',
    YourName: 'Ihr Name',
    EnterYourName: 'Geben Sie Ihren Namen ein',
    EnterYourEmail: 'Geben Sie Ihre E-Mail ein',
    Order: 'Auftrag',
    UploadFile: 'Datei hochladen',
    ChooseFile: 'Datei auswählen',
    selectFromLocalFiles: 'Aus lokalen Dateien auswählen',
    FileUploaded: 'Datei hochgeladen:',
    PostalCode: 'Postleitzahl',
    Subject: 'Betreff',
    Message: 'Nachricht',
    ScheduledDatetime: 'Geplante Zeit',
    Send: 'Senden',
    EnterURLLink: 'Geben Sie den URL-Link ein',
    ValidURLMessage: 'Bitte geben Sie eine gültige URL ein, die mit "https://www." beginnt',
    EnterPostalCode: 'Postleitzahl eingeben',
    SearchFor: 'Suchen nach...',
    EnterSubject: 'Betreff eingeben',
    EnterMessage: 'Nachricht eingeben',
    Report: 'Melden',
    chooseReason: 'Grund auswählen',
    OffensiveContent: 'Anstößiger Inhalt',
    HateSpeech: 'Hassrede oder Diskriminierung',
    SpamContent: 'Spam oder irrelevanter Inhalt',
    FalseInformation: 'Falsche oder irreführende Informationen',
    OtherReason: 'Anderer Grund',
    Settings: 'Einstellungen',
    Pinned: 'Fixiert',
    OnlineAndReady: 'Online und bereit',

    ApplicantsWorkflowContact: 'Workflow/Kontakt',
    ApplicantsAIFilter: 'KI-Filter',
    ApplicantsDataTransferInProgress: 'Datentransfer läuft',
    ApplicantsProgress: 'Fortschritt',
    ApplicantsDataImportTestMode: 'Datenimport läuft (TESTMODUS)',
    ApplicantsStatusLabel: 'Status',
    ApplicantsReadingFile: 'Datei wird gelesen...',
    ApplicantsProcessingData: 'Daten werden verarbeitet...',
    ApplicantsImportComplete: 'Import abgeschlossen!',
    ApplicantsTalentionExportInProgress: 'Talention-Export läuft',
    ApplicantsInitializing: 'Initialisierung...',
    ApplicantsExportingToTalention: 'Export zu Talention...',
    ApplicantsExportComplete: 'Export abgeschlossen!',
    ApplicantsSystemStatus: 'Systemstatus',
    ApplicantsEditStatus: 'Status bearbeiten',
    ApplicantsFilterByMona: 'Bewerber nach MONA filtern',
    ApplicantsSelectPosition: 'Stelle auswählen',
    ApplicantsSearchPosition: 'Stelle suchen...',
    ApplicantsNoPositionsFound: 'Keine Stellen gefunden',
    ApplicantsNoCreditsHeader: 'Keine Recruiting-Credits verfügbar',
    ApplicantsOK: 'OK',
    ApplicantsCancel: 'Abbrechen',
    ApplicantsLockedHeader: 'Bewerber gesperrt',
    ApplicantsDataTransferHeader: 'Datentransfer',
    ApplicantsContinue: 'Fortfahren',
    ApplicantsImportTestHeader: 'Testdaten importieren',
    ApplicantsSelectFile: 'Datei auswählen',
    ApplicantsTalentionExportHeader: 'Bewerber zu Talention exportieren',
    ApplicantsTalentionExportAll: 'Alle exportieren',
    ApplicantsTalentionTestExport: 'Testexport',
    ApplicantsRecontactHeader: 'Bewerber für Neukontaktierung vorbereiten',
    ApplicantsRecontactAll: 'Alle verarbeiten',
    ApplicantsDeleteHeader: 'Bewerber löschen',
    ApplicantsDelete: 'Löschen',
    ApplicantsBuyCredits: 'Credits kaufen',
    ProfilePlanBilling: 'Plan & Abrechnung',
    ProfileCVFilter: 'CV-Filter',
    ProfileNoLocations: 'Keine Standorte vorhanden',
    ProfileLocationName: 'Name',
    ProfileLocationAddress: 'Adresse',
    ProfileLocationPhone: 'Telefon',
    ProfileLocationEmail: 'E-Mail',
    ProfileYears: 'Jahre',
    ProfileDays: 'Tage',
    ProfileCurrentAPIKeys: 'Aktuelle API-Schlüssel',
    ProfileAPIKeysDesc: 'Sie können die folgenden API-Schlüssel verwenden, um auf Ihre Daten zuzugreifen.',
    ProfileAPIKey: 'API-Schlüssel',
    ProfileActive: 'Aktiv',
    ProfileInactive: 'Inaktiv',
    ProfileKeyLabel: 'Schlüssel',
    ProfileSecureKeyWarning: 'Dieser sichere Schlüssel funktioniert nicht. Bitte verwenden Sie den generierten Schlüssel.',
    ProfileDelete: 'Löschen',
    ProfileCoreDataAccess: 'Kerndatenzugriff',
    ProfileReadApplicants: 'Bewerber lesen',
    ProfilePushApplicants: 'Bewerber senden',
    ProfileReadJobOffers: 'Stellenangebote lesen',
    ProfilePushJobOffers: 'Stellenangebote senden',
    ProfileReadData: 'Daten lesen',
    ProfilePushData: 'Daten senden',
    ProfileAgentManagement: 'Agent-Verwaltung',
    ProfileReadAgents: 'Agenten lesen',
    ProfilePushAgents: 'Agenten senden',
    ProfileExecuteAgents: 'Agenten ausführen',
    ProfileExecuteWorkflow: 'Workflow ausführen',
    ProfileToolManagement: 'Tool-Verwaltung',
    ProfileReadTools: 'Tools lesen',
    ProfileManageTools: 'Tools verwalten',
    ProfileMatchingAnalytics: 'Matching & Analysen',
    ProfileReadMatching: 'Matching lesen',
    ProfileCreateMatching: 'Matching erstellen',
    ProfileReadAnalytics: 'Analysen lesen',
    ProfileDocumentProcessing: 'Dokumentenverarbeitung',
    ProfileParsing: 'Parsing',
    ProfileCommunication: 'Kommunikation',
    ProfileReadCommunication: 'Kommunikation lesen',
    ProfileAdministrative: 'Verwaltung',
    ProfileManageAPIKeys: 'API-Schlüssel verwalten',
    ProfileSystemAdmin: 'Systemadministrator',
    ProfileLongLivedAPIKey: 'Langlebiger API-Schlüssel',
    ProfileStatus: 'Status',
    ProfileGenerateNewAPIKey: 'Neuen API-Schlüssel generieren',
    ProfileLogout: 'Abmelden',
    ProfileWorkflow: 'Workflow',
    ProfileEditWorkflow: 'Workflow bearbeiten',
    ProfileEmailAutomationSaved: 'E-Mail-Automatisierung erfolgreich gespeichert!',
    ProfileEmailAutomationFailed: 'Fehler beim Speichern der E-Mail-Automatisierung.',
    ProfilePayPerUse: 'Pay-per-Use',
    ProfileCredits: 'Credits',
    ProfileBasic: 'Basis',
    ProfilePopular: 'Beliebt',
    ProfileBestValue: 'Bestes Angebot',
    ProfilePremium: 'Premium',
    ProfilePrivacyPolicy: 'Datenschutzerklärung',
    ProfileTerms: 'AVB',
    ProfileImprint: 'Impressum',
    ProfileReadyToHelp: 'Bereit zu helfen',
    ProfileNoEmailAddress: 'Keine E-Mail-Adresse vorhanden',
    ProfileEmailCopied: 'E-Mail-Adresse kopiert',
    ProfileCopyFailed: 'Kopieren fehlgeschlagen',
    ProfileBrandingCreated: 'Branding-Profil wurde erstellt',
    ProfileBrandingError: 'Fehler beim Erstellen des Branding-Profils',
    ProfileAPIKeyGenerated: 'API-Schlüssel erfolgreich generiert',
    ProfileAPIKeyGenerateFailed: 'Fehler beim Generieren des API-Schlüssels',
    ProfileSoundSaved: 'Globaler Sound gespeichert.',
    ProfileUploadFailed: 'Upload fehlgeschlagen. Bitte erneut versuchen.',
    ProfileUpdatedSuccessfully: 'Erfolgreich aktualisiert',
    ProfileSaved: 'Gespeichert!',
    ProfileSaveError: 'Fehler beim Speichern. Bitte versuchen Sie es erneut.',
    ProfileSuccess: 'Erfolgreich',
    ProfileSaveFailed: 'Fehler beim Speichern',
    CommDashStandardWorkflows: 'Standard-Workflows',
    CommDashOkay: 'Okay',
    CommDashInitializingWorkflows: 'Initialisiere Workflows…',
    CommDashStandardWorkflowsCreated: 'Standard-Workflows erstellt',
    CommDashCreateStandardWorkflows: 'Standard-Workflows erstellen?',
    CommDashWorkflowsExistConfirm: 'Es existieren bereits Workflows. Trotzdem Standard-Workflows hinzufügen?',
    CommDashConfirm: 'Bestätigen',
    CommDashCreate: 'Erstellen',
    CommDashWrongFormat: 'Falsches Format. Bitte laden Sie eine JSON-Datei hoch.',
    UploadImported: 'importiert',
    UploadJobPost: 'Stellenanzeige',
    UploadApplicantsImported: '{count} Bewerber erfolgreich übernommen',
    UploadAdsUpdated: '{count} Anzeigen wurden erfolgreich aktualisiert. Neu hochgeladen: {new}. Insgesamt vorhanden: {total}',
    UploadConfirmContact: 'Sind Sie sicher, dass Sie {count} Bewerber kontaktieren wollen?',
    UploadProcessCannotBeStopped: 'Ist der Prozess einmal gestartet, kann er nicht mehr gestoppt werden.',
    UploadYesStart: 'Ja, starten',
    UploadContactingWithJobOffer: 'Die Bewerber werden jetzt kontaktiert mit der Stellenanzeige: {jobTitle}',
    UploadCorrectJobOffer: 'Ist das sicherlich die richtige Stellenanzeige?',
    AppInfoUnknown: 'unbekannt',
    AppInfoGeneral: 'Allgemein',
    AppInfoDataSaved: 'Daten wurden gespeichert',
    AppInfoEmployeeCreated: 'Mitarbeiter wurde angelegt',
    AppInfoEmailSent: 'E-Mail wurde verschickt',
    AppInfoConfirmArchive: 'Sicher, dass Sie archivieren wollen?',
    AppInfoConfirmDelete: 'Sicher, dass Sie löschen wollen?',
    AppInfoCallError: 'Fehler, Anruf funktioniert nicht',
    AppInfoConfirmPart2: 'Sicher, dass der Bewerber Teil 2 erhält?',
    AppInfoYesSend: 'Ja, Abschicken!',
    AppInfoContactingEmployee: 'Mitarbeiter wird kontaktiert',
    AppInfoNoPersonnelNumber: 'Keine Personalnummer eingetragen',
    AppInfoNoDocs: 'Keine Dokumente hinterlegt',
    AppInfoNoDocsDocx: 'Keine Docx für diese Datei hinterlegt. Prüfen Sie die Benennung der Datei. Sie muss genauso heißen wie die PDF Datei. Nur mit der Endung .docx',
    AppInfoSameLanguage: 'Gleiche Sprache',
    AppInfoSameLanguageMsg: 'Das Gespräch ist bereits in der gleichen Sprache wie die Plattform. Keine Übersetzung nötig.',
    AppInfoTimeout: 'TIMEOUT, bitte erneut einloggen',
    AppInfoVideoOpening: 'Das Video wird in einem neuen Fenster geöffnet',
    AppInfoNoCVUploaded: 'Kein Lebenslauf hochgeladen',
    AppInfoNoInterview: 'Kein Interview mit Bewerber vorhanden',
    AppInfoProfileCreated: 'Profil erstellt',
    AppInfoProfileCreating: 'Profil wird erstellt',
    AppInfoSelectWorkflow: 'Workflow auswählen',
    AppInfoWorkflowStarted: 'Workflow gestartet',
    AppInfoWorkflowStartedMsg: 'Der Workflow wurde erfolgreich gestartet.',
    AppInfoNoWorkflows: 'Keine Workflows verfügbar',
    AppInfoNoWorkflowsMsg: 'Bitte erstellen Sie einen Workflow, bevor Sie diesen Schritt ausführen.',
    AppInfoTimelineError: 'Fehler',
    AppInfoTimelineSuccess: 'Erfolg',
    AppInfoScheduleAppointment: 'BPS - Termin vereinbaren',
    AIAnalyse: 'KI-Analyse',
    AIFitAnalyse: 'KI-Eignungsanalyse',
    Zusammenfassung: 'Zusammenfassung',
    Anforderungen: 'Anforderungen',
    Stärken: 'Stärken',
    Risiken: 'Risiken',
    KeineAIAnalyseVorhanden: 'Keine KI-Analyse vorhanden',
    BewerteteJobs: 'Bewertete Jobs',
    Bestanden: 'Bestanden',
    NichtBestanden: 'Nicht bestanden',
    BesterMatch: 'Bester Match',
    ErkanntesProfilAusCv: 'Erkanntes Profil (aus CV)',
    Jahre: 'Jahre',
    AktuellePosition: 'Aktuelle Position',
    Warnhinweise: 'Warnhinweise',
    Abgelehnt: 'Abgelehnt',
    Begründung: 'Begründung',
    Bedenken: 'Bedenken',
    Vorhanden: 'Vorhanden',
    Fehlend: 'Fehlend',
    Kompatibel: 'Kompatibel',
    NichtKompatibel: 'Nicht kompatibel',
    Ausreichend: 'Ausreichend',
    NichtAusreichend: 'Nicht ausreichend',
    Erkannt: 'Erkannt',
    NichtErkannt: 'Nicht erkannt',
    Rechtskonformität: 'Rechtskonformität',
    Problematisch: 'Problematisch',
    Kosten: 'Kosten',
    KeineCVFilterErgebnisse: 'Keine CV-Filter Ergebnisse vorhanden',
    CanvasElements: 'Canvas-Elemente',
    CanvasNote: 'Notiz',
    CanvasRectangle: 'Rechteck',
    CanvasCircle: 'Kreis',
    CanvasTextBox: 'Textfeld',
    CanvasArrow: 'Pfeil',
    CanvasMarker: 'Marker',
    AddNote: 'Notiz hinzufügen',
    LayerFront: 'Vorne',
    LayerBack: 'Hinten',
    CanvasSavingConfig: 'Konfiguration wird gespeichert',
    CanvasSavingConfigSubtitle: 'Bitte warten Sie, während wir Ihre Änderungen verarbeiten',
    CanvasItemsOf: 'von',
    CanvasItems: 'Elementen',
    CanvasAgentsAndMembers: 'Agenten & Mitarbeiter',
    CanvasTeams: 'Teams',
    CanvasWorkflowsAndNodes: 'Workflows & Nodes',
    CanvasSavingInfoMsg: 'Alle Workflows und Workflow-Nodes werden im Hintergrund auf die neueste Konfiguration aktualisiert. Dies kann einen Moment dauern.',
    CanvasConnectTeams: 'Teams verbinden',
    FitToView: 'Ansicht anpassen',
    SwitchOrganization: 'Organisation wechseln',
    ActiveConnections: 'Aktive Verbindungen',
    WorkflowSimulation: 'Workflow-Simulation',
    SimulationInputPlaceholder: 'Geben Sie Ihre Nachricht ein oder laden Sie Dateien hoch...',
    NoWorkflowSelected: 'Kein Workflow ausgewählt oder keine Steps definiert',
    StartingTestExecution: 'Starte echte Test-Ausführung mit',
    DataValidation: 'Daten-Validierung',
    ErrorInStep: 'Fehler in Step',
    Executed: 'ausgeführt',
    NoAgentConfigured: 'Kein Agent konfiguriert für Step',
    WarningAgentMissing: 'WARNUNG: Agent fehlt',
    NoResponse: 'Keine Antwort',
    Response: 'Antwort',
    AgentResponseReceived: 'Agent-Antwort empfangen',
    Characters: 'Zeichen',
    AgentExecutionFailed: 'Agent-Ausführung fehlgeschlagen',
    NoToolConfigured: 'Kein Tool konfiguriert für Step',
    WarningToolMissing: 'WARNUNG: Tool fehlt',
    Result: 'Ergebnis',
    ToolExecutedSuccessfully: 'Tool erfolgreich ausgeführt',
    ToolExecutionFailed: 'Tool-Ausführung fehlgeschlagen',
    ToolSendEmail: 'E-Mail senden',
    ToolSendSMS: 'SMS senden',
    ToolParseCv: 'Lebenslauf parsen',
    ToolDbQuery: 'Datenbank-Abfrage',
    ToolDbUpdate: 'Datenbank aktualisieren',
    ToolCreateProfile: 'Profil erstellen',
    ToolMatching: 'Matching durchführen',
    ToolCalendar: 'Kalender-Operation',
    ToolPhoneCall: 'Telefonanruf',
    ConditionChecked: 'Bedingung geprüft',
    True: 'WAHR',
    False: 'FALSCH',
    InputData: 'Input-Daten',
    ConditionEvaluated: 'Bedingung evaluiert',
    ApiCall: 'API-Aufruf',
    ApiSuccess: 'API erfolgreich',
    ApiCallFailed: 'API-Aufruf fehlgeschlagen',
    EmailTestMode: 'E-Mail (Test-Modus - nicht versendet)',
    To: 'An',
    Content: 'Inhalt',
    EmailPreparedTestMode: 'E-Mail vorbereitet (Test-Modus)',
    TransformFailed: 'Transformation fehlgeschlagen',
    DataTransformed: 'Daten transformiert',
    Before: 'Vorher',
    After: 'Nachher',
    TransformSuccess: 'Transformation erfolgreich',
    FilesUploaded: 'Datei(en) hochgeladen',
    Knowledge: 'Wissen',
    More: 'weitere',
    StartChat: 'Chat starten',
    Public: 'Öffentlich',
    Restricted: 'Eingeschränkt',
    ApprovalRequired: 'Genehmigung erforderlich',
    UsersAuthorized: 'Benutzer berechtigt',
    EmailsAuthorized: 'E-Mail(s) berechtigt',
    CreatedBy: 'Erstellt von',
    YourAgents: 'Deine Agenten',
    PersonalizedAgentsDesc: 'Personalisierte Agenten nach deinen Anforderungen',
    OwnAgent: 'Eigener Agent',
    Less: 'Weniger',
    Details: 'Details',
    Setup: 'Einrichten',
    PrebuiltSpecialistsDesc: 'Vorgefertigte Spezialisten für optimale Ergebnisse',
    PinAgent: 'Agent fixieren',
    SystemAgents: 'System-Agenten',
    SystemAgentsDesc: 'Integrations-Agenten (ATS) - erfordern Aktivierung unter Integrationen',
    Experience: 'Erfahrung',
    Specialist: 'Spezialist',
    Open: 'Öffnen',
    CanvasClickTeamsToConnect: 'Teams anklicken zum Verbinden',
    CanvasActiveAgents: 'Aktive Agenten',
    CanvasWorkflows: 'Workflows',
    CanvasKIAgentsAndMembers: 'KI-Agenten & Mitarbeiter',
    CanvasAddAgent: 'Agent hinzufügen',
    CanvasNoAgentsAssigned: 'Keine Agenten zugeordnet',
    CanvasNoWorkflows: 'Keine Workflows',
    CanvasNoActiveAgents: 'Keine aktiven Agenten. Starten Sie einen Workflow, um Live-Daten zu sehen.',
    ChatWith: 'Chat mit',
    AskAnythingAbout: 'Frag mich alles über',
    KeyResponsibilities: 'Wichtigste Aufgaben',
    OptimizationTips: 'Optimierungstipps',
    SummarizeStructure: 'Struktur zusammenfassen',
    AskAboutThis: 'Frage zu diesem',
    ChatError: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    Back: 'Zurück',
    Forward: 'Weiter',
    Overview: 'Übersicht',
    Edit: 'Bearbeiten',
    Create: 'Erstellen',
    Update: 'Aktualisieren',
    Guidelines: 'Richtlinien',
    NoItems: 'Keine',
    Yet: 'vorhanden',
    ChatAboutThis: 'Chat über dieses',
    WhatAreKeyResponsibilities: 'Was sind die wichtigsten Aufgaben von diesem ',
    HowCanIOptimize: 'Wie kann ich dieses ',
    SummarizeCurrentStructure: 'Fasse die aktuelle Struktur zusammen',
    EnterDescriptiveName: 'Beschreibenden Namen eingeben',
    NameRequired: 'Name ist erforderlich',
    ParentDepartment: 'Übergeordnete Abteilung',
    NoDepartmentUnassigned: 'Keine Abteilung (Nicht zugewiesen)',
    ParentDivision: 'Übergeordneter Bereich',
    NoDivisionUnassigned: 'Kein Bereich (Nicht zugewiesen)',
    SelectLocation: 'Standort auswählen',
    NoLocationsAvailable: 'Keine Standorte verfügbar. Bitte erstellen Sie zuerst einen Standort.',
    LocationType: 'Standorttyp',
    PhysicalOffice: 'Physisches Büro',
    OnlineRemote: 'Online/Remote',
    StreetAddress: 'Straße',
    EnterStreetAddress: 'Straße eingeben',
    HouseNumber: 'Hausnummer',
    EnterHouseNumber: 'Hausnummer eingeben',
    Address2Optional: 'Adresszusatz (Optional)',
    ApartmentSuiteFloor: 'Wohnung, Etage, etc.',
    City: 'Stadt',
    EnterCity: 'Stadt eingeben',
    ZipCode: 'Postleitzahl',
    EnterZipCode: 'Postleitzahl eingeben',
    Country: 'Land',
    EnterCountry: 'Land eingeben',
    Timezone: 'Zeitzone',
    CompanyDataEnrichment: 'Unternehmensdaten-Anreicherung',
    Searching: 'Suche...',
    SearchCompanyData: 'Unternehmensdaten suchen',
    EnterCompanyNameHint: 'Firmenname oder Website eingeben und auf Suche klicken, um Unternehmensinformationen automatisch auszufüllen',
    Website: 'Website',
    Industry: 'Branche',
    IndustryPlaceholder: 'z.B. Technologie, Gesundheitswesen',
    EmployeeCount: 'Mitarbeiteranzahl',
    Founded: 'Gegründet',
    Headquarters: 'Hauptsitz',
    HeadquartersPlaceholder: 'z.B. Berlin, Deutschland',
    EnrichedCompanyDescription: 'Angereicherte Unternehmensbeschreibung',
    ApplyToAdditionalInfo: 'Zu Zusatzinformationen hinzufügen',
    OverallGoal: 'Gesamtziel',
    GoalPurpose: 'Ziel/Zweck',
    WhatIsMainObjective: 'Was ist das Hauptziel?',
    DescribeGoalPlaceholder: 'Beschreiben Sie das primäre Ziel oder den Zweck...',
    GuidelinesAndPrinciples: 'Richtlinien & Prinzipien',
    OperatingPrinciples: 'Betriebsprinzipien, Regeln oder Richtlinien',
    EnterGuidelinesPlaceholder: 'Geben Sie wichtige Richtlinien, Prinzipien oder Regeln ein...',
    AdditionalInformation: 'Zusätzliche Informationen',
    AnyOtherContext: 'Sonstiger relevanter Kontext oder Details',
    AddContextPlaceholder: 'Fügen Sie zusätzlichen Kontext, Informationen oder Notizen hinzu...',
    ExtendedContext: 'Erweiterter Kontext',
    DetailedCompanyInfo: 'Detaillierte Unternehmensinformationen, Geschichte, Kultur, etc.',
    EnterComprehensiveContext: 'Geben Sie umfassenden Kontext über das Unternehmen ein...',
    SelectOrganization: 'Organisation auswählen',
    YouHave: 'Sie haben',
    OrganizationsSelectOrCreate: 'Organisationen. Wählen Sie eine aus oder erstellen Sie eine neue.',
    SearchOrganizations: 'Organisation suchen...',
    DeptShort: 'Abt.',
    Teams: 'Teams',
    People: 'Personen',
    NoOrganizationFound: 'Keine Organisation gefunden für',
    CreateNewOrganization: 'Neue Organisation erstellen',
    ShowThinkingProcess: 'Denkprozess anzeigen',
    ThinkingProcess: 'Denkprozess',
    Steps: 'Schritte',
    LoadMore: 'Mehr laden',
    Remaining: 'weitere',
    AllLocations: 'Alle Standorte',
    LocationsSelected: 'Standort(e) ausgewählt',
    AllTeams: 'Alle Teams',
    TeamsSelected: 'Team(s) ausgewählt',
    NoLocation: 'Kein Standort',
    NotAssigned: 'Nicht zugewiesen',
    WbSwitchOrganization: 'Organisation wechseln',
    WbOrgAiPlaceholder: 'Frage stellen oder Anweisung geben...',
    WbLoading: 'Laden...',
    WbWebhookSecretPlaceholder: 'Webhook Secret (optional, für HMAC)',
    WbOrganigrammSnapshot: 'Organigramm Snapshot',
    WbNoSnapshotYet: 'Kein Snapshot vorhanden. Der Snapshot wird automatisch beim Speichern des Organigramms erstellt.',
    WbIntegrations: 'Integrationen',
    WbFile: 'Datei',
    WbThinking: 'Denken',
    WbWeb: 'Web',
    WbConnected: 'Verbunden',
    WbCopy: 'Kopieren',
    WbRemove: 'Entfernen',
    WbSchedule: 'Zeitplan',
    WbDaily: 'Täglich',
    WbWeekdays: 'Werktags',
    WbMondays: 'Montags',
    WbEvery4Hours: 'Alle 4 Stunden',
    WbCronExpression: 'Cron-Ausdruck',
    WbResetSimulation: 'Simulation zurücksetzen',
    CanvasSyncedAgent: 'Synchronisierter Agent',
    CanvasActive: 'Aktiv',
    CanvasInactive: 'Inaktiv',
    CanvasDragToReorganize: 'Ziehen zum Reorganisieren',
    WbOrganization: 'Organisation',
    WbShopifyStorePlaceholder: 'Store-Name (z.B. mein-shop.myshopify.com)',
    AcAiTools: 'KI-Tools',
    AcAiToolsSubtitle: 'Erweitere deine Konversation mit intelligenten Tools',
    AcToolEmail: 'E-Mail',
    AcToolEmailDesc: 'Nachrichten senden',
    AcToolDatabase: 'Datenbank',
    AcToolDatabaseDesc: 'Informationen finden',
    AcToolIndexData: 'Index Anzeigendaten',
    AcToolIndexDataDesc: 'Schnelle Suche',
    AcToolUrlParser: 'URL-Parser',
    AcToolUrlParserDesc: 'Inhalte analysieren',
    AcToolCvParser: 'CV-Parser',
    AcToolCvParserDesc: 'Lebensläufe analysieren',
    AcToolCall: 'Anrufen',
    AcToolCallDesc: 'Telefonate starten',
    AcToolSms: 'SMS',
    AcToolSmsDesc: 'Kurznachrichten',
    AcToolReminder: 'Erinnerung',
    AcToolReminderDesc: 'Termine setzen',
    AcToolLinkedIn: 'LinkedIn',
    AcToolLinkedInDesc: 'Leads & Outreach',
    AcPrepareTemplate: 'Template vorbereiten',
    AcCreateConfig: 'Konfiguration erstellen',
    AcActivateAi: 'KI aktivieren',
    AcSaving: 'Speichern',
    AcFinalizing: 'Fertigstellen',
    AcResetSearch: 'Suche zurücksetzen',
    AcAddAgent: 'Agent hinzufügen',
    AcLivestreamAvailable: 'Livestream verfügbar',
    AcContactInfoFound: 'Kontaktinformationen gefunden',
    AcWorkExperience: 'Berufserfahrung',
    AcRecipient: 'Empfänger',
    AcMessage: 'Nachricht',
    AcSaveToMemory: 'In Erinnerung speichern',
    AcMemory: 'Memory',
    AcDataPipeline: 'Datenpipeline',
    AcCallSuccessful: 'Anruf erfolgreich',
    AcDocGenNoFiles: 'Die Dokumenterstellung wurde abgeschlossen, es wurden jedoch keine Dateien generiert. Bitte überprüfen Sie Ihre Anfrage und versuchen Sie es erneut.',
    AcToolRequired: 'Tool benötigt',
    AcToolsTooltip: 'Tools',
    AcFileTooltip: 'Datei',
    AcVoiceTooltip: 'Sprache',
    AcAgentsCanMakeMistakes: 'MONA Agents können Fehler machen. Überprüfen Sie wichtige Informationen.',
    AcOptional: 'Optional',
    AcRequired: 'Pflicht',
    AcClickCreateToSave: 'Klicke auf "Erstellen", um den Agenten in deiner Bibliothek zu speichern.',
    AcCreating: 'Erstelle...',
    AcCreated: 'Erstellt',
    AcCreate: 'Erstellen',
    AcAgentRequiresIntegration: 'Dieser Agent benötigt die',
    AcRequiredIntegration: 'erforderliche',
    AcIntegration: 'Integration',
    AcConfigureIntegrationHint: 'Konfiguriere die Integration unter Integrationen und klicke dann auf "Verbindung prüfen".',
    AcIntegrationConnected: 'Integration erfolgreich verbunden',
    AcOpenIntegrations: 'Integrationen öffnen',
    AcCheckConnection: 'Verbindung prüfen',
    AcConnectLinkedInDesc: 'Verbinde dein LinkedIn-Konto, um Leads zu finden und Outreach-Kampagnen zu starten.',
    AcConnectLinkedInHint: 'Klicke auf "LinkedIn verbinden" — du wirst zu LinkedIn weitergeleitet. Komme danach hierher zurück und klicke "Verbindung prüfen".',
    AcLinkedInConnected: 'LinkedIn erfolgreich verbunden',
    AcWaitingForConnection: 'Warte auf Verbindung...',
    AcConnectLinkedIn: 'LinkedIn verbinden',
    AcGreetingMessage: 'Begrüßungsnachricht',
    AcGreetingPlaceholder: 'Hallo! Wie kann ich dir helfen?',
    AcCommunicationStyle: 'Kommunikationsstil',
    AcSkip: 'Überspringen',
    AcStep: 'Schritt',
    AcBack: 'Zurück',
    AcNext: 'Weiter',
    AcTools: 'Tools',
    AcAgentReady: 'Der Agent ist einsatzbereit.',
    AcAgentCreatedSuccess: 'Agent erfolgreich erstellt!',
    AcAgentCreationError: 'Bei der Agent-Erstellung ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    AcCancelOnboardingMsg: 'Der Agent wurde erstellt, ist aber noch nicht vollständig konfiguriert. Du kannst das Setup später fortsetzen.',
    AcOpenDataPipeline: 'Datenpipeline öffnen',
    AcPipelineConfigured: 'Datenquelle ist eingerichtet',
    AcStyleProfessional: 'Professionell',
    AcStyleFriendly: 'Freundlich',
    AcStyleDirect: 'Direkt',
    AcSaveFailed: 'Die Änderungen konnten nicht gespeichert werden.',
    LinkedInSyncEnable: 'LinkedIn Profil-Sync aktivieren',
    LinkedInSyncReady: 'Der LinkedIn Profil-Sync ist eingerichtet.',
    AcLinkedInNotConnected: 'LinkedIn nicht verbunden',
    AcLinkedInNotConnectedMsg: 'Bitte melde dich im geöffneten Tab bei LinkedIn an und klicke dann auf "Verbindung prüfen".',
    AcLinkedInConnectFailed: 'Beim Verbinden mit LinkedIn ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    AcSaved: 'Gespeichert',
    AcSave: 'Speichern',
    AcDragFilesOr: 'Dateien hierher ziehen oder',
    AcChooseFiles: 'Dateien wählen',
    AcFileTypes: 'PDF, TXT, JSON, XML, Bilder',
    AcUpload: 'Hochladen',
    AcToolsInfoHint: 'MONA Agents haben feste Fähigkeiten. Du kannst hier wählen, welche Tools in der Oberfläche angezeigt werden.',
    AcPipelineInfoHint: 'Verbinde eine Daten-Pipeline, um automatisch Daten (z.B. Leads, E-Mails, Dokumente) an diesen Agenten zu senden.',
    AcNoPipeline: 'Keine Pipeline',
    AcEmailInbox: 'E-Mail Eingang',
    AcWebhook: 'Webhook',
    AcHelloIAm: 'Hallo! Ich bin',
    AcHowCanIHelpToday: 'Wie kann ich Ihnen heute helfen?',
    AcYour: 'Ihr',
    AcISpecializeIn: 'Ich bin spezialisiert auf',
    AcVariousAreas: 'verschiedene Bereiche',
    AcAndHappyToHelp: 'und freue mich, Ihnen zu helfen. Was kann ich für Sie tun?',
    AcAsPersonalizedAgent: 'Als personalisierter KI Agent bin ich hier, um Ihnen bei verschiedenen Aufgaben zu helfen. Womit kann ich Ihnen behilflich sein?',
    AcHelloHowCanIHelp: 'Hallo! Wie kann ich Ihnen heute helfen?',
    AcHowCanIHelp: 'Wie kann ich helfen?',
    AcErrorOccurred: 'Ein Fehler ist aufgetreten.',
    AcVoiceMessageError: 'Fehler beim Senden der Sprachnachricht:',
    AcUnknownError: 'Unbekannter Fehler',
    AcAppointmentError: 'Fehler bei der Terminvereinbarung:',
    AcCreditsExhaustedFull: 'Dein Guthaben ist aufgebraucht. Bitte lade deine Credits auf, um den Agenten weiter nutzen zu können.',
    AcSendMessageError: 'Fehler beim Senden der Nachricht an den Agenten.',
    AcSmsSentSuccessfully: 'SMS erfolgreich gesendet',
    AcCallStartedSuccessfully: 'Anruf erfolgreich gestartet',
    AcToolActivated: 'Das Tool',
    AcToolActivatedMsg: 'wurde aktiviert und dem Agenten hinzugefügt (max. 3 Tools pro Agent). Schicken Sie Ihre Anfrage erneut.',
    AcToolActivationFailed: 'Das Tool konnte nicht aktiviert werden. Bitte versuchen Sie es erneut.',
    AcMaxToolsReached: 'Maximale Anzahl von 3 Tools pro Agent erreicht. Bitte entfernen Sie zuerst ein Tool.',
    AcLeadsSaved: 'erfolgreich in der Datenbank gespeichert.',
    AcBrowserAutomationFailed: 'Browser Automation konnte nicht gestartet werden.',
    AcHowCanYouHelpMe: 'Wie können Sie mir helfen?',
    AcWhatAreYourSkills: 'Was sind Ihre Fähigkeiten?',
    AcLetsGetStarted: 'Lassen Sie uns beginnen',
    AcAutoCreatedCvAgent: 'ein automatisch erstellter KI‑Agent basierend auf dem hochgeladenen Lebenslauf.',
    // workspace-onboarding step "Ready"
    HdObReadyTitle: 'Alles bereit!',
    HdObReadyTitleEn: "You're all set!",
    HdObReadySubtitle: 'Starte jetzt mit der Plattform',
    HdObReadySubtitleEn: 'Start exploring the platform',
    HdObPreparingTitle: 'Wir richten deinen Workspace ein...',
    HdObPreparingTitleEn: 'Preparing your workspace...',
    HdObPreparingSubtitle: 'Wir sammeln Daten, um dein Erlebnis zu personalisieren',
    HdObPreparingSubtitleEn: "We're gathering data to personalize your experience",
    HdObEmptyTitle: 'Workspace angelegt, noch ohne Daten',
    HdObEmptyTitleEn: 'Workspace created, no data yet',
    HdObEmptySubtitle: 'Wir konnten noch keine Stellen oder Kandidaten finden. Leg zuerst eine Stelle an oder importiere deine Daten.',
    HdObEmptySubtitleEn: 'We could not find any positions or candidates yet. Add a position or import your data first.',
    HdObScanCareers: 'Karriereseite wird gescannt',
    HdObScanCareersEn: 'Scanning your careers page',
    HdObInProgress: 'Läuft...',
    HdObInProgressEn: 'In progress...',
    HdObFoundPositions: 'Offene Stellen gefunden',
    HdObFoundPositionsEn: 'open positions found',
    HdObNoPositions: 'Keine offenen Stellen gefunden',
    HdObNoPositionsEn: 'No open positions found',
    HdObCouldNotScan: 'Webseite konnte nicht gescannt werden',
    HdObCouldNotScanEn: 'Could not scan website',
    HdObBackgroundScan: 'KI-Agent analysiert deine Karriereseite im Hintergrund...',
    HdObBackgroundScanEn: 'AI agent is analyzing your careers page in the background…',
    HdObSearchingFor: 'Kandidaten gesucht für',
    HdObSearchingForEn: 'Searching candidates for',
    HdObFoundCandidates: 'passende Kandidaten gefunden',
    HdObFoundCandidatesEn: 'matching candidates found',
    HdObSearchComplete: 'Suche abgeschlossen',
    HdObSearchCompleteEn: 'Search complete',
    HdObSearchFailed: 'Suche fehlgeschlagen',
    HdObSearchFailedEn: 'Search failed',
    HdObAddingPosition: 'Stelle wird hinzugefügt',
    HdObAddingPositionEn: 'Adding role',
    HdObPositionAdded: 'Zu deinen offenen Stellen hinzugefügt',
    HdObPositionAddedEn: 'Added to your open positions',
    HdObPositionFailed: 'Stelle konnte nicht hinzugefügt werden',
    HdObPositionFailedEn: 'Could not add role',
    HdObReadyDesc: 'Öffne einen neuen Tab, um Kandidaten zu suchen, Active Sourcing einzurichten oder Mia um Hilfe zu bitten.',
    HdObReadyDescEn: 'Open a new tab to start searching candidates, set up active sourcing, or ask Mia for help with anything.',
    HdObBack: 'Zurück',
    HdObBackEn: 'Back',
    HdObPleaseWait: 'Bitte warten...',
    HdObPleaseWaitEn: 'Please wait...',
    HdObStartExploring: 'Loslegen',
    HdObStartExploringEn: 'Start Exploring',
    // workspace-onboarding job alternatives panel
    HdObAltTitle: 'Kein Problem — bring deine Stellen auf einem anderen Weg in MONA',
    HdObAltTitleEn: "No worries — let's get your jobs in another way",
    HdObAltSubtitle: 'Wähle die Option, die für dich am besten passt',
    HdObAltSubtitleEn: 'Pick the option that works best for you',
    HdObAltUploadLabel: 'Stellen hochladen',
    HdObAltUploadLabelEn: 'Upload jobs',
    HdObAltUploadDesc: 'Excel-, CSV- oder PDF-Datei',
    HdObAltUploadDescEn: 'Excel, CSV or PDF file',
    HdObAltCreateLabel: 'Manuell anlegen',
    HdObAltCreateLabelEn: 'Create manually',
    HdObAltCreateDesc: 'Stelle in Sekunden anlegen',
    HdObAltCreateDescEn: 'Add a job in seconds',
    HdObAltAtsLabel: 'ATS verbinden',
    HdObAltAtsLabelEn: 'Connect ATS',
    HdObAltAtsDesc: 'Aus deinem System importieren',
    HdObAltAtsDescEn: 'Import from your system',
    HdObAltRetry: 'Erneut versuchen',
    HdObAltRetryEn: 'Try scanning again',
    HdObAltRetrying: 'Wird erneut versucht...',
    HdObAltRetryingEn: 'Retrying...',
    // workspace-onboarding steps 0-5 (welcome, about, hiring, priorities, source, goals)
    WsObWelcomeTitle: 'Willkommen bei MONA AI',
    WsObWelcomeTitleEn: 'Welcome to MONA AI',
    WsObWelcomeSubtitle: 'In unter einer Minute startklar',
    WsObWelcomeSubtitleEn: "Let's get you set up in under a minute",
    WsObWelcomeDesc: 'MONA AI hilft dir, die besten Kandidaten zu finden, anzusprechen und einzustellen — angetrieben von autonomen Recruiting-Agenten.',
    WsObWelcomeDescEn: 'MONA AI helps you find, engage, and hire the best candidates — powered by autonomous recruiting agents.',
    WsObAboutTitle: 'Über dich',
    WsObAboutTitleEn: 'About you',
    WsObAboutSubtitle: 'Erzähl uns etwas über dich und dein Unternehmen',
    WsObAboutSubtitleEn: 'Tell us a bit about yourself and your company',
    WsObHiringTitle: 'Wofür suchst du Personal?',
    WsObHiringTitleEn: 'What are you hiring for?',
    WsObHiringSubtitle: 'Damit füllen wir deine erste Suche vor',
    WsObHiringSubtitleEn: 'This helps us pre-fill your first search',
    WsObPrioritiesTitle: 'Was ist dir am wichtigsten?',
    WsObPrioritiesTitleEn: 'What matters most?',
    WsObPrioritiesSubtitle: 'Wähle 2 von 3 Optionen',
    WsObPrioritiesSubtitleEn: 'Pick 2 of 3 options',
    WsObSourceTitle: 'Wie hast du uns gefunden?',
    WsObSourceTitleEn: 'How did you find us?',
    WsObSourceSubtitle: 'Das hilft uns, besser zu werden',
    WsObSourceSubtitleEn: 'This helps us improve',
    WsObGoalsTitle: 'Deine Ziele',
    WsObGoalsTitleEn: 'Your goals',
    WsObGoalsSubtitle: 'Was möchtest du erreichen?',
    WsObGoalsSubtitleEn: 'What are you looking to achieve?',
    // workspace-onboarding shared controls
    WsObGetStarted: 'Loslegen',
    WsObGetStartedEn: 'Get Started',
    WsObSkipSetup: 'Einrichtung überspringen',
    WsObSkipSetupEn: 'Skip setup',
    WsObContinue: 'Weiter',
    WsObContinueEn: 'Continue',
    WsObSkipContinue: 'Überspringen & weiter',
    WsObSkipContinueEn: 'Skip & Continue',
    WsObOther: 'Sonstiges',
    WsObOtherEn: 'Other',
    // workspace-onboarding about step fields
    WsObYourName: 'Dein Name',
    WsObYourNameEn: 'Your name',
    WsObYourNamePlaceholder: 'z. B. Alex',
    WsObYourNamePlaceholderEn: 'e.g. Alex',
    WsObCompanyWebsite: 'Unternehmenswebsite',
    WsObCompanyWebsiteEn: 'Company website',
    WsObCompanyWebsitePlaceholder: 'z. B. https://acme.com oder acme.com',
    WsObCompanyWebsitePlaceholderEn: 'e.g. https://acme.com or acme.com',
    WsObCompanyName: 'Firmenname',
    WsObCompanyNameEn: 'Company name',
    WsObCompanyNamePlaceholder: 'z. B. Acme GmbH',
    WsObCompanyNamePlaceholderEn: 'e.g. Acme GmbH',
    WsObYourRole: 'Deine Rolle',
    WsObYourRoleEn: 'Your role',
    WsObIndustry: 'Branche',
    WsObIndustryEn: 'Industry',
    WsObCompanySize: 'Unternehmensgröße',
    WsObCompanySizeEn: 'Company size',
    // workspace-onboarding roles
    WsObRoleRecruiter: 'Recruiter',
    WsObRoleRecruiterEn: 'Recruiter',
    WsObRoleHrManager: 'HR-Manager',
    WsObRoleHrManagerEn: 'HR Manager',
    WsObRoleHiringManager: 'Hiring Manager',
    WsObRoleHiringManagerEn: 'Hiring Manager',
    WsObRoleCeoFounder: 'Geschäftsführer / Gründer',
    WsObRoleCeoFounderEn: 'CEO / Founder',
    WsObRoleTeamLead: 'Teamleiter',
    WsObRoleTeamLeadEn: 'Team Lead',
    // workspace-onboarding industries
    WsObIndustryTechnology: 'Technologie',
    WsObIndustryTechnologyEn: 'Technology',
    WsObIndustryFinance: 'Finanzen',
    WsObIndustryFinanceEn: 'Finance',
    WsObIndustryHealthcare: 'Gesundheitswesen',
    WsObIndustryHealthcareEn: 'Healthcare',
    WsObIndustryStaffing: 'Personaldienstleistung',
    WsObIndustryStaffingEn: 'Staffing',
    WsObIndustryManufacturing: 'Produktion',
    WsObIndustryManufacturingEn: 'Manufacturing',
    WsObIndustryConsulting: 'Beratung',
    WsObIndustryConsultingEn: 'Consulting',
    WsObIndustryRetail: 'Einzelhandel',
    WsObIndustryRetailEn: 'Retail',
    WsObIndustrySecurity: 'Sicherheit',
    WsObIndustrySecurityEn: 'Security',
    WsObIndustryLogistics: 'Logistik',
    WsObIndustryLogisticsEn: 'Logistics',
    WsObIndustryConstruction: 'Bau',
    WsObIndustryConstructionEn: 'Construction',
    // workspace-onboarding hiring step
    WsObHiringDescribeRole: 'Ich beschreibe die Stelle',
    WsObHiringDescribeRoleEn: "I'll describe the role",
    WsObHiringCareersPage: 'Ich habe eine Karriereseite',
    WsObHiringCareersPageEn: 'I have a careers page',
    WsObHiringWhichPosition: 'Für welche Position suchst du?',
    WsObHiringWhichPositionEn: 'What position are you hiring for?',
    WsObHiringPositionPlaceholder: 'z. B. Senior Java Entwickler, Pflegekraft, Elektriker',
    WsObHiringPositionPlaceholderEn: 'e.g. Senior Java Developer, Nurse, Electrician',
    WsObHiringPositionHint: 'Damit füllen wir deine erste ARS-Suche vor',
    WsObHiringPositionHintEn: 'This will pre-fill your first ARS search',
    WsObHiringNeedIdeas: 'Brauchst du Ideen? Wähle eine Rolle zum Start:',
    WsObHiringNeedIdeasEn: 'Need ideas? Pick a role to get started:',
    WsObHiringCareersUrl: 'Gib die URL deiner Karriereseite ein',
    WsObHiringCareersUrlEn: 'Enter your careers page URL',
    WsObHiringCareersUrlPlaceholder: 'z. B. karriere.deinunternehmen.de',
    WsObHiringCareersUrlPlaceholderEn: 'e.g. careers.yourcompany.com',
    WsObHiringCareersHint: 'Wir importieren deine offenen Stellen automatisch',
    WsObHiringCareersHintEn: "We'll import your open positions automatically",
    // workspace-onboarding priorities step
    WsObPrioritySpeed: 'Geschwindigkeit',
    WsObPrioritySpeedEn: 'Speed',
    WsObPrioritySpeedDesc: 'Ich muss schnell einstellen',
    WsObPrioritySpeedDescEn: 'I need to hire quickly',
    WsObPriorityQuality: 'Qualität',
    WsObPriorityQualityEn: 'Quality',
    WsObPriorityQualityDesc: 'Nur die besten Kandidaten',
    WsObPriorityQualityDescEn: 'Only the best candidates',
    WsObPriorityPrice: 'Preis',
    WsObPriorityPriceEn: 'Price',
    WsObPriorityPriceDesc: 'Kosteneffizientes Einstellen',
    WsObPriorityPriceDescEn: 'Cost-effective hiring',
    WsObSelectMorePrefix: 'Noch ',
    WsObSelectMorePrefixEn: 'Select ',
    WsObSelectMoreSuffix: ' auswählen',
    WsObSelectMoreSuffixEn: ' more',
    WsObGreatChoice: 'Gute Wahl!',
    WsObGreatChoiceEn: 'Great choice!',
    // workspace-onboarding sources
    WsObSourceFriend: 'Freund / Kollege',
    WsObSourceFriendEn: 'Friend / Colleague',
    WsObSourceWebsite: 'Website',
    WsObSourceWebsiteEn: 'Website',
    // workspace-onboarding goals
    WsObGoalFindCandidates: 'Qualifizierte Kandidaten finden',
    WsObGoalFindCandidatesEn: 'Find qualified candidates',
    WsObGoalAutomateOutreach: 'Ansprache & Follow-ups automatisieren',
    WsObGoalAutomateOutreachEn: 'Automate outreach & follow-ups',
    WsObGoalScreenFaster: 'Kandidaten schneller prüfen',
    WsObGoalScreenFasterEn: 'Screen candidates faster',
    WsObGoalBuildPipeline: 'Talent-Pipeline aufbauen',
    WsObGoalBuildPipelineEn: 'Build a talent pipeline',
    WsObGoalIntegrateTools: 'Bestehende Tools integrieren',
    WsObGoalIntegrateToolsEn: 'Integrate existing tools',
    WsObGoalReduceCosts: 'Einstellungskosten senken',
    WsObGoalReduceCostsEn: 'Reduce hiring costs',
    WsObGoalScheduling: 'Terminplanung für Interviews automatisieren',
    WsObGoalSchedulingEn: 'Automate interview scheduling',
    WsObGoalCvFiltering: 'Automatisiertes CV-Screening',
    WsObGoalCvFilteringEn: 'Automated CV screening',

    //upload.page.html (hybrid upload)
    ExcelImport: 'Excel Import',
    ExcelImportBeschreibung: 'Laden Sie eine Excel-Datei mit Bewerberdaten hoch. Nutzen Sie unsere Vorlage für optimale Ergebnisse.',
    VorlageHerunterladen: 'Vorlage herunterladen',
    CVUploadHinweis: 'Mehrere Lebensläufe? Ziehen Sie einfach Ihre PDF- oder Word-Dateien hierher – wir wechseln automatisch zum CV-Upload.',
    CSVImport: 'CSV Import',
    CSVImportBeschreibung: 'Laden Sie eine CSV-Datei mit Bewerberdaten hoch.',
    CVUploadBeschreibung: 'Laden Sie Lebensläufe als PDF- oder Word-Datei (.docx) hoch. Die KI extrahiert automatisch alle relevanten Daten.',
    PDFsHierherZiehen: 'PDF- oder Word-Dateien hierher ziehen oder klicken',
    MehrereErlaubt: 'mehrere erlaubt',
    Fehler: 'Fehler',
    CVsWerdenAnalysiert: 'CVs werden analysiert...',
    LebensläufeAnalysiert: 'Lebensläufe erfolgreich analysiert',
    DatenUntenPrüfen: 'prüfen Sie die Daten unten',
    EmailWeiterleitung: 'E-Mail Weiterleitung',
    EmailWeiterleitungBeschreibung: 'Leiten Sie Bewerbungs-E-Mails an die folgende Adresse weiter. Die KI verarbeitet sie automatisch.',
    EmailWirdGeneriert: 'E-Mail-Adresse wird generiert...',
    EmailAdresseGenerieren: 'E-Mail-Adresse generieren',
    EmailSchritt1: 'Kopieren Sie die E-Mail-Adresse',
    EmailSchritt2: 'Richten Sie eine Weiterleitung in Ihrem E-Mail-System ein',
    EmailSchritt3: 'Bewerbungen werden automatisch importiert',
    ATSIntegration: 'ATS Integration',
    ATSBeschreibung: 'Verbinden Sie Ihr Bewerbermanagementsystem für automatischen Datenimport.',
    ATSVerbinden: 'ATS verbinden',
    ATSVerbindenBeschreibung: 'Wählen Sie aus unseren verfügbaren Integrationen wie Zvoove, Talention, Index, Compleet und mehr.',
    ZuIntegrationen: 'Zu den Integrationen',
    ImportierteBewerber: 'Importierte Bewerber',
    AuswahlLöschen: 'Auswahl löschen',
    AlleLöschen: 'Alle löschen',
    AlleÜbernehmen: 'Alle übernehmen',
    AuswahlÜbernehmen: 'Auswahl übernehmen',
    ImportNochBestätigen: 'Die Stelle ist noch nicht importiert. Prüfen Sie die erkannten Angaben und bestätigen Sie den Import.',
    ImportBestätigen: 'Import bestätigen',
    Verwerfen: 'Verwerfen',
    Quelle: 'Quelle',
    Bearbeiten: 'Bearbeiten',
    UndWeitere: 'und',
    WeitereBewerber: 'weitere Bewerber',
    WebsiteScraping: 'Website Scraping',
    TextEinfügen: 'Einfügen',
    WebsiteScrapingBeschreibung: 'Geben Sie die URL Ihrer Karriereseite ein. Die KI findet und importiert alle Stellenanzeigen.',
    Analysieren: 'Analysieren',
    GefundeneStellenanzeigen: 'Gefundene Stellenanzeigen',
    AlleImportieren: 'Alle importieren',
    JobExcelBeschreibung: 'Laden Sie eine Excel-Datei mit Stellenanzeigen hoch.',
    JobCSVBeschreibung: 'Laden Sie eine CSV-Datei mit Stellenanzeigen hoch.',
    StellenanzeigEinfügen: 'Stellenanzeige einfügen',
    PasteJobBeschreibung: 'Kopieren Sie eine Stellenanzeige und fügen Sie sie ein. Die KI extrahiert alle relevanten Informationen.',
    StellenanzeigePlaceholder: 'Fügen Sie hier die Stellenanzeige ein...',
    MitKIAnalysieren: 'Mit KI analysieren',
    ErkannteInformationen: 'Erkannte Informationen',
    StellenanzeigenImportieren: 'Stellenanzeige importieren',
    ImportierteStellenanzeigen: 'Importierte Stellenanzeigen',
    UploadErfolgreich: 'Upload erfolgreich',
    AndereDateiHochladen: 'Andere Datei hochladen',

    OrgpageNoOrganizationsYet: 'Noch keine Organisationen',
    OrgpageNewOrganization: 'Neue Organisation',
    OrgpageEdit: 'Bearbeiten',
    OrgpageDelete: 'Löschen',
    OrgpageOverview: 'Organisationsübersicht',
    OrgpageGraph: 'Graph',
    OrgpageDashboards: 'Dashboards',
    OrgpageInsights: 'Einblicke',
    OrgpageAuditLogs: 'Prüfprotokoll',
    OrgpageCopyList: 'Kopierliste',
    OrgpageChat: 'Chat',
    OrgpageAssistant: 'Assistent',
    OrgpageClose: 'Schließen',
    OrgpageThinking: 'Denke nach…',
    OrgpageCreateTheseNodes: 'Diese {{count}} Knoten anlegen?',
    OrgpageCreating: 'Wird erstellt…',
    OrgpageCreate: 'Anlegen',
    OrgpageDiscard: 'Verwerfen',
    OrgpageNoStructureYet: 'Diese Organisation hat noch keine Struktur',
    OrgpageNoStructureHint: 'Die Organisation existiert, aber sie hat noch keine Knoten. Legen Sie den ersten an, um Abteilungen, Bereiche, Teams und Personen hinzuzufügen.',
    OrgpageCreateFirstNode: 'Ersten Knoten anlegen',
    OrgpageClipHintGraph: 'Ziehen Sie einen Eintrag auf die Leinwand. Organisationsmodule hängen unter einem Knoten, auf leerer Fläche an die Unternehmenswurzel. Ein Trigger wird auf leerer Fläche als neuer Workflow angelegt.',
    OrgpageClipHintOverview: 'Ziehen Sie ein Organisationsmodul auf eine Zeile, um es einzufügen. Lassen Sie einen Trigger auf der Liste los, um ihn als neuen Workflow anzulegen.',
    OrgpageClipHintStructure: 'Ziehen Sie einen Eintrag auf die Leinwand. Auf leerer Fläche wird er an diesen Schritt gehängt, auf einem Knoten darunter.',
    OrgpageClipEmpty: 'Fahren Sie mit der Maus über eine Abteilung, einen Bereich, ein Team, einen Agenten, eine Person oder einen Trigger und kopieren Sie. Die Liste wird beim Aktualisieren geleert.',
    OrgpageUnnamed: '(unbenannt)',
    OrgpageNodeCount: '{{count}} Knoten',
    OrgpageRemoveFromList: 'Aus der Liste entfernen',
    OrgpageSelectOrganization: 'Organisation wählen',
    OrgpageListLoadFailed: 'Die Organisationsliste konnte nicht geladen werden.',
    OrgpageSelectOrgFirst: 'Bitte zuerst eine Organisation wählen.',
    OrgpageDeleteOrgHeader: 'Diese Organisation löschen?',
    OrgpageDeleteOrgMessage: 'Sie wird für alle in diesem Konto entfernt. Das kann nicht rückgängig gemacht werden.',
    OrgpageOrgGone: 'Diese Organisation existiert nicht mehr.',
    OrgpageOrgDeleteFailed: 'Die Organisation konnte nicht gelöscht werden.',
    OrgpageTeamAssignFailed: 'Das Team konnte nicht zugeordnet werden.',
    OrgpageChooseOrgFirst: 'Bitte zuerst eine Organisation wählen.',
    OrgpageOrgReadFailed: 'Die Organisation konnte nicht gelesen werden.',
    OrgpageTeamCreateFailed: 'Das Team konnte nicht erstellt werden.',
    OrgpageCreateTeamAtLocationFirst: 'Bitte zuerst ein Team an diesem Standort anlegen.',
    OrgpageLocationSaveFailed: 'Der Standort konnte nicht gespeichert werden.',
    OrgpageAiDone: 'Fertig.',
    OrgpageAiUnreachable: 'Der Assistent war nicht erreichbar. Bitte versuchen Sie es erneut.',
    OrgpageAiTruncated: 'Der Vorschlag wurde am Knotenlimit pro Anfrage gekürzt.',
    OrgpageAiNothingNew: 'Nichts Neues anzulegen — die Struktur stimmt bereits überein.',
    OrgpageAiWouldCreate: 'Damit würden angelegt {{summary}}: {{names}}.',
    OrgpageAiDiscarded: 'Verworfen. Es wurde nichts angelegt.',
    OrgpageAiCreated: '{{count}} Knoten angelegt.',
    OrgpageAiFailedList: 'Fehlgeschlagen: {{list}}.',
    OrgpageAiApplyFailed: 'Die Änderungen konnten nicht übernommen werden.',
    OrgpageAiSuggestion1: 'Eine Vertriebsabteilung mit einem Innendienst-Team anlegen',
    OrgpageAiSuggestion2: 'Ein Support-Team unter Operations hinzufügen',
    OrgpageAiSuggestion3: 'Wie sieht die aktuelle Struktur aus?',
    OrgpageTypePerson: 'Person',
    OrgpageTypeAgent: 'KI-Agent',
    OrgpageTypeTeam: 'Team',
    OrgpageTypeDepartment: 'Abteilung',
    OrgpageTypeDivision: 'Bereich',
    OrgpageTypeTrigger: 'Trigger',
    OrgpageTypePipeline: 'Pipeline',
    OrgpageTypeNode: 'Knoten',
    OrgpageTypeGroup: 'Gruppe',
    OrgpageTypeAiAssistant: 'KI-Assistent',
    OrgpageFilterPlaceholder: 'Abteilungen, Teams, Personen filtern…',
    OrgpageMatches: '{{count}} Treffer',
    OrgpageClearFilter: 'Leeren',
    OrgpageAddToOrg: 'Zur Organisation hinzufügen',
    OrgpageFirstNode: 'Erster Knoten',
    OrgpagePeople: 'Personen',
    OrgpageAI: 'KI',
    OrgpageTeams: 'Teams',
    OrgpageActivity: 'Aktivität',
    OrgpageActive: 'aktiv',
    OrgpageCollapse: 'Einklappen',
    OrgpageExpand: 'Aufklappen',
    OrgpageCopy: 'Kopieren',
    OrgpageCopying: 'Wird kopiert…',
    OrgpageAlreadyInCopyList: 'Bereits in der Kopierliste',
    OrgpageCopied: '{{name}} kopiert',
    OrgpageCopiedN: '{{name}} kopiert ({{count}} Knoten)',
    OrgpageCopyFailed: 'Dieser Knoten konnte nicht kopiert werden.',
    OrgpageItemGone: 'Dieser Eintrag ist nicht mehr in der Kopierliste.',
    OrgpagePasteIntoStep: 'Öffnen Sie Struktur (⋯) auf einem Schritt, um dort Module hinzuzufügen.',
    OrgpageCannotPaste: 'Hier kann nicht eingefügt werden.',
    OrgpagePasteFailed: 'Einfügen fehlgeschlagen: {{reason}}',
    OrgpagePasted: '{{name}} eingefügt',
    OrgpagePastedN: '{{name}} eingefügt ({{count}} Knoten)',
    OrgpagePastedPartial: '{{created}} eingefügt, {{failed}} fehlgeschlagen',
    OrgpageAddToModule: 'Zum Modul hinzufügen',
    OrgpageAddInto: 'Einfügen in {{name}}',
    OrgpageCannotAddHere: 'Hier nicht möglich',
    OrgpageAddConfirm: '„{{src}}“ in „{{dest}}“ einfügen?',
    OrgpageAddAsWorkflow: 'Als Workflow anlegen',
    OrgpageAddWorkflowConfirm: '„{{src}}“ als neuen Workflow anlegen?',
    OrgpageLoadingOrganigram: 'Organigramm wird geladen...',
    OrgpageNoMatches: 'Keine Treffer für „{{query}}“',
    OrgpageLoadFailed: 'Das Organigramm konnte nicht geladen werden — bitte neu laden',
    OrgpageNoOrgData: 'Noch keine Organisationsdaten',
    OrgpageLocations: 'STANDORTE',
    OrgpageShowOnMap: 'Auf der Standortkarte zeigen',
    OrgpageNoLocationsYet: 'Noch keine Standorte',
    OrgpageEditing: 'Bearbeitung',
    OrgpageInactive: 'Inaktiv',
    OrgpageLoading: 'Wird geladen…',
    OrgpageDetailsFailed: 'Details konnten nicht geladen werden.',
    OrgpageDescription: 'Beschreibung',
    OrgpageGoal: 'Ziel',
    OrgpageNoDescription: 'Noch keine Beschreibung.',
    OrgpageAddAStep: 'Schritt hinzufügen',
    OrgpageStructure: 'Struktur',
    OrgpageStructureHint: 'Bearbeiten Sie die Organisation unter diesem Schritt. Nur graue Verbindungen — ziehen zum Umhängen, Hinzufügen für Mitglieder.',
    OrgpageAdd: 'Hinzufügen',
    OrgpageTypeCompany: 'Unternehmen',
    OrgpageName: 'Name',
    OrgpageMembers: 'Mitglieder',
    OrgpageInside: 'Inhalt',
    OrgpageChatWith: 'Chat mit {{name}}',
    OrgpageGuidelines: 'Richtlinien',
    OrgpageThisModule: 'dieses Modul',
    OrgpageCompanyParen: '{{name}} (Unternehmen)',
    OrgpageDiscardUnsaved: 'Ungespeicherte Änderungen verwerfen?',
    OrgpageEditBlockedLoad: 'Das Organigramm konnte nicht geladen werden — bitte neu laden, um zu bearbeiten',
    OrgpageEditBlockedLoading: 'Details werden geladen...',
    OrgpageEditBlockedReopen: 'Details konnten nicht geladen werden — öffnen Sie diesen Eintrag erneut, um zu bearbeiten',
    OrgpageTriggerUnsynced: 'Dieser Trigger ist noch nicht mit dem Workflow-Speicher synchronisiert und kann hier nicht angezeigt werden.',
    OrgpageAddSomeoneFirst: 'Fügen Sie zuerst jemanden hinzu, an den der Trigger senden kann — er braucht einen Knoten.',
    OrgpagePipelineEditNote: 'Quellen, Zeitplan und Schritte werden auf der Seite Datenpipelines bearbeitet.',
    OrgpageWhatRecipientsDo: 'Was jeder Empfänger tut',
    OrgpageNotRegistered: 'Noch nicht registriert',
    OrgpageNoInstruction: 'Noch keine Anweisung',
    OrgpageRunsAfterStep: 'Läuft nach dem vorherigen Schritt',
    OrgpageAssignedTodo: 'Als Aufgabe zugewiesen',
    OrgpageShowMore: 'Mehr anzeigen',
    OrgpageShowLess: 'Weniger anzeigen',
    OrgpageCopiedShort: 'Kopiert',
    OrgpageNoRootPaste: 'Diese Organisation hat keine Wurzel, auf die eingefügt werden kann.',
    OrgpageExportTitle: 'Organisation exportieren',
    OrgpageImportTitle: 'Organisation importieren',
    OrgpageExport: 'Export',
    OrgpageImport: 'Import',
    OrgpageExporting: 'Wird exportiert…',
    OrgpageImporting: 'Wird importiert…',
    OrgpageExportComplete: 'Export abgeschlossen.',
    OrgpageImportComplete: 'Import abgeschlossen.',
    OrgpageExportFailed: 'Die Organisation konnte nicht exportiert werden.',
    OrgpageImportFailed: 'Die Organisation konnte nicht importiert werden.',
    OrgpageImportModuleFailed: 'Dieses Modul konnte nicht importiert werden.',
    OrgpageDownloadZip: 'Zip herunterladen',
    OrgpageCancel: 'Abbrechen',
    OrgpagePause: 'Pause',
    OrgpageResume: 'Fortsetzen',
    OrgpageImportPaused: 'Import pausiert.',
    OrgpageImportStopping: 'Import wird gestoppt. Der aktuelle Schritt wird noch abgeschlossen…',
    OrgpageImportCancelled: 'Import abgebrochen.',
    OrgpageRemovingWrites: 'Angelegte Agenten und Pipelines werden entfernt…',
    OrgpageCleaningImport: 'Der unvollständige Import wird aufgeräumt…',
    OrgpageCancelImportHeader: 'Import abbrechen?',
    OrgpageCancelImportAgents: '{{count}} Agenten wurden bereits angelegt. Sollen diese wieder gelöscht werden?',
    OrgpageCancelImportPipelines: '{{count}} Pipelines wurden bereits angelegt. Sollen diese wieder gelöscht werden?',
    OrgpageCancelImportBoth: 'Es wurden bereits {{agents}} Agenten und {{pipelines}} Pipelines angelegt. Sollen diese wieder gelöscht werden?',
    OrgpageKeepWrites: 'Behalten',
    OrgpageDeleteWrites: 'Löschen',
    OrgpageStopExport: 'Export abbrechen',
    OrgpageExportCancelled: 'Export gestoppt.',
    OrgpageOpenOrganization: 'Organisation öffnen',
    OrgpageOrganization: 'Organisation',
    OrgpageOrgName: 'Organisationsname',
    OrgpageNameTaken: 'In diesem Konto gibt es bereits eine Organisation mit diesem Namen.',
    OrgpageNeedsName: 'Die Organisation braucht einen Namen.',
    OrgpageExportLead: 'Dieses Zip enthält diese Organisation. Prüfen Sie die Inhalte, und laden Sie es dann herunter.',
    OrgpageReadingOrg: 'Organisation wird gelesen…',
    OrgpageImportLead: 'Dieses Zip wird als neue Organisation importiert. Agenten und Pipelines, die in diesem Konto schon existieren, werden wiederverwendet; der Rest wird kopiert.',
    OrgpageImportPeople: 'Personen',
    OrgpageKeepContact: 'Kontaktdaten behalten',
    OrgpageKeepContactHint: 'Name, E-Mail und Telefon wie exportiert. Die ursprüngliche Anmeldung wird nicht übernommen.',
    OrgpageAnonymizePeople: 'Personen anonymisieren',
    OrgpageAnonymizePeopleHint: 'Die Sitze bleiben, E-Mail und Telefon werden durch Platzhalter ersetzt.',
    OrgpageSkipPeople: 'Personen überspringen',
    OrgpageSkipPeopleHint: 'Keine Personen-Knoten anlegen. Teams und Agenten bleiben.',
    OrgpageNodes: 'Knoten',
    OrgpageAgents: 'Agenten',
    OrgpageFiles: 'Dateien',
    OrgpageWarningStat: 'Warnungen',
    OrgpageWarnings: '{{count}} Warnung(en)',
    OrgpageWarningsFromExport: '{{count}} Warnung(en) aus dem Export',
    OrgpageExportedWithWarnings: 'Exportiert mit {{count}} Warnung(en).',
    OrgpageImportedWithWarnings: 'Importiert mit {{count}} Warnung(en).',
    OrgpageReadingZip: 'Zip wird gelesen…',
    OrgpageCouldNotReadZip: 'Diese Datei konnte nicht gelesen werden.',
    OrgpageExportedOrg: 'Exportierte Organisation',
    OrgpageAgentsToCopy: 'Zu kopierende Agenten',
    OrgpagePipelines: 'Pipelines',
    OrgpageLocationsStat: 'Standorte',
    OrgpageTriggersStat: 'Trigger',
    OrgpageKnowledgeStat: 'Wissensdateien',
    OrgpageKnowledgeNotExported: 'Nicht exportiert',
    OrgpageCheckingAccount: 'Dieses Konto wird geprüft…',
    OrgpageWillReuse: 'Bereits vorhanden',
    OrgpageWillCreate: 'Neu',
    OrgpageExportWarnings: 'Export-Warnungen',
    OrgpageFile: 'Datei',
    OrgpageLocationCol: 'Ort',
    OrgpageReason: 'Grund',
    OrgpageExportTrigger: 'Trigger exportieren',
    OrgpageExportModule: 'Modul exportieren',
    OrgpageExportTriggerTitle: 'Trigger exportieren',
    OrgpageExportModuleTitle: 'Modul exportieren',
    OrgpageExportTriggerLead: 'Dieses Zip enthält diesen Trigger inklusive Layout, Agenten, Unternehmensstruktur und Wissensdateien. Prüfen Sie die Inhalte, und laden Sie es dann herunter.',
    OrgpageExportModuleLead: 'Dieses Zip enthält dieses Modul inklusive Layout, Agenten, Unternehmensstruktur und Wissensdateien. Prüfen Sie die Inhalte, und laden Sie es dann herunter.',
    OrgpageImportOrganization: 'Gesamte Organisation',
    OrgpageImportTrigger: 'Trigger-Modul',
    OrgpageImportModule: 'Knoten-Modul',
    OrgpageImportTriggerTitle: 'Trigger importieren',
    OrgpageImportModuleTitle: 'Modul importieren',
    OrgpageImportTriggerLead: 'Dieses Zip wird in die aktuelle Organisation als eigenständiges Trigger-Modul importiert. Agenten und Pipelines, die in diesem Konto schon existieren, werden wiederverwendet; der Rest wird kopiert.',
    OrgpageImportModuleLead: 'Dieses Zip wird in der aktuellen Organisation unter dem Modul eingefügt, das Sie wählen. Agenten und Pipelines, die in diesem Konto schon existieren, werden wiederverwendet; der Rest wird kopiert.',
    OrgpageSelectOrgToImport: 'Wählen Sie zuerst eine Organisation, in die importiert werden soll.',
    OrgpageImportParent: 'Einfügen unter',
    OrgpageImportParentPlaceholder: 'Modul wählen…',
    OrgpageNeedsParent: 'Wählen Sie, unter welchem Modul dieses Modul eingefügt werden soll.',
    OrgpageNoImportParents: 'In dieser Organisation gibt es kein Modul, unter dem eingefügt werden kann.',

    Einloggen: 'Einloggen',
    WelcomeBack: 'Willkommen zurück!',
    Anmelden: 'Anmelden',
    Registrieren: 'Registrieren',
    LoginOder: 'oder',
    PleaseGiveAValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    PleaseGiveAValidPassword: 'Bitte geben Sie ein gültiges Passwort ein.',
    ForgotPassword: 'Passwort vergessen?',
    SignUp: 'Registrieren',
    AutoLoginFailed: 'Automatische Anmeldung nicht möglich. Bitte melde dich mit deinen Zugangsdaten an.',
    RichEmailEditorBulletList: 'Aufzählungsliste',

    //mcp-settings.component.html
    McpNichtVerfuegbar: 'MCP ist in dieser Umgebung noch nicht verfügbar.',
    McpZugriff: 'MCP-Zugriff für ChatGPT, Claude und andere KI-Clients',
    McpServerUrl: 'Server-URL',
    McpErlaubteBerechtigungen: 'Erlaubte Berechtigungen',
    McpMeineVerbindungen: 'Meine Verbindungen',
    McpKeineVerbindungen: 'Keine aktiven Verbindungen',
    McpTrennen: 'Trennen',
    McpVerbindungenFirma: 'Verbindungen der Firma',
    McpNeuVerbindenFuer: 'Neu verbinden für:',
    McpAnleitung: 'So verbinden Sie MONA',
    McpAnleitungClaude: 'Claude: Einstellungen → Connectors → „Add custom connector“, URL einfügen, „Verbinden“ klicken und mit dem MONA-Login anmelden.',
    McpAnleitungChatGPT: 'ChatGPT: Einstellungen → Apps & Connectors → „Create“, URL einfügen, Authentifizierung OAuth wählen und mit dem MONA-Login anmelden.',
    McpAnleitungRechte: 'Der Client erhält nur die hier erlaubten Berechtigungen. Ohne „Kontaktdaten“ werden E-Mail-Adressen und Telefonnummern entfernt. Verbindungen lassen sich jederzeit trennen.',
    McpExterneServer: 'Externe MCP-Server für ARS',
    McpOhneAuth: 'Ohne Auth',
    McpHeaderName: 'Header-Name',
    McpHinzufuegen: 'Hinzufügen',
    McpLesend: 'lesend',
    McpFreigabe: 'Freigabe',
    McpFehler: 'Fehler',
    McpScope_candidates_read: 'Bewerber lesen',
    McpScope_candidates_contact: 'Kontaktdaten von Bewerbern',
    McpScope_jobs_read: 'Stellenangebote lesen',
    McpScope_matching_read: 'Matching-Ergebnisse lesen',
    McpScope_matching_write: 'Matching starten',
    McpScope_knowledge_read: 'Firmenwissen durchsuchen',
    //dashboard-view.component.html
    DashActivity: 'Aktivität',
    DashAddWidget: 'Widget hinzufügen',
    DashAggAvg: 'Durchschnitt',
    DashAggCount: 'Anzahl',
    DashAggGroup: 'Gruppieren und zählen',
    DashAggLatest: 'Neuester Eintrag',
    DashAggList: 'Liste',
    DashAggregation: 'Auswertung',
    DashAggSum: 'Summe',
    DashAiAssistant: 'KI-Assistent',
    DashAiConnection: 'Verbindungsfehler. Bitte versuche es erneut.',
    DashAiDashboardName: 'KI-generiertes Dashboard',
    DashAiError: 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    DashAiGreeting: 'Hallo! Ich baue dir Dashboards aus deinen Plattformdaten und deinen Daten-Pipelines. Beschreibe, was du verfolgen möchtest, oder wähle eine Vorlage.',
    DashAiPlaceholder: 'Beschreibe dein Dashboard …',
    DashAiSkipped: '{{count}} Widgets wurden übersprungen, weil ihre Datenquelle nicht zulässig ist.',
    DashAiSuggestion1: 'Erstelle ein Recruiting-Übersichtsdashboard',
    DashAiSuggestion2: 'Baue ein Dashboard aus meinen Daten-Pipelines',
    DashAiSuggestion3: 'Zeig mir die Performance meiner E-Mail-Kampagnen',
    DashAiSuggestion4: 'Erstelle ein Dashboard zur Workflow-Überwachung',
    DashAiTitle: 'Dashboard-KI',
    DashAiTooMany: 'Zu viele Anfragen. Bitte warte kurz und versuche es erneut.',
    DashAiTryAgain: 'Erneut versuchen',
    DashApply: 'Übernehmen',
    DashBack: 'Zurück',
    DashBrowseTemplates: 'Vorlagen ansehen',
    DashCancel: 'Abbrechen',
    DashChoosePipeline: 'Pipeline auswählen',
    DashChooseTemplate: 'Vorlage auswählen',
    DashCollection: 'Datenbestand',
    DashColor: 'Farbe',
    DashCompany: 'Firma',
    DashCompanyDashboards: 'Firmen-Dashboards',
    DashCreateWithAi: 'Mit KI erstellen',
    DashDataSource: 'Datenquelle',
    DashDateField: 'Datumsfeld (optional)',
    DashDateRange: 'Zeitraum',
    DashDelete: 'Löschen',
    DashDeleteHeader: 'Dashboard löschen',
    DashDeleteMessage: '„{{name}}“ löschen? Das kann nicht rückgängig gemacht werden.',
    DashEmptyGrid: 'Füge Widgets über den Plus-Button oben hinzu oder frag den KI-Assistenten.',
    DashEmptyText: 'Erstelle dein erstes Dashboard aus einer Vorlage oder lass es von der KI bauen.',
    DashEmptyTitle: 'Noch keine Dashboards',
    DashErrorFailed: 'Daten konnten nicht geladen werden.',
    DashErrorForbidden: 'Kein Zugriff auf diese Datenquelle.',
    DashErrorUnavailable: 'Live-Daten sind für diese Pipeline noch nicht verfügbar.',
    DashGroupBy: 'Gruppieren nach Feld',
    DashGroupByHint: 'z. B. status, source, type',
    DashIcon: 'Symbol',
    DashIconHint: 'z. B. people, briefcase, mail',
    DashInvalidWidget: 'Dieses Widget kann nicht gespeichert werden. Prüfe die Datenquelle.',
    DashItemsPath: 'Liste im Ergebnis (optional)',
    DashItemsPathHint: 'z. B. Candidate oder data.records',
    DashLimit: 'Maximale Anzahl',
    DashLoading: 'Dashboards werden geladen …',
    DashMyDashboards: 'Meine Dashboards',
    DashNamePlaceholder: 'Name des Dashboards',
    DashNewDashboard: 'Neues Dashboard',
    DashNoData: 'Keine Daten vorhanden',
    DashNoDescription: 'Keine Beschreibung',
    DashNoPipelines: 'Noch keine Inbound-Pipeline vorhanden. Lege eine auf der Seite Daten-Pipeline an.',
    DashPipeline: 'Pipeline',
    DashPrivate: 'Privat',
    DashRange1y: 'Letztes Jahr',
    DashRange24h: 'Letzte 24 Stunden',
    DashRange30d: 'Letzte 30 Tage',
    DashRange7d: 'Letzte 7 Tage',
    DashRange90d: 'Letzte 90 Tage',
    DashRangeAll: 'Gesamter Zeitraum',
    DashRefresh: 'Live-Daten aktualisieren',
    DashRefreshEvery: 'Aktualisieren alle (Sekunden)',
    DashRemove: 'Entfernen',
    DashResize: 'Größe ändern',
    DashSave: 'Speichern',
    DashSaveError: 'Dashboard konnte nicht gespeichert werden.',
    DashSettings: 'Einstellungen',
    DashSizeFull: 'Volle Breite',
    DashSizeLarge: 'Groß',
    DashSizeMedium: 'Mittel',
    DashSizeSmall: 'Klein',
    DashSourceCollection: 'Plattformdaten',
    DashSourcePipeline: 'Daten-Pipeline (live)',
    DashTemplates: 'Vorlagen',
    DashTitle: 'Titel',
    DashTotal: '{{count}} insgesamt',
    DashTotalLabel: 'Gesamt',
    DashType: 'Typ',
    DashUnknownPipeline: 'Unbekannte Pipeline',
    DashUpdatedAt: 'Aktualisiert {{time}}',
    DashValueField: 'Wertfeld',
    DashWidgetCount: '{{count}} Widgets',
    DashWidgetSettings: 'Widget-Einstellungen',
    McpScope_ars_use: 'Aufträge an MONA ARS',
    McpScopeInfo_candidates_read: 'Bewerber suchen und Profile lesen, ohne Kontaktdaten.',
    McpScopeInfo_candidates_contact: 'Zeigt zusätzlich E-Mail-Adressen und Telefonnummern.',
    McpScopeInfo_jobs_read: 'Offene Stellenangebote auflisten.',
    McpScopeInfo_matching_read: 'Passende Bewerber und Matching-Scores zu Stellen anzeigen.',
    McpScopeInfo_matching_write: 'Ein neues Matching zwischen Bewerbern und Stellen starten.',
    McpScopeInfo_knowledge_read: 'Dokumente und Ordner im Firmenwissen durchsuchen.',
    McpScopeInfo_ars_use: 'Der KI-Client gibt Aufgaben an MONA ARS weiter, z. B. Bewerber anrufen oder per SMS/E-Mail kontaktieren. ARS nutzt dafür eure Integrationen.',
    McpIntegrationen: 'Integrationen für MONA ARS',
    McpIntTelefon: 'Telefonnummer',
    McpIntTelefonInfo: 'Für Anrufe und SMS an Bewerber.',
    McpIntKalender: 'Kalender',
    McpIntKalenderInfo: 'Für Terminbuchungen mit Bewerbern.',
    McpIntEmail: 'E-Mail-Postfach',
    McpIntEmailInfo: 'Für eingehende Bewerbermails.',
    McpIntAts: 'ATS',
    McpIntAtsInfo: 'Bewerber und Stellen aus eurem ATS.',
    McpAktiv: 'Aktiv',
    McpInaktiv: 'Aus',
    McpDatenschutz: "Datenschutz",
    McpDatenschutzModus: "Datenschutz-Modus",
    McpDatenschutzInfo: "Claude, ChatGPT und Copilot sehen Bewerber nur als Pseudonym. Namen und Kontaktdaten bleiben in MONA und werden nur dir in der MONA-Karte angezeigt.",
    McpKopieren: 'Kopieren',
    McpKopiert: 'Kopiert',
    McpVerbinden: 'Client verbinden',
    McpSensibel: 'sensibel',
    McpNurAdmin: 'Nur der Account-Owner kann Änderungen vornehmen.',
    McpZuletztGenutzt: 'zuletzt genutzt',
    McpTrennenFrage: 'Verbindung trennen?',
    McpTrennenText: '{client} verliert sofort den Zugriff auf MONA. Für einen neuen Zugriff muss der Client neu verbunden werden.',
    McpAbbrechen: 'Abbrechen',
    McpFertig: 'Fertig',
    McpClaudeSchritt1: 'In Claude Einstellungen → Connectors öffnen.',
    McpClaudeSchritt2: '„Add custom connector“ wählen und die Server-URL einfügen.',
    McpClaudeSchritt3: '„Verbinden“ klicken und mit dem MONA-Login anmelden.',
    McpChatGPTSchritt1: 'In ChatGPT Einstellungen → Apps & Connectors öffnen.',
    McpChatGPTSchritt2: '„Create“ wählen, die Server-URL einfügen und als Authentifizierung OAuth wählen.',
    McpChatGPTSchritt3: 'Mit dem MONA-Login anmelden.',
    McpVerbunden: 'Verbunden',
    McpNichtVerbunden: 'Nicht verbunden',
    McpSensibelFrage: '„{scope}“ erlauben?',
    McpSensibelText: 'KI-Clients erhalten dieses Recht erst nach erneutem Verbinden. Erlaube es nur, wenn die Verarbeitung durch den KI-Client mit euren Datenschutzvorgaben vereinbar ist.',
    McpSensibelWarnungArs: 'ARS führt die Aufträge ohne zusätzliche Rückfrage aus. Teste zuerst mit einem Testkandidaten.',
    McpErlauben: 'Erlauben',
    McpFreigabeTitel: "MONA ARS-Aktion bestätigen",
    McpFreigabeText: "Dein KI-Client möchte, dass MONA ARS diese Aktion ausführt. Sie wird erst ausgeführt, wenn du zustimmst.",
    McpFreigabeJa: "Ja, ausführen",
    McpFreigabeNein: "Nein, ablehnen",
    McpFreigabeAusgefuehrt: "Bestätigt und ausgeführt. Du kannst zu deinem KI-Client zurückkehren.",
    McpFreigabeAbgelehnt: "Abgelehnt. Es wurde nichts ausgeführt.",
    McpFreigabeAbgelaufen: "Diese Anfrage ist abgelaufen oder wurde schon entschieden. Bitte im KI-Client neu anstoßen.",
    McpFreigabeFehlgeschlagen: "Bestätigt, aber MONA ARS konnte die Aktion nicht ausführen.",
    McpFreigabeNichtGefunden: "Anfrage nicht gefunden. Bist du mit dem richtigen MONA-Konto angemeldet?",
    McpFreigabeGueltigBis: "Gültig bis",
    McpTool_PHONE_TOOL: "Anruf",
    McpTool_SMS_TOOL: "SMS",
    McpTool_SMTP_TOOL: "E-Mail",
    McpScope_candidates_write: "Bewerber anlegen",
    McpScope_jobs_write: "Stellenangebote anlegen",
    McpScope_meetings_read: "Meetings, Kalender und Tagesbriefing",
    McpScopeInfo_candidates_write: "Neue Bewerber in MONA anlegen. Gespeichert wird erst nach deiner Freigabe in MONA.",
    McpScopeInfo_jobs_write: "Neue Stellenangebote als Entwurf anlegen. Gespeichert wird erst nach deiner Freigabe in MONA.",
    McpScopeInfo_meetings_read: "Notetaker-Meetings, Gesprächsprotokolle, Kalendertermine und das Tagesbriefing lesen. Namen von Teilnehmern werden im Datenschutz-Modus entfernt.",
    McpTool_CREATE_CANDIDATE: "Bewerber anlegen",
    McpTool_CREATE_JOB_OFFER: "Stellenangebot anlegen",
    McpFehlerNetzwerk: 'MCP-Server nicht erreichbar. Bitte später erneut versuchen.',
    McpFehlerAuth: 'Sitzung abgelaufen. Bitte neu anmelden.',
    McpFehlerRechte: 'Keine Berechtigung für diese Änderung.',
  };
}
